function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("cKcai", function(module, exports) {
    $parcel$export(module.exports, "WelcomeModalRenderer", ()=>$7e09df05ad2a703b$export$5d9e1395db999a45);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $co1wz;
    var $6BT89;
    var $aTWms;
    var $4sxjm;
    var $83g2V;
    const $7e09df05ad2a703b$var$WelcomeModalRendererInner = ()=>{
        const { isWelcomeModalActivated: isWelcomeModalActivated, finalWelcomeModalIsOpen: finalWelcomeModalIsOpen, handleCloseWelcomeModal: handleCloseWelcomeModal } = (0, (0, parcelRequire("6BT89")).useGlobalChangeboarding)();
        if (!isWelcomeModalActivated) return null;
        return (0, (0, parcelRequire("co1wz")).ff)('platform.show-optimal-tooling_brgom') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("83g2V")).Wizard), {
            isOpen: Boolean(finalWelcomeModalIsOpen),
            onClose: handleCloseWelcomeModal,
            defaultStep: (0, $8bd01cb292c29cb9$export$75f90732d1326d15)
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4sxjm")).Wizard), {
            isOpen: Boolean(finalWelcomeModalIsOpen),
            onClose: handleCloseWelcomeModal,
            defaultStep: (0, $fc9bc3f6523d8b85$export$75f90732d1326d15)
        });
    };
    const $7e09df05ad2a703b$export$5d9e1395db999a45 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "flag",
            teamName: "alexstrasza",
            packageName: "jiraEocChangeboarding",
            id: "jiraEocChangeboarding"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aTWms")).ChangeboardingProviders), null, (0, ($parcel$interopDefault($5uXOq))).createElement($7e09df05ad2a703b$var$WelcomeModalRendererInner, null)));
});
parcelRegister("6BT89", function(module, exports) {
    $parcel$export(module.exports, "useGlobalChangeboarding", ()=>$190423316351a626$export$e618620d6c810888);
    var $5uXOq = parcelRequire("5uXOq");
    var $8J6rn;
    var $co1wz;
    var $pa9q9;
    var $7jF6i;
    var $ldyPw;
    var $k9JTq;
    var $itmJb;
    var $cNd4s;
    var $9OXo1;
    var $ieDtd;
    var $3sQ5x;
    var $iXqE5;
    var $4iQaI;
    var $lLiTq;
    var $luBum;
    var $5fIfP;
    var $gPfYl;
    var $jbwqm;
    var $4UyCK;
    var $91lou;
    var $k9ufy;
    var $iA7nF;
    var $ez5GD;
    var $kkwlq;
    const $190423316351a626$var$initialState = {
        isTransitionHomeActivated: false,
        isTransitionHomeModalOpen: false,
        isWelcomeModalActivated: false,
        opsgenieBaseUrl: undefined
    };
    const $190423316351a626$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $190423316351a626$var$initialState,
        actions: {
            openTransitionHomeModalAction: ()=>({ setState: setState })=>{
                    setState({
                        isTransitionHomeModalOpen: true
                    });
                },
            closeTransitionHomeModal: ()=>({ setState: setState })=>{
                    setState({
                        isTransitionHomeModalOpen: false
                    });
                },
            activateTransitionHome: ()=>({ setState: setState })=>{
                    setState({
                        isTransitionHomeActivated: true
                    });
                },
            activateWelcomeModal: ()=>({ setState: setState })=>{
                    setState({
                        isWelcomeModalActivated: true
                    });
                },
            deactivateWelcomeModal: ()=>({ setState: setState })=>{
                    setState({
                        isWelcomeModalActivated: false
                    });
                }
        },
        name: 'global-changeboarding'
    });
    const $190423316351a626$export$2285bd7a7d8d4d7b = (0, (0, parcelRequire("3sQ5x")).createHook)($190423316351a626$var$Store);
    const $190423316351a626$export$e618620d6c810888 = ()=>{
        const [isTransitionHomeLoading, setIsTransitionHomeLoading] = (0, $5uXOq.useState)(false);
        const [{ isTransitionHomeActivated: isTransitionHomeActivated, isWelcomeModalActivated: isWelcomeModalActivated, isTransitionHomeModalOpen: isTransitionHomeModalOpen }, { openTransitionHomeModalAction: openTransitionHomeModalAction, closeTransitionHomeModal: closeTransitionHomeModal, activateTransitionHome: activateTransitionHome, activateWelcomeModal: activateWelcomeModal, deactivateWelcomeModal: deactivateWelcomeModal }] = $190423316351a626$export$2285bd7a7d8d4d7b();
        const [{ usersWithoutAdminRole: usersWithoutAdminRole, usersWithoutCustomRole: usersWithoutCustomRole, stakeholders: stakeholders }, { initialize: initializeUsersAndRoles }] = (0, (0, parcelRequire("k9ufy")).useUsersAndRolesStore)();
        const [{ counts: counts, syncedIntegrations: syncedIntegrations, discontinuedIntegrations: discontinuedIntegrations, deprecatedIntegrations: deprecatedIntegrations, incomingCallIntegrations: incomingCallIntegrations }, { initialize: initializeIntegrations }] = (0, (0, parcelRequire("5fIfP")).useIntegrationsStore)();
        const [{ notificationPolicies: notificationPolicies, groups: groups, heartbeats: heartbeats }, { initialize: initializeDeprecatedCounts }] = (0, (0, parcelRequire("lLiTq")).useDeprecatedCountsStore)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const [{ integrations: integrations, connections: connections }, { initialize: initializeChatTools, initializeForTeamAdmin: initializeChatToolsForTeamAdmin }] = (0, (0, parcelRequire("4iQaI")).useChatToolsStore)();
        const [{ incidentsCopyStatus: incidentsCopyStatus }, { initialize: initializeIncidentsCopyStatus }] = (0, (0, parcelRequire("luBum")).useIncidentsStore)();
        const [{ loading: transitioningStatusLoading, error: transitioningStatusError }, { initialize: initializeTransitioningStatus }] = (0, (0, parcelRequire("91lou")).useTransitioningStatus)();
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const hasJsmAboveStandard = !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, (0, parcelRequire("ldyPw")).FREE_EDITION) && appEditions.serviceDesk !== (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION);
        const [{ teams: teams }, { initialize: initializeTeams }] = (0, (0, parcelRequire("4UyCK")).useTeams)();
        const [{ loading: jnaAppStatusLoading, error: jnaAppStatusError }, { initialize: initializeJNAAppStatus }] = (0, (0, parcelRequire("gPfYl")).useJNAAppStatus)();
        const [{ teamAdminStatus: teamAdminStatus }, { initialize: initializeTeamAdminStatus }] = (0, (0, parcelRequire("jbwqm")).useTeamAdminStatus)();
        const [{ fetchStatus: fetchStatus, opsgenieBaseUrl: opsgenieBaseUrl }] = (0, (0, parcelRequire("7jF6i")).useOpsgenieBaseUrl)('eocChangeboarding');
        const isOpsgenieBaseUrlLoaded = fetchStatus === 'SUCCESS';
        const [ref] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, $2829d585c82ec887$export$203403aefc029c66));
        const [isWelcomeModalOpen, setIsWelcomeModalOpen] = (0, $5uXOq.useState)(true);
        const { data: data, error: error } = (0, (0, parcelRequire("ez5GD")).useOgConsolidationUserState)();
        const { isTransitioning: isTransitioning, loading: tenantLoading, error: tenantError } = (0, (0, parcelRequire("8J6rn")).useOgTenantInfo)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const isWelcomeModalDisplayedInitialValue = (0, $5uXOq.useRef)(data?.isWelcomeModalDisplayed);
        isWelcomeModalDisplayedInitialValue.current = isWelcomeModalDisplayedInitialValue.current ?? data?.isWelcomeModalDisplayed;
        const isTransitioningInitialValue = (0, $5uXOq.useRef)(isTransitioning);
        isTransitioningInitialValue.current = isTransitioningInitialValue.current ?? isTransitioning;
        const isAllWelcomeModalDataLoaded = isWelcomeModalOpen && !tenantLoading && !tenantError && data?.isWelcomeModalDisplayed !== undefined && isOpsgenieBaseUrlLoaded;
        const finalWelcomeModalIsOpen = isAllWelcomeModalDataLoaded && isTransitioningInitialValue.current && !isWelcomeModalDisplayedInitialValue.current;
        const handleCloseWelcomeModal = ()=>{
            setIsWelcomeModalOpen(false);
        };
        const initializeModalRequests = (0, $5uXOq.useCallback)(()=>{
            const minimalRequiredInitializations = [
                initializeTransitioningStatus(),
                initializeJNAAppStatus()
            ];
            const isUser = !isAdmin && !isSiteAdmin;
            if (isUser) {
                if ((0, (0, parcelRequire("co1wz")).ff)('platform.show-optimal-tooling_brgom')) {
                    const optimalRequiredInitializations = [
                        ...minimalRequiredInitializations,
                        initializeTeamAdminStatus(),
                        initializeChatToolsForTeamAdmin(),
                        initializeIntegrations()
                    ];
                    return Promise.allSettled(optimalRequiredInitializations).then((0, (0, parcelRequire("iA7nF")).multiplePromiseSettler));
                }
                return Promise.allSettled(minimalRequiredInitializations).then((0, (0, parcelRequire("iA7nF")).multiplePromiseSettler));
            }
            const minimalToolingRequests = [
                initializeChatTools(),
                initializeUsersAndRoles(hasJsmAboveStandard),
                ...minimalRequiredInitializations
            ];
            if ((0, (0, parcelRequire("co1wz")).ff)('platform.show-optimal-tooling_brgom')) {
                const optimalToolingRequests = [
                    ...minimalToolingRequests,
                    initializeTeams(),
                    initializeTeamAdminStatus(),
                    initializeIntegrations(),
                    initializeDeprecatedCounts(),
                    initializeIncidentsCopyStatus()
                ];
                return Promise.allSettled(optimalToolingRequests).then((0, (0, parcelRequire("iA7nF")).multiplePromiseSettler));
            }
            return Promise.allSettled(minimalToolingRequests).then((0, (0, parcelRequire("iA7nF")).multiplePromiseSettler));
        }, [
            initializeTransitioningStatus,
            initializeJNAAppStatus,
            isAdmin,
            isSiteAdmin,
            initializeChatTools,
            initializeUsersAndRoles,
            hasJsmAboveStandard,
            initializeTeamAdminStatus,
            initializeChatToolsForTeamAdmin,
            initializeTeams,
            initializeIntegrations,
            initializeDeprecatedCounts,
            initializeIncidentsCopyStatus
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (data && error) setIsWelcomeModalOpen(false);
        }, [
            error,
            data
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isAllWelcomeModalDataLoaded) return;
            if (usersWithoutAdminRole.error || usersWithoutCustomRole.error || integrations.error || connections.error || transitioningStatusError || jnaAppStatusError || (0, (0, parcelRequire("co1wz")).ff)('platform.show-optimal-tooling_brgom') && (teams.error || teamAdminStatus.error || counts.error || syncedIntegrations.error || discontinuedIntegrations.error || deprecatedIntegrations.error || incomingCallIntegrations.error || heartbeats.error || notificationPolicies.error || groups.error || incidentsCopyStatus.error || hasJsmAboveStandard && stakeholders.error)) {
                deactivateWelcomeModal();
                activateTransitionHome();
                return;
            }
            if (isWelcomeModalActivated || isTransitionHomeActivated || usersWithoutAdminRole.loading || usersWithoutCustomRole.loading || integrations.loading || connections.loading || transitioningStatusLoading || jnaAppStatusLoading || (0, (0, parcelRequire("co1wz")).ff)('platform.show-optimal-tooling_brgom') && (teams.loading || teamAdminStatus.loading || counts.loading || syncedIntegrations.loading || discontinuedIntegrations.loading || deprecatedIntegrations.loading || incomingCallIntegrations.loading || heartbeats.loading || notificationPolicies.loading || groups.loading || incidentsCopyStatus.loading || hasJsmAboveStandard && stakeholders.loading)) return;
            if (ref === (0, $2829d585c82ec887$export$8638ff77a0e20f0f) && finalWelcomeModalIsOpen) {
                initializeModalRequests().then(()=>{
                    activateWelcomeModal();
                });
                return;
            }
            if (isTransitioningInitialValue.current) {
                deactivateWelcomeModal();
                activateTransitionHome();
            }
        }, [
            activateTransitionHome,
            activateWelcomeModal,
            connections.loading,
            deactivateWelcomeModal,
            finalWelcomeModalIsOpen,
            initializeUsersAndRoles,
            integrations.loading,
            isAllWelcomeModalDataLoaded,
            isTransitionHomeActivated,
            isWelcomeModalActivated,
            ref,
            initializeModalRequests,
            usersWithoutAdminRole.loading,
            usersWithoutCustomRole.loading,
            counts.loading,
            syncedIntegrations.loading,
            discontinuedIntegrations.loading,
            deprecatedIntegrations.loading,
            incomingCallIntegrations.loading,
            transitioningStatusLoading,
            jnaAppStatusLoading,
            usersWithoutAdminRole.error,
            usersWithoutCustomRole.error,
            integrations.error,
            connections.error,
            transitioningStatusError,
            jnaAppStatusError,
            teams.error,
            teams.loading,
            teamAdminStatus.error,
            teamAdminStatus.loading,
            counts.error,
            syncedIntegrations.error,
            discontinuedIntegrations.error,
            deprecatedIntegrations.error,
            incomingCallIntegrations.error,
            heartbeats.error,
            notificationPolicies.error,
            groups.error,
            heartbeats.loading,
            notificationPolicies.loading,
            groups.loading,
            incidentsCopyStatus.loading,
            incidentsCopyStatus.error,
            stakeholders.error,
            stakeholders.loading,
            hasJsmAboveStandard
        ]);
        const openTransitionHomeModal = ()=>{
            setIsTransitionHomeLoading(true);
            return initializeModalRequests().then(()=>{
                activateTransitionHome();
                openTransitionHomeModalAction();
            }).catch(()=>{
                showFlag({
                    type: 'error',
                    title: (0, (0, parcelRequire("kkwlq")).default).errorTitleNonFinal,
                    description: (0, (0, parcelRequire("kkwlq")).default).errorDescriptionNonFinal,
                    actions: [
                        {
                            content: (0, (0, parcelRequire("kkwlq")).default).errorActionNonFinal,
                            onClick: openTransitionHomeModal
                        }
                    ]
                });
            }).finally(()=>{
                setIsTransitionHomeLoading(false);
            });
        };
        return {
            opsgenieBaseUrl: opsgenieBaseUrl,
            openTransitionHomeModal: openTransitionHomeModal,
            closeTransitionHomeModal: closeTransitionHomeModal,
            activateTransitionHome: activateTransitionHome,
            isTransitionHomeLoading: isTransitionHomeLoading,
            isTransitionHomeActivated: isTransitionHomeActivated,
            isWelcomeModalActivated: isWelcomeModalActivated,
            isTransitionHomeModalOpen: isTransitionHomeModalOpen,
            finalWelcomeModalIsOpen: finalWelcomeModalIsOpen,
            handleCloseWelcomeModal: handleCloseWelcomeModal,
            activateWelcomeModal: activateWelcomeModal
        };
    };
});
parcelRegister("7jF6i", function(module, exports) {
    $parcel$export(module.exports, "useOpsgenieBaseUrl", ()=>$1469318d2c6fedc9$export$60d311c8b1ba6c11);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $3sQ5x;
    var $iXqE5;
    var $8r6sb;
    const $1469318d2c6fedc9$export$d4c72bab9d6cc13a = {
        opsgenieBaseUrl: undefined,
        fetchStatus: undefined,
        error: undefined
    };
    const $1469318d2c6fedc9$var$opsgenieBaseUrlStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'opsgenieBaseUrl',
        initialState: $1469318d2c6fedc9$export$d4c72bab9d6cc13a,
        actions: (0, (0, parcelRequire("8r6sb")).actions)
    });
    const $1469318d2c6fedc9$export$7d5869fb9c3cabbd = (0, (0, parcelRequire("3sQ5x")).createHook)($1469318d2c6fedc9$var$opsgenieBaseUrlStore);
    const $1469318d2c6fedc9$export$60d311c8b1ba6c11 = (packageName)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [state, { fetchOpsgenieBaseUrl: fetchOpsgenieBaseUrl }] = $1469318d2c6fedc9$export$7d5869fb9c3cabbd();
        const fetchOgBaseUrl = (0, $5uXOq.useCallback)(()=>fetchOpsgenieBaseUrl(createAnalyticsEvent({}), packageName), [
            createAnalyticsEvent,
            fetchOpsgenieBaseUrl,
            packageName
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (state.opsgenieBaseUrl === undefined && !state.fetchStatus) fetchOgBaseUrl();
        }, [
            fetchOgBaseUrl,
            state.opsgenieBaseUrl,
            state.fetchStatus
        ]);
        return [
            state,
            {
                fetchOgBaseUrl: fetchOgBaseUrl
            }
        ];
    };
});
parcelRegister("8r6sb", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$018567380165a957$export$e324594224ef24da);
    var $66VJT;
    const $018567380165a957$export$e324594224ef24da = {
        fetchOpsgenieBaseUrl: (0, parcelRequire("66VJT")).fetchOpsgenieBaseUrl
    };
});
parcelRegister("66VJT", function(module, exports) {
    $parcel$export(module.exports, "fetchOpsgenieBaseUrl", ()=>$0533b309ea677099$export$14e903f188de435b);
    var $jcw0u;
    var $7f4tk;
    var $8zOmE;
    var $gaED7;
    const $0533b309ea677099$export$14e903f188de435b = (analyticsEvent, packageName)=>async ({ getState: getState, setState: setState })=>{
            const { opsgenieBaseUrl: currentOpsgenieBaseUrl, fetchStatus: currentFetchStatus } = getState();
            if (currentOpsgenieBaseUrl !== undefined || [
                (0, (0, parcelRequire("gaED7")).FETCH_STATUS).inProgress,
                (0, (0, parcelRequire("gaED7")).FETCH_STATUS).success
            ].includes(currentFetchStatus)) return;
            setState({
                fetchStatus: (0, (0, parcelRequire("gaED7")).FETCH_STATUS).inProgress,
                error: undefined
            });
            try {
                const { baseUrl: baseUrl } = await (0, (0, parcelRequire("7f4tk")).default)('/rest/internal/2/opsgenie-base-url');
                analyticsEvent && (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'fetchOgBaseUrl succeeded');
                setState({
                    fetchStatus: (0, (0, parcelRequire("gaED7")).FETCH_STATUS).success,
                    opsgenieBaseUrl: baseUrl
                });
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                    error: error,
                    id: 'fetchOgBaseUrl',
                    packageName: packageName,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    fetchStatus: (0, (0, parcelRequire("gaED7")).FETCH_STATUS).error,
                    error: error
                });
                throw error;
            }
        };
});
parcelRegister("gaED7", function(module, exports) {
    $parcel$export(module.exports, "FETCH_STATUS", ()=>$9abe9043030eba9b$export$7279934be2ca35bc);
    const $9abe9043030eba9b$export$7279934be2ca35bc = {
        inProgress: 'IN_PROGRESS_FETCH_STATUS',
        error: 'ERROR_FETCH_STATUS',
        success: 'SUCCESS'
    };
});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';
parcelRegister("4iQaI", function(module, exports) {
    $parcel$export(module.exports, "ChatToolsContainer", ()=>$f52f0ab06dfbc1fd$export$a144a4b0356ed94f);
    $parcel$export(module.exports, "useChatToolsActions", ()=>$f52f0ab06dfbc1fd$export$bc3c9253d84bc2bf);
    $parcel$export(module.exports, "useChatToolsStore", ()=>$f52f0ab06dfbc1fd$export$a1388873c4cbfadc);
    $parcel$export(module.exports, "useChatToolsConnections", ()=>$f52f0ab06dfbc1fd$export$74071b1e2400c285);
    $parcel$export(module.exports, "useChatToolsIntegrations", ()=>$f52f0ab06dfbc1fd$export$a985a8cf780397ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $eW6Xc;
    var $iXqE5;
    var $pa9q9;
    var $9OXo1;
    var $fjrC9;
    var $ahEC6;
    var $2H916;
    var $8NNKd;
    const $f52f0ab06dfbc1fd$export$d4c72bab9d6cc13a = {
        connections: (0, (0, parcelRequire("fjrC9")).emptyResource),
        integrations: (0, (0, parcelRequire("fjrC9")).emptyResource),
        loadingConnectionId: '',
        loadingIntegrationId: '',
        mstConnectionUrls: {}
    };
    const $f52f0ab06dfbc1fd$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $f52f0ab06dfbc1fd$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("8NNKd")).actions,
        name: 'chat-tools'
    });
    const $f52f0ab06dfbc1fd$export$a144a4b0356ed94f = (0, (0, parcelRequire("eW6Xc")).createContainer)($f52f0ab06dfbc1fd$var$Store, {
        Wrapper: (0, (0, parcelRequire("eW6Xc")).createDefaultEocWrapper)({
            useSyncContainerProps: ()=>{
                const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
                const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
                return {
                    cloudId: cloudId,
                    showFlag: showFlag
                };
            },
            useContainerHook: ()=>{
                const { initialize: initialize } = $f52f0ab06dfbc1fd$export$bc3c9253d84bc2bf();
                const { slackConnectHandler: slackConnectHandler, slackUserLevelAuthoriseHandler: slackUserLevelAuthoriseHandler } = (0, (0, parcelRequire("2H916")).useSlackConnection)({
                    onSuccess: initialize
                });
                const { mstConnectHandler: mstConnectHandler, adminAuthoriseHandler: adminAuthoriseHandler, mstUserLevelAuthoriseHandler: mstUserLevelAuthoriseHandler } = (0, (0, parcelRequire("ahEC6")).useMSTConnection)({
                    onSuccess: initialize
                });
                const connectHandler = (0, $5uXOq.useCallback)((event)=>{
                    if (!event.data || !event.data.event_id) return;
                    if (event.data.event_id === (0, (0, parcelRequire("fjrC9")).SLACK_CREATE_CONNECTION_EVENT_ID)) slackConnectHandler(event);
                    else if (event.data.event_id === (0, (0, parcelRequire("fjrC9")).MSTEAMS_CREATE_CONNECTION_EVENT_ID)) mstConnectHandler(event);
                    else if (event.data.event_id === (0, (0, parcelRequire("fjrC9")).ADMIN_CONSENT_REQUIRED_EVENT_ID)) adminAuthoriseHandler(event);
                    else if (event.data.event_id === (0, (0, parcelRequire("fjrC9")).MSTEAMS_USER_LEVEL_AUTH_EVENT_ID)) mstUserLevelAuthoriseHandler(event);
                    else if (event.data.event_id === (0, (0, parcelRequire("fjrC9")).SLACK_USER_LEVEL_AUTH_EVENT_ID)) slackUserLevelAuthoriseHandler(event);
                }, [
                    slackConnectHandler,
                    mstConnectHandler,
                    adminAuthoriseHandler,
                    mstUserLevelAuthoriseHandler,
                    slackUserLevelAuthoriseHandler
                ]);
                (0, $5uXOq.useEffect)(()=>{
                    window.addEventListener('message', connectHandler);
                    return ()=>{
                        window.removeEventListener('message', connectHandler);
                    };
                }, [
                    connectHandler
                ]);
            }
        })
    });
    const $f52f0ab06dfbc1fd$export$a1388873c4cbfadc = (0, (0, parcelRequire("3sQ5x")).createHook)($f52f0ab06dfbc1fd$var$Store);
    const $f52f0ab06dfbc1fd$export$bc3c9253d84bc2bf = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($f52f0ab06dfbc1fd$var$Store);
    const $f52f0ab06dfbc1fd$export$74071b1e2400c285 = (0, (0, parcelRequire("3sQ5x")).createHook)($f52f0ab06dfbc1fd$var$Store, {
        selector: (state)=>state.connections
    });
    const $f52f0ab06dfbc1fd$export$a985a8cf780397ec = (0, (0, parcelRequire("3sQ5x")).createHook)($f52f0ab06dfbc1fd$var$Store, {
        selector: (state)=>state.integrations
    });
});
parcelRegister("eW6Xc", function(module, exports) {
    $parcel$export(module.exports, "createDefaultEocWrapper", ()=>$479853350fd92f18$export$a9264953429b0df);
    $parcel$export(module.exports, "createContainer", ()=>$479853350fd92f18$export$26ae5ca175b4ec5a);
    var $5uXOq = parcelRequire("5uXOq");
    var $gg7kZ;
    function $479853350fd92f18$var$InnerElement({ children: children, useContainerHook: useContainerHook, containerProps: containerProps }) {
        useContainerHook?.(containerProps);
        return children;
    }
    function $479853350fd92f18$export$a9264953429b0df({ useSyncContainerProps: useSyncContainerProps, useContainerHook: useContainerHook }) {
        return ({ children: children })=>{
            if ((0, ($parcel$interopDefault($5uXOq))).isValidElement(children)) {
                const containerProps = useSyncContainerProps ? useSyncContainerProps(children.props) : {};
                return (0, ($parcel$interopDefault($5uXOq))).cloneElement(children, {
                    ...children.props,
                    ...containerProps
                }, useContainerHook ? (0, ($parcel$interopDefault($5uXOq))).createElement($479853350fd92f18$var$InnerElement, {
                    useContainerHook: useContainerHook,
                    containerProps: containerProps
                }, children.props.children) : children.props.children);
            }
            return null;
        };
    }
    const $479853350fd92f18$export$26ae5ca175b4ec5a = (store, options)=>{
        const OriginalContainer = (0, (0, parcelRequire("gg7kZ")).createContainer)(store, {
            ...options
        });
        const HOC = ({ ...props })=>{
            return options?.Wrapper ? (0, ($parcel$interopDefault($5uXOq))).createElement(options.Wrapper, props, (0, ($parcel$interopDefault($5uXOq))).createElement(OriginalContainer, props, props.children)) : (0, ($parcel$interopDefault($5uXOq))).createElement(OriginalContainer, props, props.children);
        };
        HOC.displayName = OriginalContainer.displayName + '-HOC';
        return HOC;
    };
});
parcelRegister("fjrC9", function(module, exports) {
    $parcel$export(module.exports, "emptyResource", ()=>$6e16d59f74f8efc1$export$6ed870441802d126);
    $parcel$export(module.exports, "SLACK_CREATE_CONNECTION_EVENT_ID", ()=>$6e16d59f74f8efc1$export$f499a35a9a662ad8);
    $parcel$export(module.exports, "SlackErrorCodes", ()=>$6e16d59f74f8efc1$export$ca77fcbf65183d7a);
    $parcel$export(module.exports, "MstErrorCodes", ()=>$6e16d59f74f8efc1$export$7dd2cc6fd63b5d49);
    $parcel$export(module.exports, "JIRA_SUPPORT_LINK", ()=>$6e16d59f74f8efc1$export$4dc85a478189d1be);
    $parcel$export(module.exports, "SLACK_IMAGE_URL", ()=>$6e16d59f74f8efc1$export$c5dc119cdbeed3dc);
    $parcel$export(module.exports, "MST_IMAGE_URL", ()=>$6e16d59f74f8efc1$export$31622a6434c822c0);
    $parcel$export(module.exports, "SLACK_TEXT", ()=>$6e16d59f74f8efc1$export$d982cc6618dbc0f3);
    $parcel$export(module.exports, "MST_TEXT", ()=>$6e16d59f74f8efc1$export$80d888715be28a18);
    $parcel$export(module.exports, "MSTEAMS_CREATE_CONNECTION_EVENT_ID", ()=>$6e16d59f74f8efc1$export$37e742a41eacef56);
    $parcel$export(module.exports, "ADMIN_CONSENT_REQUIRED_EVENT_ID", ()=>$6e16d59f74f8efc1$export$fe93b230923a5912);
    $parcel$export(module.exports, "SLACK_APP_TYPE", ()=>$6e16d59f74f8efc1$export$2dfb4588bf1292d9);
    $parcel$export(module.exports, "MST_APP_TYPE", ()=>$6e16d59f74f8efc1$export$6838a40356798ab0);
    $parcel$export(module.exports, "MSTEAMS_USER_LEVEL_AUTH_EVENT_ID", ()=>$6e16d59f74f8efc1$export$d1ee2159a22b5eeb);
    $parcel$export(module.exports, "SLACK_USER_LEVEL_AUTH_EVENT_ID", ()=>$6e16d59f74f8efc1$export$40d44b9e20d7bd23);
    $parcel$export(module.exports, "TRANSITION_HOME_BUTTON_SPOTLIGHT_NAME", ()=>$6e16d59f74f8efc1$export$36dc24398b969929);
    $parcel$export(module.exports, "HELP_PANEL_SPOTLIGHT_NAME", ()=>$6e16d59f74f8efc1$export$47504886f4581388);
    $parcel$export(module.exports, "UNLOCK_LINK", ()=>$6e16d59f74f8efc1$export$25520e270c8e452f);
    const $6e16d59f74f8efc1$export$6ed870441802d126 = {
        data: null,
        error: null,
        loading: false
    };
    const $6e16d59f74f8efc1$export$f499a35a9a662ad8 = 'slack_connection_creation_response';
    const $6e16d59f74f8efc1$export$ca77fcbf65183d7a = {
        AUTH_CODE_MISSING: 'auth_code_missing',
        CONNECTION_ALREADY_EXIST: 'connection_already_exist',
        CONNECTION_CREATION_FAILED: 'connection_creation_failed',
        FETCH_TOKEN_FAILED: 'failed_to_fetch_token',
        FORBIDDEN_TENANT: 'forbidden_tenant',
        INVALID_STATE: 'invalid_state',
        LINK_EXPIRED: 'link_expired',
        STATE_DECRYPTION_FAILED: 'state_decryption_failed',
        WORKSPACE_MISSMATCH: 'workspace_mismatch'
    };
    const $6e16d59f74f8efc1$export$7dd2cc6fd63b5d49 = {
        TENANT_CONFLICT: 'tenant_conflict',
        TENANT_MISMATCH: 'tenant_mismatch'
    };
    const $6e16d59f74f8efc1$export$4dc85a478189d1be = 'https://support.atlassian.com/contact/';
    const $6e16d59f74f8efc1$export$c5dc119cdbeed3dc = 'https://resources.opsgeni.us/resources/images/public/integration/logos/SlackApp.png';
    const $6e16d59f74f8efc1$export$31622a6434c822c0 = 'https://resources.opsgeni.us/resources/images/public/integration/logos/MSTeams.png';
    const $6e16d59f74f8efc1$export$d982cc6618dbc0f3 = 'Slack';
    const $6e16d59f74f8efc1$export$80d888715be28a18 = 'Microsoft Teams';
    const $6e16d59f74f8efc1$export$37e742a41eacef56 = 'microsoft_create_connection_response';
    const $6e16d59f74f8efc1$export$fe93b230923a5912 = 'microsoft_admin_permission_response';
    const $6e16d59f74f8efc1$export$2dfb4588bf1292d9 = 'jsm-it-service-desk';
    const $6e16d59f74f8efc1$export$6838a40356798ab0 = 'jsm-msteams-app';
    const $6e16d59f74f8efc1$export$d1ee2159a22b5eeb = 'microsoft_delegated_permission_response';
    const $6e16d59f74f8efc1$export$40d44b9e20d7bd23 = 'slack_user_auth_response';
    const $6e16d59f74f8efc1$export$36dc24398b969929 = 'eoc-changeboarding_transition_home_lozenge';
    const $6e16d59f74f8efc1$export$47504886f4581388 = 'help-spotlight';
    const $6e16d59f74f8efc1$export$25520e270c8e452f = '/jira/settings/products/ops/unlock';
});
parcelRegister("ahEC6", function(module, exports) {
    $parcel$export(module.exports, "useMSTConnection", ()=>$403306d7bad73714$export$4c0b85f07dbab21c);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $fjrC9;
    var $7EYmk;
    var $jTm7v;
    const $403306d7bad73714$export$4c0b85f07dbab21c = ({ onSuccess: onSuccess })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const mstConnectHandler = (0, $5uXOq.useCallback)((event)=>{
            (0, (0, parcelRequire("7EYmk")).chatOpsMessageHandler)({
                event: event,
                requiredEventId: (0, (0, parcelRequire("fjrC9")).MSTEAMS_CREATE_CONNECTION_EVENT_ID),
                onSuccessCallback: onSuccess,
                onFailedCallback: (errorCode)=>{
                    switch(errorCode){
                        case (0, (0, parcelRequire("fjrC9")).MstErrorCodes).TENANT_CONFLICT:
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("jTm7v")).default).tenantConflictErrorTitleNonFinal,
                                description: (0, (0, parcelRequire("jTm7v")).default).tenantConflictErrorDescriptionNonFinal
                            });
                            break;
                        case (0, (0, parcelRequire("fjrC9")).MstErrorCodes).TENANT_MISMATCH:
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("jTm7v")).default).tenantMissmatchErrorTitleNonFinal,
                                description: (0, (0, parcelRequire("jTm7v")).default).tenantMissmatchErrorDescriptionNonFinal
                            });
                            break;
                        default:
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("jTm7v")).default).teamsLoginErrorTitleNonFinal,
                                description: (0, (0, parcelRequire("jTm7v")).default).teamsLoginErrorTitleNonFinal,
                                actions: [
                                    {
                                        content: (0, (0, parcelRequire("jTm7v")).default).contactSupportBtnLabelNonFinal,
                                        href: (0, (0, parcelRequire("fjrC9")).JIRA_SUPPORT_LINK),
                                        target: '_blank'
                                    }
                                ]
                            });
                    }
                }
            });
        }, [
            onSuccess,
            showFlag
        ]);
        const adminAuthoriseHandler = (0, $5uXOq.useCallback)((event)=>{
            (0, (0, parcelRequire("7EYmk")).chatOpsMessageHandler)({
                event: event,
                requiredEventId: (0, (0, parcelRequire("fjrC9")).ADMIN_CONSENT_REQUIRED_EVENT_ID),
                onSuccessCallback: ()=>{
                    onSuccess();
                },
                onFailedCallback: ()=>{
                    showFlag({
                        type: 'error',
                        title: (0, (0, parcelRequire("jTm7v")).default).teamsLoginErrorTitleNonFinal,
                        description: (0, (0, parcelRequire("jTm7v")).default).teamsLoginErrorTitleNonFinal,
                        actions: [
                            {
                                content: (0, (0, parcelRequire("jTm7v")).default).contactSupportBtnLabelNonFinal,
                                href: (0, (0, parcelRequire("fjrC9")).JIRA_SUPPORT_LINK),
                                target: '_blank'
                            }
                        ]
                    });
                }
            });
        }, [
            onSuccess,
            showFlag
        ]);
        const mstUserLevelAuthoriseHandler = (0, $5uXOq.useCallback)((event)=>{
            (0, (0, parcelRequire("7EYmk")).chatOpsMessageHandler)({
                event: event,
                requiredEventId: (0, (0, parcelRequire("fjrC9")).MSTEAMS_USER_LEVEL_AUTH_EVENT_ID),
                onSuccessCallback: ()=>{
                    onSuccess();
                }
            });
        }, [
            onSuccess
        ]);
        return {
            mstConnectHandler: mstConnectHandler,
            adminAuthoriseHandler: adminAuthoriseHandler,
            mstUserLevelAuthoriseHandler: mstUserLevelAuthoriseHandler
        };
    };
});
parcelRegister("7EYmk", function(module, exports) {
    $parcel$export(module.exports, "chatOpsMessageHandler", ()=>$1e77709525354a34$export$6e5d249d884395f6);
    const $1e77709525354a34$export$9fb6e800e02bf3ea = [
        'https://api-private.stg.atlassian.com',
        'https://api-private.atlassian.com'
    ];
    const $1e77709525354a34$export$6e5d249d884395f6 = ({ event: event, onSuccessCallback: onSuccessCallback, onFailedCallback: onFailedCallback, requiredEventId: requiredEventId })=>{
        if (!$1e77709525354a34$export$9fb6e800e02bf3ea.includes(event.origin)) return;
        if (!event.data || !event.data.event_id || !event.data.data || event.data.event_id !== requiredEventId) return;
        const eventData = event.data;
        if (eventData?.data?.success === 'true') onSuccessCallback();
        else if (eventData?.data?.success === 'false') onFailedCallback?.(eventData.data.error);
    };
});
parcelRegister("jTm7v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9f7b988340afc65$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b9f7b988340afc65$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tenantConflictErrorTitleNonFinal: {
            "id": "eoc-changeboarding.services.use-mst-connection.tenant-conflict-error-title-non-final",
            "defaultMessage": "Couldn't connect your Microsoft tenant"
        },
        tenantConflictErrorDescriptionNonFinal: {
            "id": "eoc-changeboarding.services.use-mst-connection.tenant-conflict-error-description-non-final",
            "defaultMessage": "Your Microsoft tenant is connected to a different Jira Service Management site. Disconnect your tenant from the other site or connect a different Microsoft tenant to this Jira Service Management site."
        },
        teamsLoginErrorTitleNonFinal: {
            "id": "eoc-changeboarding.services.use-mst-connection.teams-login-error-title-non-final",
            "defaultMessage": "Couldn't sign in to your Microsoft account"
        },
        teamsLoginErrorDescriptionNonFinal: {
            "id": "eoc-changeboarding.services.use-mst-connection.teams-login-error-description-non-final",
            "defaultMessage": "Please try again or contact support for help."
        },
        contactSupportBtnLabelNonFinal: {
            "id": "eoc-changeboarding.services.use-mst-connection.contact-support-btn-label-non-final",
            "defaultMessage": "Contact support"
        },
        tenantMissmatchErrorTitleNonFinal: {
            "id": "eoc-changeboarding.services.use-mst-connection.tenant-missmatch-error-title-non-final",
            "defaultMessage": "You aren't a member of the Microsoft tenant"
        },
        tenantMissmatchErrorDescriptionNonFinal: {
            "id": "eoc-changeboarding.services.use-mst-connection.tenant-missmatch-error-description-non-final",
            "defaultMessage": "Looks like you aren't part of the Microsoft tenant you're trying to connect with Jira. Join the Microsoft tenant and try again."
        }
    });
});
parcelRegister("2H916", function(module, exports) {
    $parcel$export(module.exports, "useSlackConnection", ()=>$5e90d657d68ef7cf$export$3912d4b50c1e1942);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $fjrC9;
    var $7EYmk;
    var $hzun8;
    const $5e90d657d68ef7cf$export$3912d4b50c1e1942 = ({ onSuccess: onSuccess })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const slackConnectHandler = (0, $5uXOq.useCallback)((event)=>(0, (0, parcelRequire("7EYmk")).chatOpsMessageHandler)({
                event: event,
                requiredEventId: (0, (0, parcelRequire("fjrC9")).SLACK_CREATE_CONNECTION_EVENT_ID),
                onSuccessCallback: onSuccess,
                onFailedCallback: (errorCode)=>{
                    switch(errorCode){
                        case (0, (0, parcelRequire("fjrC9")).SlackErrorCodes).AUTH_CODE_MISSING:
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("hzun8")).default).slackNotConnectedTitleNonFinal,
                                description: (0, (0, parcelRequire("hzun8")).default).slackAuthoriseErrorDescriptionNonFinal
                            });
                            break;
                        case (0, (0, parcelRequire("fjrC9")).SlackErrorCodes).CONNECTION_ALREADY_EXIST:
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("hzun8")).default).slackNotConnectedTitleNonFinal,
                                description: (0, (0, parcelRequire("hzun8")).default).connectionAlreadyExistsDescriptionNonFinal
                            });
                            break;
                        case (0, (0, parcelRequire("fjrC9")).SlackErrorCodes).CONNECTION_CREATION_FAILED:
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("hzun8")).default).slackNotConnectedTitleNonFinal,
                                description: (0, (0, parcelRequire("hzun8")).default).connectionFailedDescriptionNonFinal,
                                actions: [
                                    {
                                        content: (0, (0, parcelRequire("hzun8")).default).slackSupportBtnLabelNonFinal,
                                        href: (0, (0, parcelRequire("fjrC9")).JIRA_SUPPORT_LINK),
                                        target: '_blank'
                                    }
                                ]
                            });
                            break;
                        case (0, (0, parcelRequire("fjrC9")).SlackErrorCodes).FETCH_TOKEN_FAILED:
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("hzun8")).default).slackNotConnectedTitleNonFinal,
                                description: (0, (0, parcelRequire("hzun8")).default).slackAuthoriseErrorDescriptionNonFinal
                            });
                            break;
                        case (0, (0, parcelRequire("fjrC9")).SlackErrorCodes).FORBIDDEN_TENANT:
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("hzun8")).default).somethingWentWrongTitleNonFinal,
                                description: (0, (0, parcelRequire("hzun8")).default).slackContactSupportDescriptionNonFinal,
                                actions: [
                                    {
                                        content: (0, (0, parcelRequire("hzun8")).default).slackSupportBtnLabelNonFinal,
                                        href: (0, (0, parcelRequire("fjrC9")).JIRA_SUPPORT_LINK),
                                        target: '_blank'
                                    }
                                ]
                            });
                            break;
                        case (0, (0, parcelRequire("fjrC9")).SlackErrorCodes).INVALID_STATE:
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("hzun8")).default).slackNotConnectedTitleNonFinal,
                                description: (0, (0, parcelRequire("hzun8")).default).slackConnectAgainDescriptionNonFinal
                            });
                            break;
                        case (0, (0, parcelRequire("fjrC9")).SlackErrorCodes).LINK_EXPIRED:
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("hzun8")).default).slackSessionExpiredTitleNonFinal,
                                description: (0, (0, parcelRequire("hzun8")).default).slackConnectAgainDescriptionNonFinal
                            });
                            break;
                        case (0, (0, parcelRequire("fjrC9")).SlackErrorCodes).STATE_DECRYPTION_FAILED:
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("hzun8")).default).slackNotConnectedTitleNonFinal,
                                description: (0, (0, parcelRequire("hzun8")).default).slackConnectAgainDescriptionNonFinal
                            });
                            break;
                        case (0, (0, parcelRequire("fjrC9")).SlackErrorCodes).WORKSPACE_MISSMATCH:
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("hzun8")).default).slackWorkspaceMismatchTitleNonFinal,
                                description: (0, (0, parcelRequire("hzun8")).default).slackWorkSpaceMissmatchDescriptionNonFinal
                            });
                            break;
                        default:
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("hzun8")).default).somethingWentWrongTitleNonFinal,
                                description: (0, (0, parcelRequire("hzun8")).default).slackContactSupportDescriptionNonFinal,
                                actions: [
                                    {
                                        content: (0, (0, parcelRequire("hzun8")).default).slackSupportBtnLabelNonFinal,
                                        href: (0, (0, parcelRequire("fjrC9")).JIRA_SUPPORT_LINK),
                                        target: '_blank'
                                    }
                                ]
                            });
                            break;
                    }
                }
            }), [
            onSuccess,
            showFlag
        ]);
        const slackUserLevelAuthoriseHandler = (0, $5uXOq.useCallback)((event)=>{
            (0, (0, parcelRequire("7EYmk")).chatOpsMessageHandler)({
                event: event,
                requiredEventId: (0, (0, parcelRequire("fjrC9")).SLACK_USER_LEVEL_AUTH_EVENT_ID),
                onSuccessCallback: ()=>{
                    onSuccess();
                }
            });
        }, [
            onSuccess
        ]);
        return {
            slackConnectHandler: slackConnectHandler,
            slackUserLevelAuthoriseHandler: slackUserLevelAuthoriseHandler
        };
    };
});
parcelRegister("hzun8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$549a18cabad62593$export$2e2bcd8739ae039);
    var $7VHMR;
    var $549a18cabad62593$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        getSlackConfigurationErrorTitleNonFinal: {
            "id": "eoc-changeboarding.services.use-slack-connection.get-slack-configuration-error-title-non-final",
            "defaultMessage": "We couldn't connect the workspace"
        },
        getSlackConfigurationErrorDescriptionNonFinal: {
            "id": "eoc-changeboarding.services.use-slack-connection.get-slack-configuration-error-description-non-final",
            "defaultMessage": "Wait a moment or refresh the page before trying again."
        },
        slackNotConnectedTitleNonFinal: {
            "id": "eoc-changeboarding.services.use-slack-connection.slack-not-connected-title-non-final",
            "defaultMessage": "Couldn't connect your Slack workspace"
        },
        slackAuthoriseErrorDescriptionNonFinal: {
            "id": "eoc-changeboarding.services.use-slack-connection.slack-authorise-error-description-non-final",
            "defaultMessage": "Your Slack workspace couldn't be authenticated. Please try again."
        },
        connectionAlreadyExistsDescriptionNonFinal: {
            "id": "eoc-changeboarding.services.use-slack-connection.connection-already-exists-description-non-final",
            "defaultMessage": "Your Slack workspace is already connected to a different Jira Service Management site. Disconnect your workspace from the other site and try again."
        },
        connectionFailedDescriptionNonFinal: {
            "id": "eoc-changeboarding.services.use-slack-connection.connection-failed-description-non-final",
            "defaultMessage": "Something went wrong. Please try connecting again or contact support for help."
        },
        slackSupportBtnLabelNonFinal: {
            "id": "eoc-changeboarding.services.use-slack-connection.slack-support-btn-label-non-final",
            "defaultMessage": "Contact support"
        },
        somethingWentWrongTitleNonFinal: {
            "id": "eoc-changeboarding.services.use-slack-connection.something-went-wrong-title-non-final",
            "defaultMessage": "Something went wrong"
        },
        slackContactSupportDescriptionNonFinal: {
            "id": "eoc-changeboarding.services.use-slack-connection.slack-contact-support-description-non-final",
            "defaultMessage": "Please try again or contact support for help."
        },
        slackConnectAgainDescriptionNonFinal: {
            "id": "eoc-changeboarding.services.use-slack-connection.slack-connect-again-description-non-final",
            "defaultMessage": "Please try connecting your workspace again."
        },
        slackSessionExpiredTitleNonFinal: {
            "id": "eoc-changeboarding.services.use-slack-connection.slack-session-expired-title-non-final",
            "defaultMessage": "Slack session expired"
        },
        slackWorkspaceMismatchTitleNonFinal: {
            "id": "eoc-changeboarding.services.use-slack-connection.slack-workspace-mismatch-title-non-final",
            "defaultMessage": "You aren't a member of the Slack workspace"
        },
        slackWorkSpaceMissmatchDescriptionNonFinal: {
            "id": "eoc-changeboarding.services.use-slack-connection.slack-work-space-missmatch-description-non-final",
            "defaultMessage": "Looks like you aren't part of the Slack workspace you're trying to connect with Jira. Join the Slack workspace and try again."
        }
    });
});
parcelRegister("8NNKd", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$dcbe28dff0425066$export$e324594224ef24da);
    var $fjrC9;
    var $1GqJn;
    var $iA7nF;
    var $jdPtr;
    var $eCYZp;
    const $dcbe28dff0425066$var$getChatToolsConnections = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
            const state = getState();
            setState({
                connections: {
                    data: state.connections.data,
                    error: null,
                    loading: true
                }
            });
            return (0, parcelRequire("jdPtr")).getConnections(cloudId).then((res)=>setState({
                    connections: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                })).catch((err)=>{
                setState({
                    connections: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $dcbe28dff0425066$var$authorizeSlackConnection = (chatSpaceId)=>({ setState: setState }, { cloudId: cloudId })=>{
            setState({
                loadingConnectionId: chatSpaceId
            });
            (0, parcelRequire("jdPtr")).getAuthorizeSlackConnectionUrl({
                chatSpaceId: chatSpaceId,
                cloudId: cloudId
            }).then((res)=>{
                window.open(res.data.url, '_blank');
            }).finally(()=>{
                setState({
                    loadingConnectionId: ''
                });
            });
        };
    const $dcbe28dff0425066$var$delegateMSTConnection = (chatSpaceId)=>({ setState: setState }, { cloudId: cloudId })=>{
            setState({
                loadingConnectionId: chatSpaceId
            });
            (0, parcelRequire("jdPtr")).getDelegateMSTConnectionUrl({
                chatSpaceId: chatSpaceId,
                cloudId: cloudId
            }).then((res)=>{
                window.open(res.data.url, '_blank');
            }).finally(()=>{
                setState({
                    loadingConnectionId: ''
                });
            });
        };
    const $dcbe28dff0425066$var$getAuthorizeMSTConnectionUrl = (chatSpaceId)=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
            const state = getState();
            if (state.mstConnectionUrls[chatSpaceId]) return Promise.resolve(state.mstConnectionUrls[chatSpaceId]);
            setState({
                loadingConnectionId: chatSpaceId
            });
            return (0, parcelRequire("jdPtr")).getaAuthorizeMSTConnectionUrl({
                chatSpaceId: chatSpaceId,
                cloudId: cloudId
            }).then((res)=>{
                state.mstConnectionUrls[chatSpaceId] = res.data.url;
                return res.data.url;
            }).finally(()=>{
                setState({
                    loadingConnectionId: ''
                });
            });
        };
    const $dcbe28dff0425066$var$authorizeMSTConnection = (chatSpaceId)=>({ dispatch: dispatch })=>{
            dispatch($dcbe28dff0425066$var$getAuthorizeMSTConnectionUrl(chatSpaceId)).then((url)=>{
                window.open(url, '_blank');
            });
        };
    const $dcbe28dff0425066$var$copyMSTAuthorizationLink = (chatSpaceId)=>({ dispatch: dispatch }, { showFlag: showFlag })=>{
            dispatch($dcbe28dff0425066$var$getAuthorizeMSTConnectionUrl(chatSpaceId)).then((url)=>{
                navigator.clipboard.writeText(url || '').then(()=>{
                    showFlag?.({
                        type: 'success',
                        title: (0, (0, parcelRequire("eCYZp")).default).copiedConfirmationTitleNonFinal,
                        description: (0, (0, parcelRequire("eCYZp")).default).copiedSuccessNonFinal
                    });
                }).catch(()=>{
                    showFlag?.({
                        type: 'error',
                        title: (0, (0, parcelRequire("eCYZp")).default).copiedConfirmationTitleNonFinal,
                        description: (0, (0, parcelRequire("eCYZp")).default).copiedFailedNonFinal
                    });
                });
            });
        };
    const $dcbe28dff0425066$var$getIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
            const state = getState();
            setState({
                integrations: {
                    data: state.integrations.data,
                    error: null,
                    loading: true
                }
            });
            return (0, parcelRequire("jdPtr")).getOgIntegrations(cloudId).then((res)=>setState({
                    integrations: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                })).catch((err)=>{
                setState({
                    integrations: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $dcbe28dff0425066$var$givePermissionToUser = (integration)=>({ setState: setState }, { cloudId: cloudId })=>{
            setState({
                loadingIntegrationId: integration.id
            });
            (0, parcelRequire("jdPtr")).getUserAuthorizationUrl({
                cloudId: cloudId,
                chatSpaceType: integration.chatSpaceType,
                chatSpaceId: integration.chatSpaceId
            }).then((res)=>{
                window.open(res.data.url, '_blank');
            }).finally(()=>{
                setState({
                    loadingIntegrationId: ''
                });
            });
        };
    const $dcbe28dff0425066$var$duplicateIntegration = (integration)=>({ setState: setState, dispatch: dispatch }, { cloudId: cloudId, showFlag: showFlag })=>{
            setState({
                loadingIntegrationId: integration.id
            });
            (0, parcelRequire("jdPtr")).duplicateIntegration({
                cloudId: cloudId,
                id: integration.id,
                channelId: integration.channelId,
                connectionId: integration.connectionId,
                msTeamsId: integration.msTeamsId
            }).then(()=>{
                dispatch($dcbe28dff0425066$var$getIntegrations());
            }).catch((error)=>{
                if (error.statusCode === 403) {
                    showFlag?.({
                        type: 'error',
                        title: (0, (0, parcelRequire("eCYZp")).default).duplicateNotPartOfChannelTitleNonFinal,
                        description: (0, (0, parcelRequire("eCYZp")).default).duplicateNotPartOfChannelDescriptionNonFinal
                    });
                    return;
                }
                showFlag?.({
                    type: 'error',
                    title: (0, (0, parcelRequire("eCYZp")).default).duplicateGenericErrorTitleNonFinal,
                    description: (0, (0, parcelRequire("eCYZp")).default).duplicateGenericErrorDescriptionNonFinal,
                    actions: [
                        {
                            content: (0, (0, parcelRequire("eCYZp")).default).contactSupportBtnLabelNonFinal,
                            href: (0, (0, parcelRequire("fjrC9")).JIRA_SUPPORT_LINK),
                            target: '_blank'
                        }
                    ]
                });
            }).finally(()=>{
                setState({
                    loadingIntegrationId: ''
                });
            });
        };
    const $dcbe28dff0425066$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
                dispatch($dcbe28dff0425066$var$getChatToolsConnections()),
                dispatch($dcbe28dff0425066$var$getIntegrations())
            ]).then((0, (0, parcelRequire("iA7nF")).multiplePromiseSettler));
    const $dcbe28dff0425066$var$initializeForTeamAdmin = ()=>({ dispatch: dispatch })=>Promise.allSettled([
                dispatch($dcbe28dff0425066$var$getIntegrations())
            ]).then((0, (0, parcelRequire("iA7nF")).multiplePromiseSettler));
    const $dcbe28dff0425066$export$e324594224ef24da = {
        getChatToolsConnections: $dcbe28dff0425066$var$getChatToolsConnections,
        authorizeSlackConnection: $dcbe28dff0425066$var$authorizeSlackConnection,
        delegateMSTConnection: $dcbe28dff0425066$var$delegateMSTConnection,
        authorizeMSTConnection: $dcbe28dff0425066$var$authorizeMSTConnection,
        copyMSTAuthorizationLink: $dcbe28dff0425066$var$copyMSTAuthorizationLink,
        getIntegrations: $dcbe28dff0425066$var$getIntegrations,
        givePermissionToUser: $dcbe28dff0425066$var$givePermissionToUser,
        duplicateIntegration: $dcbe28dff0425066$var$duplicateIntegration,
        initialize: $dcbe28dff0425066$var$initialize,
        initializeForTeamAdmin: $dcbe28dff0425066$var$initializeForTeamAdmin
    };
});
parcelRegister("1GqJn", function(module, exports) {
    $parcel$export(module.exports, "createErrorResponse", ()=>$513a18ba2d1aff95$export$d27409b579447857);
    $parcel$export(module.exports, "createDataResponse", ()=>$513a18ba2d1aff95$export$65a48814b87e4478);
    const $513a18ba2d1aff95$export$d27409b579447857 = (error)=>({
            data: null,
            error: error,
            loading: false
        });
    const $513a18ba2d1aff95$export$65a48814b87e4478 = (data)=>({
            data: data,
            error: null,
            loading: false
        });
});
parcelRegister("iA7nF", function(module, exports) {
    $parcel$export(module.exports, "multiplePromiseSettler", ()=>$585fda433702dced$export$be72b6e68f6d7c8f);
    const $585fda433702dced$export$be72b6e68f6d7c8f = (results)=>{
        if (results.length > 0) {
            const error = results.find((result)=>result.status === 'rejected');
            if (error) throw 'reason' in error ? error.reason : new Error('Unknown error occurred during fetch resource');
            return results;
        }
        return results;
    };
});
parcelRegister("jdPtr", function(module, exports) {
    $parcel$export(module.exports, "getConnections", ()=>$4fe7c11842caba6c$export$82b9f8f75cc709b4);
    $parcel$export(module.exports, "getAuthorizeSlackConnectionUrl", ()=>$4fe7c11842caba6c$export$2a70ab934b694f17);
    $parcel$export(module.exports, "getOgIntegrations", ()=>$4fe7c11842caba6c$export$f2efa3535e8bb631);
    $parcel$export(module.exports, "getDelegateMSTConnectionUrl", ()=>$4fe7c11842caba6c$export$58c33fd2c801ef0b);
    $parcel$export(module.exports, "getaAuthorizeMSTConnectionUrl", ()=>$4fe7c11842caba6c$export$d44eb3398b5db37);
    $parcel$export(module.exports, "getUserAuthorizationUrl", ()=>$4fe7c11842caba6c$export$4df1f26230bcb7c);
    $parcel$export(module.exports, "duplicateIntegration", ()=>$4fe7c11842caba6c$export$67ff1e867c2131aa);
    var $jcw0u;
    var $eusud;
    var $fjrC9;
    const $4fe7c11842caba6c$export$82b9f8f75cc709b4 = (cloudId)=>{
        const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/connections`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getConnectionsEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
    const $4fe7c11842caba6c$export$2a70ab934b694f17 = ({ chatSpaceId: chatSpaceId, cloudId: cloudId })=>{
        const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/slack/connection/create?chatSpaceId=${chatSpaceId}&appType=jsm-it-service-desk&container=transition`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'authorizeSlackConnection',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
    const $4fe7c11842caba6c$export$f2efa3535e8bb631 = (cloudId)=>{
        const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/integrations`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getOgIntegrationsEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
    const $4fe7c11842caba6c$export$58c33fd2c801ef0b = ({ chatSpaceId: chatSpaceId, cloudId: cloudId })=>{
        const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/msteams/delegated?chatSpaceId=${chatSpaceId}&appType=jsm-msteams-app&container=transition&createConnection=true`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'delegateMSTConnection',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
    const $4fe7c11842caba6c$export$d44eb3398b5db37 = ({ chatSpaceId: chatSpaceId, cloudId: cloudId })=>{
        const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/msteams/admin?chatSpaceId=${chatSpaceId}&appType=jsm-msteams-app&container=transition`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'authorizeMSTConnection',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
    const $4fe7c11842caba6c$export$4df1f26230bcb7c = ({ cloudId: cloudId, chatSpaceType: chatSpaceType, chatSpaceId: chatSpaceId })=>{
        const appType = chatSpaceType === 'slack' ? (0, (0, parcelRequire("fjrC9")).SLACK_APP_TYPE) : (0, (0, parcelRequire("fjrC9")).MST_APP_TYPE);
        const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorise/user?chatSpaceId=${chatSpaceId}&appType=${appType}&source=transition`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getUserAuthorizationUrl',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
    const $4fe7c11842caba6c$export$67ff1e867c2131aa = (body)=>{
        const { cloudId: cloudId, id: id, ...restOfBody } = body;
        const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/integration/duplicate/${id}`;
        return (0, (0, parcelRequire("eusud")).performPostRequest)(url, {
            body: JSON.stringify(restOfBody)
        }).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'duplicateIntegration',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
});
parcelRegister("eCYZp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$163319dc0b12cde7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $163319dc0b12cde7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copiedConfirmationTitleNonFinal: {
            "id": "eoc-changeboarding.services.store.chat-tools.actions.copied-confirmation-title-non-final",
            "defaultMessage": "Copied link"
        },
        copiedSuccessNonFinal: {
            "id": "eoc-changeboarding.services.store.chat-tools.actions.copied-success-non-final",
            "defaultMessage": "Share it with your Teams Administrator to ask for their authorization to give permission."
        },
        copiedFailedNonFinal: {
            "id": "eoc-changeboarding.services.store.chat-tools.actions.copied-failed-non-final",
            "defaultMessage": "Something went wrong, please try again? If you need help, contact support."
        },
        duplicateNotPartOfChannelTitleNonFinal: {
            "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-not-part-of-channel-title-non-final",
            "defaultMessage": "You aren't a member of the connected channel"
        },
        duplicateNotPartOfChannelDescriptionNonFinal: {
            "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-not-part-of-channel-description-non-final",
            "defaultMessage": "This integration is connected to a chat channel or conversation that you aren't a member of. Join the channel and try again."
        },
        duplicateGenericErrorTitleNonFinal: {
            "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-generic-error-title-non-final",
            "defaultMessage": "Couldn't copy your integration"
        },
        duplicateGenericErrorDescriptionNonFinal: {
            "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-generic-error-description-non-final",
            "defaultMessage": "Something went wrong while copying your integration to Jira. Try again in some time. If you still need help, contact support."
        },
        contactSupportBtnLabelNonFinal: {
            "id": "eoc-changeboarding.services.store.chat-tools.actions.contact-support-btn-label-non-final",
            "defaultMessage": "Contact support"
        }
    });
});
parcelRegister("lLiTq", function(module, exports) {
    $parcel$export(module.exports, "DeprecatedCountsContainer", ()=>$f93024f97192e9da$export$46cb9574b46bee08);
    $parcel$export(module.exports, "useDeprecatedCountsStore", ()=>$f93024f97192e9da$export$7ccc6df7e431e9d5);
    $parcel$export(module.exports, "useDeprecatedGroups", ()=>$f93024f97192e9da$export$a683813e834f13f1);
    $parcel$export(module.exports, "useDeprecatedNotificationPolicies", ()=>$f93024f97192e9da$export$6dd4db40d5822337);
    $parcel$export(module.exports, "useDeprecatedHeartbeats", ()=>$f93024f97192e9da$export$48cc63620d55f335);
    var $eW6Xc;
    var $3sQ5x;
    var $iXqE5;
    var $pa9q9;
    var $9OXo1;
    var $fjrC9;
    var $f2DMU;
    const $f93024f97192e9da$export$d4c72bab9d6cc13a = {
        groups: (0, (0, parcelRequire("fjrC9")).emptyResource),
        notificationPolicies: (0, (0, parcelRequire("fjrC9")).emptyResource),
        heartbeats: (0, (0, parcelRequire("fjrC9")).emptyResource)
    };
    const $f93024f97192e9da$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $f93024f97192e9da$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("f2DMU")).actions,
        name: 'deprecated-counts'
    });
    const $f93024f97192e9da$export$46cb9574b46bee08 = (0, (0, parcelRequire("eW6Xc")).createContainer)($f93024f97192e9da$var$Store, {
        Wrapper: (0, (0, parcelRequire("eW6Xc")).createDefaultEocWrapper)({
            useSyncContainerProps: ()=>{
                const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
                const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
                return {
                    cloudId: cloudId,
                    showFlag: showFlag
                };
            }
        })
    });
    const $f93024f97192e9da$export$7ccc6df7e431e9d5 = (0, (0, parcelRequire("3sQ5x")).createHook)($f93024f97192e9da$var$Store);
    const $f93024f97192e9da$export$a683813e834f13f1 = (0, (0, parcelRequire("3sQ5x")).createHook)($f93024f97192e9da$var$Store, {
        selector: (state)=>({
                groups: state.groups,
                hasDeprecatedGroups: (state.groups.data?.count || 0) > 0
            })
    });
    const $f93024f97192e9da$export$6dd4db40d5822337 = (0, (0, parcelRequire("3sQ5x")).createHook)($f93024f97192e9da$var$Store, {
        selector: (state)=>({
                notificationPolicies: state.notificationPolicies,
                hasDeprecatedNotificationPolicies: (state.notificationPolicies.data?.count || 0) > 0
            })
    });
    const $f93024f97192e9da$export$48cc63620d55f335 = (0, (0, parcelRequire("3sQ5x")).createHook)($f93024f97192e9da$var$Store, {
        selector: (state)=>({
                heartbeats: state.heartbeats,
                hasDeprecatedGlobalHeartbeats: (state.heartbeats.data?.globalHeartbeatCount || 0) > 0,
                hasDeprecatedTotalHeartbeats: (state.heartbeats.data?.totalHeartbeatCount || 0) > 0,
                isExceedHeartbeatLimit: (state.heartbeats.data?.totalHeartbeatCount || 0) > 2000
            })
    });
});
parcelRegister("f2DMU", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$e67700634072e137$export$e324594224ef24da);
    var $1GqJn;
    var $iA7nF;
    var $jMK2J;
    const $e67700634072e137$var$getDeprecatedGroupsCount = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
            const state = getState();
            setState({
                groups: {
                    data: state.groups.data,
                    error: null,
                    loading: true
                }
            });
            return (0, parcelRequire("jMK2J")).getDeprecatedGroupsCount(cloudId).then((res)=>setState({
                    groups: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                })).catch((err)=>{
                setState({
                    groups: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $e67700634072e137$var$getDeprecatedHeartbeatsCount = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
            const state = getState();
            setState({
                heartbeats: {
                    data: state.heartbeats.data,
                    error: null,
                    loading: true
                }
            });
            return (0, parcelRequire("jMK2J")).getDeprecatedHeartbeatsCount(cloudId).then((res)=>setState({
                    heartbeats: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                })).catch((err)=>{
                setState({
                    heartbeats: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $e67700634072e137$var$getDeprecatedNotificationPoliciesCount = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
            const state = getState();
            setState({
                notificationPolicies: {
                    data: state.notificationPolicies.data,
                    error: null,
                    loading: true
                }
            });
            return (0, parcelRequire("jMK2J")).getDeprecatedNotificationPoliciesCount(cloudId).then((res)=>setState({
                    notificationPolicies: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                })).catch((err)=>{
                setState({
                    notificationPolicies: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $e67700634072e137$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
                dispatch($e67700634072e137$var$getDeprecatedGroupsCount()),
                dispatch($e67700634072e137$var$getDeprecatedHeartbeatsCount()),
                dispatch($e67700634072e137$var$getDeprecatedNotificationPoliciesCount())
            ]).then((0, (0, parcelRequire("iA7nF")).multiplePromiseSettler));
    const $e67700634072e137$export$e324594224ef24da = {
        getDeprecatedGroupsCount: $e67700634072e137$var$getDeprecatedGroupsCount,
        getDeprecatedHeartbeatsCount: $e67700634072e137$var$getDeprecatedHeartbeatsCount,
        getDeprecatedNotificationPoliciesCount: $e67700634072e137$var$getDeprecatedNotificationPoliciesCount,
        initialize: $e67700634072e137$var$initialize
    };
});
parcelRegister("jMK2J", function(module, exports) {
    $parcel$export(module.exports, "getDeprecatedGroupsCount", ()=>$dd71ffe8646c0283$export$67b822a517f03dfe);
    $parcel$export(module.exports, "getDeprecatedNotificationPoliciesCount", ()=>$dd71ffe8646c0283$export$55e3f0e3955ec140);
    $parcel$export(module.exports, "getDeprecatedHeartbeatsCount", ()=>$dd71ffe8646c0283$export$241c0dafce985f59);
    var $jcw0u;
    var $eusud;
    const $dd71ffe8646c0283$export$67b822a517f03dfe = (cloudId)=>{
        const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/changeboarding/groups`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getDeprecatedGroupsCountEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
    const $dd71ffe8646c0283$export$55e3f0e3955ec140 = (cloudId)=>{
        const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/changeboarding/policies`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getDeprecatedNotificationPoliciesCountEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
    const $dd71ffe8646c0283$export$241c0dafce985f59 = (cloudId)=>{
        const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/heartbeats/changeboarding`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getDeprecatedHeartbeatsCountEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
});
parcelRegister("luBum", function(module, exports) {
    $parcel$export(module.exports, "IncidentsContainer", ()=>$afaad1410f35f665$export$f504e9eea1c23a86);
    $parcel$export(module.exports, "useIncidentsStore", ()=>$afaad1410f35f665$export$7dfe7cf41f5c2f79);
    $parcel$export(module.exports, "useIncidents", ()=>$afaad1410f35f665$export$23e9cad190e56aee);
    var $3sQ5x;
    var $eW6Xc;
    var $iXqE5;
    var $9OXo1;
    var $fjrC9;
    var $5axFq;
    const $afaad1410f35f665$export$d4c72bab9d6cc13a = {
        incidentsCopyStatus: (0, (0, parcelRequire("fjrC9")).emptyResource)
    };
    const $afaad1410f35f665$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $afaad1410f35f665$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("5axFq")).actions,
        name: 'incidents'
    });
    const $afaad1410f35f665$export$f504e9eea1c23a86 = (0, (0, parcelRequire("eW6Xc")).createContainer)($afaad1410f35f665$var$Store, {
        Wrapper: (0, (0, parcelRequire("eW6Xc")).createDefaultEocWrapper)({
            useSyncContainerProps: ()=>{
                const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
                return {
                    cloudId: cloudId
                };
            }
        })
    });
    const $afaad1410f35f665$export$7dfe7cf41f5c2f79 = (0, (0, parcelRequire("3sQ5x")).createHook)($afaad1410f35f665$var$Store);
    const $afaad1410f35f665$export$43131cb4b87347a9 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($afaad1410f35f665$var$Store);
    const $afaad1410f35f665$export$23e9cad190e56aee = (0, (0, parcelRequire("3sQ5x")).createHook)($afaad1410f35f665$var$Store, {
        selector: (state)=>{
            const { incidentsCopyStatus: incidentsCopyStatus } = state;
            const projectKey = incidentsCopyStatus.data?.payload?.projectKey;
            const status = incidentsCopyStatus.data?.status;
            const errorLength = incidentsCopyStatus.data?.error?.length ?? 0;
            const hasCopyOperationError = errorLength > 0 || status === 'ERROR';
            const isCopied = status === 'SUCCESS' && !!projectKey && errorLength === 0;
            const isCopying = status === 'IN_PROGRESS';
            const canMigrateAgain = incidentsCopyStatus.data?.canMigrateAgain;
            const isEligibleForCopy = (status === 'SUCCESS' || hasCopyOperationError) && canMigrateAgain || status === 'NOT_STARTED';
            const shouldDisplaySuccessBanner = isCopied && canMigrateAgain === false;
            return {
                projectKey: projectKey,
                hasCopyOperationError: hasCopyOperationError,
                isCopied: isCopied,
                isCopying: isCopying,
                isEligibleForCopy: isEligibleForCopy,
                shouldDisplaySuccessBanner: shouldDisplaySuccessBanner
            };
        }
    });
});
parcelRegister("5axFq", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$365580d5c0599be0$export$e324594224ef24da);
    var $1GqJn;
    var $iA7nF;
    var $ls6ny;
    const $365580d5c0599be0$var$getIncidentsCopyStatus = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
            const state = getState();
            setState({
                incidentsCopyStatus: {
                    ...state.incidentsCopyStatus,
                    loading: true
                }
            });
            return (0, parcelRequire("ls6ny")).getIncidentsCopyStatus(cloudId).then((res)=>setState({
                    incidentsCopyStatus: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                })).catch((err)=>{
                setState({
                    incidentsCopyStatus: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $365580d5c0599be0$var$copyIncidents = ()=>({ dispatch: dispatch }, { cloudId: cloudId })=>(0, parcelRequire("ls6ny")).copyIncidents(cloudId).then(()=>dispatch($365580d5c0599be0$var$getIncidentsCopyStatus()));
    const $365580d5c0599be0$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
                dispatch($365580d5c0599be0$var$getIncidentsCopyStatus())
            ]).then((0, (0, parcelRequire("iA7nF")).multiplePromiseSettler));
    const $365580d5c0599be0$export$e324594224ef24da = {
        getIncidentsCopyStatus: $365580d5c0599be0$var$getIncidentsCopyStatus,
        copyIncidents: $365580d5c0599be0$var$copyIncidents,
        initialize: $365580d5c0599be0$var$initialize
    };
});
parcelRegister("ls6ny", function(module, exports) {
    $parcel$export(module.exports, "getIncidentsCopyStatus", ()=>$1aa4ab063840354a$export$c027992a439e850d);
    $parcel$export(module.exports, "copyIncidents", ()=>$1aa4ab063840354a$export$583821603355a6e2);
    var $jcw0u;
    var $eusud;
    const $1aa4ab063840354a$export$c027992a439e850d = (cloudId)=>{
        const url = `/gateway/api/jsd/escalator/${cloudId}/api/im-tooling/status`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getIncidentCopyStatusEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
    const $1aa4ab063840354a$export$583821603355a6e2 = (cloudId)=>{
        const url = `/gateway/api/jsd/escalator/${cloudId}/api/im-tooling/start`;
        return (0, (0, parcelRequire("eusud")).performPostRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'copyIncidentsEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
});
parcelRegister("5fIfP", function(module, exports) {
    $parcel$export(module.exports, "IntegrationsContainer", ()=>$422ec97ec7702e9c$export$a82408dc976aed12);
    $parcel$export(module.exports, "useIntegrationsStore", ()=>$422ec97ec7702e9c$export$20dfa6771a354e6b);
    $parcel$export(module.exports, "useIntegrationCounts", ()=>$422ec97ec7702e9c$export$d42a7d921bccf5ad);
    $parcel$export(module.exports, "useSyncedIntegrations", ()=>$422ec97ec7702e9c$export$f79da416c7d67657);
    $parcel$export(module.exports, "useDiscontinuedIntegrations", ()=>$422ec97ec7702e9c$export$7145e9baa0c24277);
    $parcel$export(module.exports, "useDeprecatedIntegrations", ()=>$422ec97ec7702e9c$export$1525890f71cafb3f);
    $parcel$export(module.exports, "useIncomingCallIntegrations", ()=>$422ec97ec7702e9c$export$f3c44b9fdca261f2);
    var $3sQ5x;
    var $eW6Xc;
    var $iXqE5;
    var $pa9q9;
    var $9OXo1;
    var $fjrC9;
    var $a1OoE;
    const $422ec97ec7702e9c$export$d4c72bab9d6cc13a = {
        counts: (0, (0, parcelRequire("fjrC9")).emptyResource),
        syncedIntegrations: (0, (0, parcelRequire("fjrC9")).emptyResource),
        discontinuedIntegrations: (0, (0, parcelRequire("fjrC9")).emptyResource),
        deprecatedIntegrations: (0, (0, parcelRequire("fjrC9")).emptyResource),
        incomingCallIntegrations: (0, (0, parcelRequire("fjrC9")).emptyResource)
    };
    const $422ec97ec7702e9c$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $422ec97ec7702e9c$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("a1OoE")).actions,
        name: 'integrations'
    });
    const $422ec97ec7702e9c$export$a82408dc976aed12 = (0, (0, parcelRequire("eW6Xc")).createContainer)($422ec97ec7702e9c$var$Store, {
        Wrapper: (0, (0, parcelRequire("eW6Xc")).createDefaultEocWrapper)({
            useSyncContainerProps: ()=>{
                const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
                const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
                return {
                    cloudId: cloudId,
                    showFlag: showFlag
                };
            }
        })
    });
    const $422ec97ec7702e9c$export$20dfa6771a354e6b = (0, (0, parcelRequire("3sQ5x")).createHook)($422ec97ec7702e9c$var$Store);
    const $422ec97ec7702e9c$export$eb083cb7fb078478 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($422ec97ec7702e9c$var$Store);
    const $422ec97ec7702e9c$export$d42a7d921bccf5ad = (0, (0, parcelRequire("3sQ5x")).createHook)($422ec97ec7702e9c$var$Store, {
        selector: (state)=>({
                counts: state.counts,
                hasIntegrations: (state.counts.data?.totalCount || 0) > 0
            })
    });
    const $422ec97ec7702e9c$export$f79da416c7d67657 = (0, (0, parcelRequire("3sQ5x")).createHook)($422ec97ec7702e9c$var$Store, {
        selector: (state)=>({
                syncedIntegrations: state.syncedIntegrations,
                hasSyncedIntegration: (state.syncedIntegrations.data?.count || 0) > 0
            })
    });
    const $422ec97ec7702e9c$export$7145e9baa0c24277 = (0, (0, parcelRequire("3sQ5x")).createHook)($422ec97ec7702e9c$var$Store, {
        selector: (state)=>({
                discontinuedIntegrations: state.discontinuedIntegrations,
                hasDiscontinuedIntegration: (state.discontinuedIntegrations.data?.count || 0) > 0
            })
    });
    const $422ec97ec7702e9c$export$1525890f71cafb3f = (0, (0, parcelRequire("3sQ5x")).createHook)($422ec97ec7702e9c$var$Store, {
        selector: (state)=>({
                deprecatedIntegrations: state.deprecatedIntegrations,
                hasDeprecatedIntegration: (state.deprecatedIntegrations.data?.count || 0) > 0
            })
    });
    const $422ec97ec7702e9c$export$f3c44b9fdca261f2 = (0, (0, parcelRequire("3sQ5x")).createHook)($422ec97ec7702e9c$var$Store, {
        selector: (state)=>({
                incomingCallIntegrations: state.incomingCallIntegrations,
                hasIncomingCallIntegration: (state.incomingCallIntegrations.data?.count || 0) > 0
            })
    });
});
parcelRegister("a1OoE", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$280bbd03a95fd3a3$export$e324594224ef24da);
    var $1GqJn;
    var $iA7nF;
    var $axqwP;
    const $280bbd03a95fd3a3$var$getIntegrationCounts = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
            const state = getState();
            setState({
                counts: {
                    ...state.counts,
                    loading: true
                }
            });
            return (0, parcelRequire("axqwP")).getIntegrationCounts(cloudId).then((res)=>setState({
                    counts: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                })).catch((err)=>{
                setState({
                    counts: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $280bbd03a95fd3a3$var$getSyncedIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
            const state = getState();
            setState({
                syncedIntegrations: {
                    ...state.syncedIntegrations,
                    loading: true
                }
            });
            return (0, parcelRequire("axqwP")).getSyncedIntegrations(cloudId).then((res)=>setState({
                    syncedIntegrations: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                })).catch((err)=>{
                setState({
                    syncedIntegrations: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $280bbd03a95fd3a3$var$getDiscontinuedIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
            const state = getState();
            setState({
                discontinuedIntegrations: {
                    ...state.discontinuedIntegrations,
                    loading: true
                }
            });
            return (0, parcelRequire("axqwP")).getDiscontinuedIntegrations(cloudId).then((res)=>setState({
                    discontinuedIntegrations: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                })).catch((err)=>{
                setState({
                    discontinuedIntegrations: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $280bbd03a95fd3a3$var$getDeprecatedIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
            const state = getState();
            setState({
                deprecatedIntegrations: {
                    ...state.deprecatedIntegrations,
                    loading: true
                }
            });
            return (0, parcelRequire("axqwP")).getDeprecatedIntegrations(cloudId).then((res)=>setState({
                    deprecatedIntegrations: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                })).catch((err)=>{
                setState({
                    deprecatedIntegrations: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $280bbd03a95fd3a3$var$getIncomingCallIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
            const state = getState();
            setState({
                incomingCallIntegrations: {
                    ...state.incomingCallIntegrations,
                    loading: true
                }
            });
            return (0, parcelRequire("axqwP")).getIncomingCallIntegrations(cloudId).then((res)=>setState({
                    incomingCallIntegrations: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                })).catch((err)=>{
                setState({
                    incomingCallIntegrations: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $280bbd03a95fd3a3$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
                dispatch($280bbd03a95fd3a3$var$getIntegrationCounts()),
                dispatch($280bbd03a95fd3a3$var$getSyncedIntegrations()),
                dispatch($280bbd03a95fd3a3$var$getDeprecatedIntegrations()),
                dispatch($280bbd03a95fd3a3$var$getDiscontinuedIntegrations()),
                dispatch($280bbd03a95fd3a3$var$getIncomingCallIntegrations())
            ]).then((0, (0, parcelRequire("iA7nF")).multiplePromiseSettler));
    const $280bbd03a95fd3a3$export$e324594224ef24da = {
        initialize: $280bbd03a95fd3a3$var$initialize
    };
});
parcelRegister("axqwP", function(module, exports) {
    $parcel$export(module.exports, "getIntegrationCounts", ()=>$4a633d532959c7d6$export$77778a0ed0c6fa6e);
    $parcel$export(module.exports, "getSyncedIntegrations", ()=>$4a633d532959c7d6$export$832e854d2572cc2f);
    $parcel$export(module.exports, "getDiscontinuedIntegrations", ()=>$4a633d532959c7d6$export$fd29039ae6c0f299);
    $parcel$export(module.exports, "getDeprecatedIntegrations", ()=>$4a633d532959c7d6$export$37a9d02f12612e7c);
    $parcel$export(module.exports, "getIncomingCallIntegrations", ()=>$4a633d532959c7d6$export$269a90dd370437b8);
    var $jcw0u;
    var $eusud;
    const $4a633d532959c7d6$export$77778a0ed0c6fa6e = (cloudId)=>{
        const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/count`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getIntegrationCountsEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
    const $4a633d532959c7d6$export$832e854d2572cc2f = (cloudId)=>{
        const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/sync`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getSyncedIntegrationsEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
    const $4a633d532959c7d6$export$fd29039ae6c0f299 = (cloudId)=>{
        const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/discontinued`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getDiscontinuedIntegrationsEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
    const $4a633d532959c7d6$export$37a9d02f12612e7c = (cloudId)=>{
        const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/deprecated`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getDeprecatedIntegrationsEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
    const $4a633d532959c7d6$export$269a90dd370437b8 = (cloudId)=>{
        const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/incoming-call`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getIncomingCallIntegrationsEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
});
parcelRegister("gPfYl", function(module, exports) {
    $parcel$export(module.exports, "JNAAppStatusContainer", ()=>$168808b2276040e7$export$ea2d0ab423a74686);
    $parcel$export(module.exports, "useJNAAppStatus", ()=>$168808b2276040e7$export$5d602c3d2ce99e4d);
    var $eW6Xc;
    var $3sQ5x;
    var $iXqE5;
    var $pa9q9;
    var $9OXo1;
    var $2osG0;
    const $168808b2276040e7$export$d4c72bab9d6cc13a = {
        loading: false,
        error: null
    };
    const $168808b2276040e7$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $168808b2276040e7$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("2osG0")).actions,
        name: 'jna-app-status'
    });
    const $168808b2276040e7$export$ea2d0ab423a74686 = (0, (0, parcelRequire("eW6Xc")).createContainer)($168808b2276040e7$var$Store, {
        Wrapper: (0, (0, parcelRequire("eW6Xc")).createDefaultEocWrapper)({
            useSyncContainerProps: ()=>{
                const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
                const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
                return {
                    cloudId: cloudId,
                    showFlag: showFlag
                };
            }
        })
    });
    const $168808b2276040e7$export$5d602c3d2ce99e4d = (0, (0, parcelRequire("3sQ5x")).createHook)($168808b2276040e7$var$Store);
});
parcelRegister("2osG0", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$b5d1450971772bb8$export$e324594224ef24da);
    var $6QXBz;
    const $b5d1450971772bb8$var$getData = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
            const { loading: loading } = getState();
            if (loading) return;
            setState({
                loading: true
            });
            return (0, (0, parcelRequire("6QXBz")).listJNAAppsEndpoint)(cloudId).then(({ values: values })=>({
                    values: values
                })).then(setState).catch((error)=>{
                setState({
                    error: error
                });
                throw error;
            }).finally(()=>{
                setState({
                    loading: false
                });
            });
        };
    const $b5d1450971772bb8$var$initialize = $b5d1450971772bb8$var$getData;
    const $b5d1450971772bb8$export$e324594224ef24da = {
        initialize: $b5d1450971772bb8$var$initialize
    };
});
parcelRegister("6QXBz", function(module, exports) {
    $parcel$export(module.exports, "listJNAAppsEndpoint", ()=>$585f8a9ffc29380f$export$89c8c108742e6641);
    var $jcw0u;
    var $eusud;
    const $585f8a9ffc29380f$export$89c8c108742e6641 = (cloudId)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/notification/devices`).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'listJNAAppsEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
});
parcelRegister("jbwqm", function(module, exports) {
    $parcel$export(module.exports, "TeamAdminStatusContainer", ()=>$d393a57ef66828a1$export$1c30a658c5f5a989);
    $parcel$export(module.exports, "useTeamAdminStatus", ()=>$d393a57ef66828a1$export$8e6e1b9570cbbe18);
    $parcel$export(module.exports, "useIsTeamAdmin", ()=>$d393a57ef66828a1$export$1e85709af32c9e77);
    var $eW6Xc;
    var $3sQ5x;
    var $iXqE5;
    var $9OXo1;
    var $fjrC9;
    var $u313a;
    const $d393a57ef66828a1$export$d4c72bab9d6cc13a = {
        teamAdminStatus: (0, (0, parcelRequire("fjrC9")).emptyResource)
    };
    const $d393a57ef66828a1$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $d393a57ef66828a1$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("u313a")).actions,
        name: 'team-admin-status'
    });
    const $d393a57ef66828a1$export$1c30a658c5f5a989 = (0, (0, parcelRequire("eW6Xc")).createContainer)($d393a57ef66828a1$var$Store, {
        Wrapper: (0, (0, parcelRequire("eW6Xc")).createDefaultEocWrapper)({
            useSyncContainerProps: ()=>{
                const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
                return {
                    cloudId: cloudId
                };
            }
        })
    });
    const $d393a57ef66828a1$export$8e6e1b9570cbbe18 = (0, (0, parcelRequire("3sQ5x")).createHook)($d393a57ef66828a1$var$Store);
    const $d393a57ef66828a1$export$1e85709af32c9e77 = (0, (0, parcelRequire("3sQ5x")).createHook)($d393a57ef66828a1$var$Store, {
        selector: (state)=>({
                isTeamAdmin: state.teamAdminStatus.data?.isTeamAdmin
            })
    });
});
parcelRegister("u313a", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$e9ada8a126ed29ad$export$e324594224ef24da);
    var $1GqJn;
    var $iA7nF;
    var $4NBj0;
    const $e9ada8a126ed29ad$var$getTeamAdminStatus = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
            const state = getState();
            setState({
                teamAdminStatus: {
                    data: state.teamAdminStatus.data,
                    error: null,
                    loading: true
                }
            });
            return (0, parcelRequire("4NBj0")).getTeamAdminStatus(cloudId).then((res)=>setState({
                    teamAdminStatus: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                })).catch((error)=>{
                setState({
                    teamAdminStatus: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(error)
                });
                throw error;
            });
        };
    const $e9ada8a126ed29ad$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
                dispatch($e9ada8a126ed29ad$var$getTeamAdminStatus())
            ]).then((0, (0, parcelRequire("iA7nF")).multiplePromiseSettler));
    const $e9ada8a126ed29ad$export$e324594224ef24da = {
        getTeamAdminStatus: $e9ada8a126ed29ad$var$getTeamAdminStatus,
        initialize: $e9ada8a126ed29ad$var$initialize
    };
});
parcelRegister("4NBj0", function(module, exports) {
    $parcel$export(module.exports, "getTeamAdminStatus", ()=>$139f0b131a39dfb8$export$454301be74c0d0f5);
    var $jcw0u;
    var $eusud;
    const $139f0b131a39dfb8$export$454301be74c0d0f5 = (cloudId)=>{
        const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/teams/has-any-team-admin-role`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getTeamAdminStatusEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
});
parcelRegister("4UyCK", function(module, exports) {
    $parcel$export(module.exports, "TeamsContainer", ()=>$68ff89a0c54ca969$export$1af14301d7a47977);
    $parcel$export(module.exports, "useTeams", ()=>$68ff89a0c54ca969$export$6fe02dcc2001dcb0);
    var $3sQ5x;
    var $eW6Xc;
    var $iXqE5;
    var $pa9q9;
    var $14XJw;
    var $9OXo1;
    var $fjrC9;
    var $61UG4;
    const $68ff89a0c54ca969$export$d4c72bab9d6cc13a = {
        teams: (0, (0, parcelRequire("fjrC9")).emptyResource),
        hasTeams: false
    };
    const $68ff89a0c54ca969$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $68ff89a0c54ca969$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("61UG4")).actions,
        name: 'teams-step'
    });
    const $68ff89a0c54ca969$export$1af14301d7a47977 = (0, (0, parcelRequire("eW6Xc")).createContainer)($68ff89a0c54ca969$var$Store, {
        Wrapper: (0, (0, parcelRequire("eW6Xc")).createDefaultEocWrapper)({
            useSyncContainerProps: ()=>{
                const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
                const { atlassianAccountId: atlassianAccountId, cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
                const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
                return {
                    orgId: orgId,
                    accountId: atlassianAccountId,
                    siteId: cloudId,
                    showFlag: showFlag
                };
            }
        })
    });
    const $68ff89a0c54ca969$export$381ea4f5dcfe14e8 = (0, (0, parcelRequire("3sQ5x")).createHook)($68ff89a0c54ca969$var$Store);
    const $68ff89a0c54ca969$export$61c2ead0c7de7c67 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($68ff89a0c54ca969$var$Store);
    const $68ff89a0c54ca969$export$6fe02dcc2001dcb0 = (0, (0, parcelRequire("3sQ5x")).createHook)($68ff89a0c54ca969$var$Store, {
        selector: (state)=>({
                teams: state.teams,
                hasTeams: (state.teams.data?.entities.length || 0) > 0
            })
    });
});
parcelRegister("61UG4", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$8b1c9aa8723d62ee$export$e324594224ef24da);
    var $1GqJn;
    var $iA7nF;
    var $pjOsd;
    const $8b1c9aa8723d62ee$var$getTeams = ()=>({ setState: setState, getState: getState }, { orgId: orgId, siteId: siteId, accountId: accountId })=>{
            if (!orgId) throw new Error('TeamsContainer-actions-getTeams-orgId must be defined to search teams');
            if (!accountId) {
                const error = new Error('TeamsContainer-useSyncContainerProps-atlassianAccountId must be defined to search teams');
                error.skipSentry = true;
                throw error;
            }
            const state = getState();
            setState({
                teams: {
                    data: state.teams.data,
                    error: null,
                    loading: true
                }
            });
            return (0, parcelRequire("pjOsd")).searchTeamsEndpoint({
                orgId: orgId,
                siteId: siteId,
                accountId: accountId
            }).then((res)=>setState({
                    teams: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                })).catch((err)=>{
                setState({
                    teams: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $8b1c9aa8723d62ee$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
                dispatch($8b1c9aa8723d62ee$var$getTeams())
            ]).then((0, (0, parcelRequire("iA7nF")).multiplePromiseSettler));
    const $8b1c9aa8723d62ee$export$e324594224ef24da = {
        getTeams: $8b1c9aa8723d62ee$var$getTeams,
        initialize: $8b1c9aa8723d62ee$var$initialize
    };
});
parcelRegister("pjOsd", function(module, exports) {
    $parcel$export(module.exports, "searchTeamsEndpoint", ()=>$ef017c4083dc5c7f$export$b6cad9b1c9a0c16e);
    var $jcw0u;
    var $eusud;
    const $ef017c4083dc5c7f$export$b6cad9b1c9a0c16e = ({ orgId: orgId, siteId: siteId, accountId: accountId })=>{
        const url = '/gateway/api/v4/teams/search';
        return (0, (0, parcelRequire("eusud")).performPostRequest)(url, {
            method: 'POST',
            body: JSON.stringify({
                organizationId: orgId,
                siteId: siteId,
                membership: {
                    memberAccountIds: [
                        accountId
                    ]
                },
                sortBy: [
                    {
                        field: 'displayName',
                        order: 'asc'
                    }
                ],
                limit: 100
            })
        }).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'searchTeamsEndpoint',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    };
});
parcelRegister("91lou", function(module, exports) {
    $parcel$export(module.exports, "TransitioningStatusContainer", ()=>$b8070b541c362c00$export$99720b5470b975d9);
    $parcel$export(module.exports, "useTransitioningStatus", ()=>$b8070b541c362c00$export$534e97dc293df05a);
    $parcel$export(module.exports, "useTransitioningStatusActions", ()=>$b8070b541c362c00$export$5097f959a9aa62ee);
    var $3sQ5x;
    var $eW6Xc;
    var $iXqE5;
    var $pa9q9;
    var $itmJb;
    var $cNd4s;
    var $9OXo1;
    var $8ALXm;
    const $b8070b541c362c00$export$d4c72bab9d6cc13a = {
        loading: false,
        error: null,
        isJnaAppDownloaded: false,
        ogAppExistsAtTransitioningStart: false,
        isRBNEnabled: true,
        areOgRulesDuplicated: false,
        areOgAppsDeactivated: false,
        jnaAppDownloadedRatio: 0,
        jnaAppDownloadedUsersCount: 0
    };
    const $b8070b541c362c00$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $b8070b541c362c00$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("8ALXm")).actions,
        name: 'transitioning-status'
    });
    const $b8070b541c362c00$export$99720b5470b975d9 = (0, (0, parcelRequire("eW6Xc")).createContainer)($b8070b541c362c00$var$Store, {
        Wrapper: (0, (0, parcelRequire("eW6Xc")).createDefaultEocWrapper)({
            useSyncContainerProps: ()=>{
                const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
                const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
                const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
                const isPrimaryAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
                return {
                    cloudId: cloudId,
                    showFlag: showFlag,
                    isAdmin: isSiteAdmin || isPrimaryAdmin
                };
            }
        })
    });
    const $b8070b541c362c00$export$534e97dc293df05a = (0, (0, parcelRequire("3sQ5x")).createHook)($b8070b541c362c00$var$Store);
    const $b8070b541c362c00$export$5097f959a9aa62ee = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($b8070b541c362c00$var$Store);
});
parcelRegister("8ALXm", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$0d76ba88b9164f9c$export$e324594224ef24da);
    var $iA7nF;
    var $i19HX;
    const $0d76ba88b9164f9c$var$getData = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId, isAdmin: isAdmin })=>{
            const { loading: loading } = getState();
            if (loading) return;
            setState({
                loading: true
            });
            return Promise.allSettled([
                (0, (0, parcelRequire("i19HX")).getNotificationPreferences)(cloudId),
                (0, (0, parcelRequire("i19HX")).getTransitioningStatus)(cloudId, isAdmin)
            ]).then((0, (0, parcelRequire("iA7nF")).multiplePromiseSettler)).then(([notificationPreferencesResult, transitioningStatusResult])=>{
                if (notificationPreferencesResult.status === 'rejected' || transitioningStatusResult.status === 'rejected') throw new Error('All promises should be fulfilled in then callback');
                return {
                    ...notificationPreferencesResult.value,
                    ...transitioningStatusResult.value
                };
            }).then(setState).catch((error)=>{
                setState({
                    error: error
                });
                throw error;
            }).finally(()=>{
                setState({
                    loading: false
                });
            });
        };
    const $0d76ba88b9164f9c$var$initialize = $0d76ba88b9164f9c$var$getData;
    const $0d76ba88b9164f9c$var$deactivateOgApps = ()=>async ({ setState: setState })=>{
            setState({
                areOgAppsDeactivated: true
            });
        };
    const $0d76ba88b9164f9c$export$e324594224ef24da = {
        initialize: $0d76ba88b9164f9c$var$initialize,
        deactivateOgApps: $0d76ba88b9164f9c$var$deactivateOgApps
    };
});
parcelRegister("i19HX", function(module, exports) {
    $parcel$export(module.exports, "getTransitioningStatus", ()=>$af3bd5a83ad05315$export$6b245964f40af86a);
    $parcel$export(module.exports, "getNotificationPreferences", ()=>$af3bd5a83ad05315$export$60e139c3026f21bc);
    var $jcw0u;
    var $eusud;
    const $af3bd5a83ad05315$export$6b245964f40af86a = (cloudId, isAdmin)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/transitioning?isAdmin=${isAdmin}`).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getTransitioningStatus',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    const $af3bd5a83ad05315$export$60e139c3026f21bc = (cloudId)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/notification-preferences`).then((res)=>({
                isRBNEnabled: !!res.roleBasedNotificationName
            })).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getNotificationPreferences',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
});
parcelRegister("k9ufy", function(module, exports) {
    $parcel$export(module.exports, "UsersAndRolesContainer", ()=>$f5ea6d8f67a25a35$export$8641f4275dfb350f);
    $parcel$export(module.exports, "useUsersAndRolesStore", ()=>$f5ea6d8f67a25a35$export$4c1f48a2f8c5d25);
    $parcel$export(module.exports, "useUserAndRolesActions", ()=>$f5ea6d8f67a25a35$export$3a5577e95dd8ebcf);
    $parcel$export(module.exports, "useGetUsersWithoutAdminRole", ()=>$f5ea6d8f67a25a35$export$208cf6e453d9959);
    $parcel$export(module.exports, "useGetUsersWithoutCustomRole", ()=>$f5ea6d8f67a25a35$export$f97f67eb73b757d4);
    $parcel$export(module.exports, "useStakeholders", ()=>$f5ea6d8f67a25a35$export$57e32456ebc09be3);
    var $3sQ5x;
    var $eW6Xc;
    var $iXqE5;
    var $9OXo1;
    var $fjrC9;
    var $41HN4;
    const $f5ea6d8f67a25a35$var$initialState = {
        usersWithoutAdminRole: (0, (0, parcelRequire("fjrC9")).emptyResource),
        usersWithoutCustomRole: (0, (0, parcelRequire("fjrC9")).emptyResource),
        stakeholders: (0, (0, parcelRequire("fjrC9")).emptyResource)
    };
    const $f5ea6d8f67a25a35$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $f5ea6d8f67a25a35$var$initialState,
        actions: (0, parcelRequire("41HN4")).actions,
        name: 'user-section'
    });
    const $f5ea6d8f67a25a35$export$8641f4275dfb350f = (0, (0, parcelRequire("eW6Xc")).createContainer)($f5ea6d8f67a25a35$var$Store, {
        Wrapper: (0, (0, parcelRequire("eW6Xc")).createDefaultEocWrapper)({
            useSyncContainerProps: ()=>{
                const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
                return {
                    cloudId: cloudId
                };
            }
        })
    });
    const $f5ea6d8f67a25a35$export$4c1f48a2f8c5d25 = (0, (0, parcelRequire("3sQ5x")).createHook)($f5ea6d8f67a25a35$var$Store);
    const $f5ea6d8f67a25a35$export$3a5577e95dd8ebcf = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($f5ea6d8f67a25a35$var$Store);
    const $f5ea6d8f67a25a35$export$208cf6e453d9959 = (0, (0, parcelRequire("3sQ5x")).createHook)($f5ea6d8f67a25a35$var$Store, {
        selector: (state)=>state.usersWithoutAdminRole
    });
    const $f5ea6d8f67a25a35$export$f97f67eb73b757d4 = (0, (0, parcelRequire("3sQ5x")).createHook)($f5ea6d8f67a25a35$var$Store, {
        selector: (state)=>state.usersWithoutCustomRole
    });
    const $f5ea6d8f67a25a35$export$57e32456ebc09be3 = (0, (0, parcelRequire("3sQ5x")).createHook)($f5ea6d8f67a25a35$var$Store, {
        selector: (state)=>state.stakeholders
    });
});
parcelRegister("41HN4", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$83453406eb32a656$export$e324594224ef24da);
    var $co1wz;
    var $1GqJn;
    var $iA7nF;
    var $2VwYU;
    const $83453406eb32a656$var$getUsersWithoutAdminRole = ()=>({ setState: setState }, { cloudId: cloudId })=>{
            setState({
                usersWithoutAdminRole: {
                    data: null,
                    error: null,
                    loading: true
                }
            });
            return (0, parcelRequire("2VwYU")).getUsersWithoutAdminRole(cloudId).then((res)=>{
                setState({
                    usersWithoutAdminRole: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                });
            }).catch((err)=>{
                setState({
                    usersWithoutAdminRole: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $83453406eb32a656$var$getUsersWithoutCustomRole = ()=>({ setState: setState }, { cloudId: cloudId })=>{
            setState({
                usersWithoutCustomRole: {
                    data: null,
                    error: null,
                    loading: true
                }
            });
            return (0, parcelRequire("2VwYU")).getUsersWithoutCustomRole(cloudId).then((res)=>{
                setState({
                    usersWithoutCustomRole: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                });
            }).catch((err)=>{
                setState({
                    usersWithoutCustomRole: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $83453406eb32a656$var$getStakeholders = ()=>({ setState: setState }, { cloudId: cloudId })=>{
            setState({
                stakeholders: {
                    data: null,
                    error: null,
                    loading: true
                }
            });
            return (0, parcelRequire("2VwYU")).getStakeholders(cloudId).then((res)=>{
                setState({
                    stakeholders: (0, (0, parcelRequire("1GqJn")).createDataResponse)(res)
                });
            }).catch((err)=>{
                setState({
                    stakeholders: (0, (0, parcelRequire("1GqJn")).createErrorResponse)(err)
                });
                throw err;
            });
        };
    const $83453406eb32a656$var$initialize = (hasJsmAboveStandard)=>({ dispatch: dispatch })=>{
            if ((0, (0, parcelRequire("co1wz")).ff)('platform.show-optimal-tooling_brgom') && hasJsmAboveStandard) return Promise.allSettled([
                dispatch($83453406eb32a656$var$getUsersWithoutCustomRole()),
                dispatch($83453406eb32a656$var$getUsersWithoutAdminRole()),
                dispatch($83453406eb32a656$var$getStakeholders())
            ]).then((0, (0, parcelRequire("iA7nF")).multiplePromiseSettler));
            return Promise.allSettled([
                dispatch($83453406eb32a656$var$getUsersWithoutCustomRole()),
                dispatch($83453406eb32a656$var$getUsersWithoutAdminRole())
            ]).then((0, (0, parcelRequire("iA7nF")).multiplePromiseSettler));
        };
    const $83453406eb32a656$export$e324594224ef24da = {
        getUsersWithoutAdminRole: $83453406eb32a656$var$getUsersWithoutAdminRole,
        getUsersWithoutCustomRole: $83453406eb32a656$var$getUsersWithoutCustomRole,
        getStakeholders: $83453406eb32a656$var$getStakeholders,
        initialize: $83453406eb32a656$var$initialize
    };
});
parcelRegister("2VwYU", function(module, exports) {
    $parcel$export(module.exports, "getStakeholders", ()=>$867327124ecc2dfa$export$30370cfbc42a80a5);
    $parcel$export(module.exports, "getUsersWithoutAdminRole", ()=>$867327124ecc2dfa$export$1ec19cfa7c383f0d);
    $parcel$export(module.exports, "getUsersWithoutCustomRole", ()=>$867327124ecc2dfa$export$64f73bf174c9014a);
    var $jcw0u;
    var $eusud;
    const $867327124ecc2dfa$export$30370cfbc42a80a5 = (cloudId)=>(0, (0, parcelRequire("eusud")).performPostRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/roles/filter`, {
            body: JSON.stringify({
                limit: '10',
                offset: 0,
                roles: [
                    'Stakeholder'
                ]
            })
        }).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getStakeholders',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    const $867327124ecc2dfa$export$1ec19cfa7c383f0d = (cloudId)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/permissionDifference/admin`).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getUsersWithoutAdminRole',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    const $867327124ecc2dfa$export$64f73bf174c9014a = (cloudId)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/permissionDifference/customRole`).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getUsersWithoutCustomRole',
                    packageName: 'jiraEocChangeboarding',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
});
const $2829d585c82ec887$export$203403aefc029c66 = 'ref';
const $2829d585c82ec887$export$8638ff77a0e20f0f = 'opsgenie';
parcelRegister("kkwlq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6abecfa22ab77d89$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6abecfa22ab77d89$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitleNonFinal: {
            "id": "eoc-changeboarding.controllers.store.global.error-title-non-final",
            "defaultMessage": "Couldn't open the guide"
        },
        errorDescriptionNonFinal: {
            "id": "eoc-changeboarding.controllers.store.global.error-description-non-final",
            "defaultMessage": "Something went wrong. Reload the page and try again."
        },
        errorActionNonFinal: {
            "id": "eoc-changeboarding.controllers.store.global.error-action-non-final",
            "defaultMessage": "Try again"
        }
    });
});
parcelRegister("aTWms", function(module, exports) {
    $parcel$export(module.exports, "ChangeboardingProviders", ()=>$a85523c42764cbee$export$935fa8923574c4cf);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $4iQaI;
    var $lLiTq;
    var $luBum;
    var $5fIfP;
    var $gPfYl;
    var $jbwqm;
    var $4UyCK;
    var $91lou;
    var $k9ufy;
    const $a85523c42764cbee$var$MinimalToolingProviders = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k9ufy")).UsersAndRolesContainer), {
            isGlobal: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4iQaI")).ChatToolsContainer), {
            isGlobal: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gPfYl")).JNAAppStatusContainer), {
            isGlobal: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("91lou")).TransitioningStatusContainer), {
            isGlobal: true
        }, children))));
    const $a85523c42764cbee$export$935fa8923574c4cf = ({ children: children })=>{
        if ((0, (0, parcelRequire("co1wz")).ff)('platform.show-optimal-tooling_brgom')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4UyCK")).TeamsContainer), {
            isGlobal: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jbwqm")).TeamAdminStatusContainer), {
            isGlobal: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5fIfP")).IntegrationsContainer), {
            isGlobal: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLiTq")).DeprecatedCountsContainer), {
            isGlobal: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBum")).IncidentsContainer), {
            isGlobal: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a85523c42764cbee$var$MinimalToolingProviders, null, children))))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a85523c42764cbee$var$MinimalToolingProviders, null, children);
    };
});
const $fc9bc3f6523d8b85$export$75f90732d1326d15 = 4;
parcelRegister("4sxjm", function(module, exports) {
    $parcel$export(module.exports, "Wizard", ()=>$97b80234070362fc$export$c6a37f46d6629cf2);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $2rqOp;
    var $3gt3f;
    var $8RBk4;
    var $lLLkM;
    var $1R1Ge;
    var $i8Qvm;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $hxoiH;
    var $9fuVs;
    var $koVbs;
    var $8zOmE;
    var $a0LIU = parcelRequire("a0LIU");
    var $oV99b = parcelRequire("oV99b");
    var $1Iasm = parcelRequire("1Iasm");
    var $cEXCj = parcelRequire("cEXCj");
    var $bLrRh = parcelRequire("bLrRh");
    var $8r2Ej = parcelRequire("8r2Ej");
    var $7RwOe = parcelRequire("7RwOe");
    var $lUOr8 = parcelRequire("lUOr8");
    var $N5xjr = parcelRequire("N5xjr");
    var $ksgXI = parcelRequire("ksgXI");
    var $9aTIS = parcelRequire("9aTIS");
    var $6BT89;
    var $ez5GD;
    var $fF3w1;
    var $1Pj9C;
    var $8nrJn;
    var $kDvMN;
    var $d9o3I;
    var $dPJzc;
    const $97b80234070362fc$export$c6a37f46d6629cf2 = ({ isOpen: isOpen, onClose: onClose, defaultStep: defaultStep = 0, onUnlock: onUnlock })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const theme = (0, (0, parcelRequire("hxoiH")).default)();
        const isDarkMode = theme.colorMode === 'dark';
        const [currentStep, setCurrentStep] = (0, $5uXOq.useState)(defaultStep);
        const { update: update } = (0, (0, parcelRequire("ez5GD")).useOgConsolidationUserState)();
        const [isUnlocking, setIsUnlocking] = (0, $5uXOq.useState)(false);
        const { activateTransitionHome: activateTransitionHome, openTransitionHomeModal: openTransitionHomeModal, isTransitionHomeLoading: isTransitionHomeLoading } = (0, (0, parcelRequire("6BT89")).useGlobalChangeboarding)();
        const steps = [
            {
                id: 'step-1',
                component: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kDvMN")).StepOne), null),
                vector: {
                    light: (0, ($parcel$interopDefault($7RwOe))),
                    dark: (0, ($parcel$interopDefault($8r2Ej)))
                }
            },
            {
                id: 'step-2',
                component: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dPJzc")).StepTwo), null),
                vector: {
                    light: (0, ($parcel$interopDefault($9aTIS))),
                    dark: (0, ($parcel$interopDefault($ksgXI)))
                }
            },
            {
                id: 'step-3',
                component: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9o3I")).StepThree), null),
                vector: {
                    light: (0, ($parcel$interopDefault($N5xjr))),
                    dark: (0, ($parcel$interopDefault($lUOr8)))
                }
            },
            {
                id: 'step-4',
                component: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8nrJn")).StepFour), null),
                vector: {
                    light: (0, ($parcel$interopDefault($bLrRh))),
                    dark: (0, ($parcel$interopDefault($cEXCj)))
                }
            },
            {
                id: 'step-5',
                component: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Pj9C")).StepFive), {
                    isFirstUnlocked: defaultStep !== (0, $fc9bc3f6523d8b85$export$75f90732d1326d15)
                }),
                vector: {
                    light: (0, ($parcel$interopDefault($1Iasm))),
                    dark: (0, ($parcel$interopDefault($1Iasm)))
                }
            }
        ];
        const isFirstStep = currentStep === 0;
        const isUnlockStep = currentStep === 3;
        const isUnlockedStep = currentStep === (0, $fc9bc3f6523d8b85$export$75f90732d1326d15);
        (0, $5uXOq.useEffect)(()=>{
            if (isUnlockedStep && isOpen) update({
                isWelcomeModalDisplayed: true
            }).catch(()=>{
                onClose();
            });
        }, [
            isUnlockedStep,
            update,
            isOpen
        ]);
        const handlePrevButton = (e, analyticsEvent)=>{
            if (isFirstStep) onClose();
            else if (isUnlockedStep) {
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'closeTransitionWizardInUnlockStep');
                onClose();
                activateTransitionHome();
            } else setCurrentStep((prevState)=>prevState - 1);
        };
        const handleNextButton = ()=>{
            if (isUnlockStep) {
                setIsUnlocking(true);
                onUnlock?.().then(()=>{
                    setCurrentStep((prevState)=>prevState + 1);
                }).finally(()=>{
                    setIsUnlocking(false);
                });
                return;
            }
            if (isUnlockedStep) {
                activateTransitionHome();
                openTransitionHomeModal().then(()=>{
                    onClose();
                });
                return;
            }
            setCurrentStep((prevState)=>prevState + 1);
        };
        const primaryButtonText = (0, $5uXOq.useMemo)(()=>{
            if (isUnlockStep) return formatMessage((0, (0, parcelRequire("fF3w1")).messages).unlockButton);
            if (isUnlockedStep) return formatMessage((0, (0, parcelRequire("fF3w1")).messages).getStartedButton);
            return formatMessage((0, (0, parcelRequire("fF3w1")).messages).nextButton);
        }, [
            formatMessage,
            isUnlockStep,
            isUnlockedStep
        ]);
        const secondaryButtonText = (0, $5uXOq.useMemo)(()=>{
            if (isFirstStep) return formatMessage((0, (0, parcelRequire("fF3w1")).messages).closeButton);
            if (isUnlockedStep) return formatMessage((0, (0, parcelRequire("fF3w1")).messages).remindMeLaterButton);
            return formatMessage((0, (0, parcelRequire("fF3w1")).messages).backButton);
        }, [
            formatMessage,
            isFirstStep,
            isUnlockedStep
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            height: "700px",
            width: 1100,
            onClose: onClose,
            shouldCloseOnOverlayClick: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $97b80234070362fc$var$contentContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            xcss: [
                $97b80234070362fc$var$halfWidthStyles,
                $97b80234070362fc$var$leftColumnStyles,
                isUnlockedStep && $97b80234070362fc$var$leftColumnUnlockedStyles
            ],
            justifyContent: isUnlockedStep ? 'end' : 'center',
            rowGap: "space.400"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.100"
        }, !isUnlockedStep && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $97b80234070362fc$var$locatorStyles
        }, formatMessage((0, (0, parcelRequire("fF3w1")).messages).stepLocator, {
            stepNumber: currentStep + 1,
            totalSteps: steps.length - 1
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, steps[currentStep].component)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $97b80234070362fc$var$actionsStyles,
            columnGap: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            iconBefore: !isFirstStep && !isUnlockedStep ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3gt3f"))))), {
                label: ""
            }) : undefined,
            onClick: handlePrevButton,
            appearance: isUnlockedStep ? 'subtle' : 'default'
        }, secondaryButtonText), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            iconAfter: !isUnlockStep && !isUnlockedStep ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
                label: ""
            }) : undefined,
            onClick: handleNextButton,
            appearance: "primary",
            isLoading: isUnlocking || isTransitionHomeLoading
        }, primaryButtonText))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: [
                $97b80234070362fc$var$halfWidthStyles,
                $97b80234070362fc$var$rightColumnStyles,
                isDarkMode ? $97b80234070362fc$var$rightColumnDarkStyles : $97b80234070362fc$var$rightColumnLightStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            role: "presentation",
            style: {
                backgroundImage: `url(${isDarkMode ? steps[currentStep].vector?.dark : steps[currentStep].vector?.light})`
            },
            xcss: $97b80234070362fc$var$rightVectorStyles
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $97b80234070362fc$var$closeIconStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
                label: ""
            }),
            "aria-label": formatMessage((0, (0, parcelRequire("fF3w1")).messages).closeButton),
            onClick: onClose
        }))))));
    };
    const $97b80234070362fc$var$actionsStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        alignSelf: 'flex-end'
    });
    const $97b80234070362fc$var$contentContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '100%',
        position: 'relative'
    });
    const $97b80234070362fc$var$locatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtlest',
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $97b80234070362fc$var$leftColumnStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.800',
        paddingRight: 'space.800'
    });
    const $97b80234070362fc$var$leftColumnUnlockedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBottom: 'space.1000'
    });
    const $97b80234070362fc$var$halfWidthStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '50%',
        flexShrink: 0
    });
    const $97b80234070362fc$var$rightColumnStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderTopRightRadius: 'border.radius.100',
        borderBottomRightRadius: 'border.radius.100'
    });
    const $97b80234070362fc$var$rightVectorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center'
    });
    const $97b80234070362fc$var$rightColumnLightStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundImage: `url(${(0, ($parcel$interopDefault($oV99b)))})`
    });
    const $97b80234070362fc$var$rightColumnDarkStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundImage: `url(${(0, ($parcel$interopDefault($a0LIU)))})`
    });
    const $97b80234070362fc$var$closeIconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        right: 'space.200',
        top: 'space.200'
    });
});
parcelRegister("8RBk4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
    function $6740397d4ba98b13$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>$6740397d4ba98b13$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
        }, props, {
            newIcon: $6740397d4ba98b13$var$_arrowRight.default
        }));
    $6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;
});
parcelRegister("h1TKi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c65dc59efb96b35a$var$_UNSAFE_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>$c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
        }, props));
    $c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("a0LIU", function(module, exports) {
    module.exports = new URL("right_section_bg_dark.dc17e2a1.svg", import.meta.url).toString();
});
parcelRegister("oV99b", function(module, exports) {
    module.exports = new URL("right_section_bg_light.524451d7.svg", import.meta.url).toString();
});
parcelRegister("1Iasm", function(module, exports) {
    module.exports = new URL("step_five_vector.ea9a3b76.png", import.meta.url).toString();
});
parcelRegister("cEXCj", function(module, exports) {
    module.exports = new URL("step_four_vector_dark.2f4a898a.png", import.meta.url).toString();
});
parcelRegister("bLrRh", function(module, exports) {
    module.exports = new URL("step_four_vector_light.c758c949.png", import.meta.url).toString();
});
parcelRegister("8r2Ej", function(module, exports) {
    module.exports = new URL("step_one_vector_dark.0f84f063.png", import.meta.url).toString();
});
parcelRegister("7RwOe", function(module, exports) {
    module.exports = new URL("step_one_vector_light.5040164b.png", import.meta.url).toString();
});
parcelRegister("lUOr8", function(module, exports) {
    module.exports = new URL("step_three_vector_dark.56be6ccf.png", import.meta.url).toString();
});
parcelRegister("N5xjr", function(module, exports) {
    module.exports = new URL("step_three_vector_light.c27f5a05.png", import.meta.url).toString();
});
parcelRegister("ksgXI", function(module, exports) {
    module.exports = new URL("step_two_vector_dark.168f447a.png", import.meta.url).toString();
});
parcelRegister("9aTIS", function(module, exports) {
    module.exports = new URL("step_two_vector_light.ede3342e.png", import.meta.url).toString();
});
parcelRegister("fF3w1", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$83bed3caa2c56c5a$export$defe85febe8b728c);
    var $7VHMR;
    const $83bed3caa2c56c5a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        stepLocator: {
            "id": "eoc-changeboarding.wizard.step-locator-no-translate",
            "defaultMessage": "{stepNumber} of {totalSteps}"
        },
        nextButton: {
            "id": "eoc-changeboarding.wizard.next-button-no-translate",
            "defaultMessage": "Next"
        },
        backButton: {
            "id": "eoc-changeboarding.wizard.back-button-no-translate",
            "defaultMessage": "Back"
        },
        closeButton: {
            "id": "eoc-changeboarding.wizard.close-button-no-translate",
            "defaultMessage": "Close"
        },
        unlockButton: {
            "id": "eoc-changeboarding.wizard.unlock-button-no-translate",
            "defaultMessage": "Let's start moving"
        },
        getStartedButton: {
            "id": "eoc-changeboarding.wizard.get-started-button-no-translate",
            "defaultMessage": "Open guide"
        },
        remindMeLaterButton: {
            "id": "eoc-changeboarding.wizard.remind-me-later-button-no-translate",
            "defaultMessage": "Remind me later"
        }
    });
});
parcelRegister("1Pj9C", function(module, exports) {
    $parcel$export(module.exports, "StepFive", ()=>$d8e2de7c6a777bd7$export$782dfa47fc019134);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $cwmS5;
    var $bFmnZ;
    var $7eUVi;
    var $jDorM;
    var $fptva;
    var $1bKdn;
    var $kgoHi;
    var $luBm6;
    var $cgL5K;
    var $koVbs;
    var $itmJb;
    var $cNd4s;
    var $4iQaI;
    var $k9ufy;
    var $bvirq;
    var $5PzzT;
    const $d8e2de7c6a777bd7$var$ListItem = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            justifyContent: "start",
            columnGap: "space.075",
            alignItems: "start"
        }, children);
    const $d8e2de7c6a777bd7$export$782dfa47fc019134 = ({ isFirstUnlocked: isFirstUnlocked = true })=>{
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const isUser = !isAdmin && !isSiteAdmin;
        const [usersWithoutAdminRole] = (0, (0, parcelRequire("k9ufy")).useGetUsersWithoutAdminRole)();
        const [usersWithoutCustomRole] = (0, (0, parcelRequire("k9ufy")).useGetUsersWithoutCustomRole)();
        const [integrations] = (0, (0, parcelRequire("4iQaI")).useChatToolsIntegrations)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (isUser) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvirq")).List), {
            heading: formatMessage((0, (0, parcelRequire("5PzzT")).messages).titleByUser),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("5PzzT")).messages).listDescriptionForAnotherAdmin))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall",
            as: "h2"
        }, formatMessage((0, (0, parcelRequire("5PzzT")).messages).listItemHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d8e2de7c6a777bd7$var$ListItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("jDorM"))))),
            appearance: "orange",
            label: ""
        }), formatMessage((0, (0, parcelRequire("5PzzT")).messages).listItemOneUser)), (0, ($parcel$interopDefault($5uXOq))).createElement($d8e2de7c6a777bd7$var$ListItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("7eUVi"))))),
            appearance: "green",
            label: ""
        }), formatMessage((0, (0, parcelRequire("5PzzT")).messages).listItemTwoUser)))));
        if (isFirstUnlocked) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvirq")).List), {
            heading: formatMessage((0, (0, parcelRequire("5PzzT")).messages).titleUnlockedBySameAdmin),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                space: "space.250"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("5PzzT")).messages).listDescription)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("5PzzT")).messages).listDescriptionTwo)))
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvirq")).List), {
            heading: formatMessage((0, (0, parcelRequire("5PzzT")).messages).titleUnlockedByAnotherAdmin),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("5PzzT")).messages).listDescriptionForAnotherAdmin))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall",
            as: "h2"
        }, formatMessage((0, (0, parcelRequire("5PzzT")).messages).listItemHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, integrations.data?.count !== 0 && (0, ($parcel$interopDefault($5uXOq))).createElement($d8e2de7c6a777bd7$var$ListItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("bFmnZ"))))),
            appearance: "teal",
            label: ""
        }), formatMessage((0, (0, parcelRequire("5PzzT")).messages).listItemOne)), usersWithoutAdminRole.data?.count !== 0 && (0, ($parcel$interopDefault($5uXOq))).createElement($d8e2de7c6a777bd7$var$ListItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("1bKdn"))))),
            appearance: "orange",
            label: ""
        }), formatMessage((0, (0, parcelRequire("5PzzT")).messages).listItemTwo, {
            userAmount: usersWithoutAdminRole.data?.values.length ?? 0
        })), usersWithoutCustomRole.data?.count !== 0 && (0, ($parcel$interopDefault($5uXOq))).createElement($d8e2de7c6a777bd7$var$ListItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("fptva"))))),
            appearance: "purple",
            label: ""
        }), formatMessage((0, (0, parcelRequire("5PzzT")).messages).listItemThree, {
            userAmount: usersWithoutCustomRole.data?.values.length ?? 0
        })))));
    };
});
parcelRegister("cwmS5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a921419639fe8f6f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    function $a921419639fe8f6f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a921419639fe8f6f$var$sizeMap = {
        '16': {
            name: "157xhr7",
            styles: "width:16px;height:16px"
        },
        '24': {
            name: "rrel8y",
            styles: "width:24px;height:24px"
        },
        '32': {
            name: "68x97p",
            styles: "width:32px;height:32px"
        },
        '40': {
            name: "1mfsro6",
            styles: "width:40px;height:40px"
        },
        '48': {
            name: "18jhpep",
            styles: "width:48px;height:48px"
        }
    };
    const $a921419639fe8f6f$var$appearanceMap = {
        grayBold: {
            name: "algye9",
            styles: "background-color:var(--ds-background-accent-gray-bolder, #626F86);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        limeBold: {
            name: "a86nvv",
            styles: "background-color:var(--ds-background-accent-lime-bolder, #5B7F24);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        greenBold: {
            name: "13e2qqr",
            styles: "background-color:var(--ds-background-accent-green-bolder, #1F845A);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        blueBold: {
            name: "jpsdma",
            styles: "background-color:var(--ds-background-accent-blue-bolder, #0C66E4);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        redBold: {
            name: "1bg8y7a",
            styles: "background-color:var(--ds-background-accent-red-bolder, #C9372C);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        purpleBold: {
            name: "19bo3lb",
            styles: "background-color:var(--ds-background-accent-purple-bolder, #6E5DC6);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        magentaBold: {
            name: "1l16rgo",
            styles: "background-color:var(--ds-background-accent-magenta-bolder, #AE4787);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        tealBold: {
            name: "7kw5zl",
            styles: "background-color:var(--ds-background-accent-teal-bolder, #227D9B);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        orangeBold: {
            name: "h77eay",
            styles: "background-color:var(--ds-background-accent-orange-bolder, #C25100);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        yellowBold: {
            name: "sbe4w3",
            styles: "background-color:var(--ds-background-accent-yellow-bolder, #946F00);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        gray: {
            name: "yxgei8",
            styles: "background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);color:var(--ds-icon-accent-gray, #758195)"
        },
        lime: {
            name: "o9c6oh",
            styles: "background-color:var(--ds-background-accent-lime-subtler, #D3F1A7);color:var(--ds-icon-accent-lime, #6A9A23)"
        },
        orange: {
            name: "szqzk5",
            styles: "background-color:var(--ds-background-accent-orange-subtler, #FEDEC8);color:var(--ds-icon-accent-orange, #E56910)"
        },
        magenta: {
            name: "o6ptuw",
            styles: "background-color:var(--ds-background-accent-magenta-subtler, #FDD0EC);color:var(--ds-icon-accent-magenta, #CD519D)"
        },
        green: {
            name: "157dg7e",
            styles: "background-color:var(--ds-background-accent-green-subtler, #BAF3DB);color:var(--ds-icon-accent-green, #22A06B)"
        },
        blue: {
            name: "x3nujl",
            styles: "background-color:var(--ds-background-accent-blue-subtler, #CCE0FF);color:var(--ds-icon-accent-blue, #1D7AFC)"
        },
        red: {
            name: "zqoyws",
            styles: "background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-icon-accent-red, #C9372C)"
        },
        purple: {
            name: "fitjkd",
            styles: "background-color:var(--ds-background-accent-purple-subtler, #DFD8FD);color:var(--ds-icon-accent-purple, #8270DB)"
        },
        teal: {
            name: "b3m1ww",
            styles: "background-color:var(--ds-background-accent-teal-subtler, #C6EDFB);color:var(--ds-icon-accent-teal, #2898BD)"
        },
        yellow: {
            name: "1j18jub",
            styles: "background-color:var(--ds-background-accent-yellow-subtler, #F8E6A0);color:var(--ds-icon-accent-yellow, #B38600)"
        }
    };
    const $a921419639fe8f6f$var$shapeMap = {
        square: {
            name: "vwdoqr",
            styles: "border-radius:var(--ds-border-radius-100, 4px)"
        },
        circle: {
            name: "i2ucdk",
            styles: "border-radius:var(--ds-border-radius-circle, 32032px)"
        }
    };
    const $a921419639fe8f6f$var$iconTileStyles = {
        name: "ykimcl",
        styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center"
    };
    function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
        const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent } = props;
        const ExpandedIcon = Icon;
        if (LEGACY_fallbackComponent && !(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
        else return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $a921419639fe8f6f$var$iconTileStyles,
                $a921419639fe8f6f$var$appearanceMap[appearance],
                $a921419639fe8f6f$var$sizeMap[size],
                $a921419639fe8f6f$var$shapeMap[shape]
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        }));
    }
});
parcelRegister("bFmnZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $87e4e36d6c115ce9$var$_react = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $87e4e36d6c115ce9$var$_UNSAFE_baseNew = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $87e4e36d6c115ce9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $87e4e36d6c115ce9$var$CommentIcon = (props)=>$87e4e36d6c115ce9$var$_react.default.createElement($87e4e36d6c115ce9$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.172.099zm-3.5 2H0a.75.75 0 0 0 1.122.651zM2.625 2h10.75V.5H2.625zM14.5 3.125v8.25H16v-8.25zM13.375 12.5H4.25V14h9.125zm-9.497.099-3.5 2 .744 1.302 3.5-2zM1.5 15.25V3.125H0V15.25zM4 6.5h8V5H4zm0 3h5V8H4zm10.5 1.875c0 .621-.504 1.125-1.125 1.125V14A2.625 2.625 0 0 0 16 11.375zM13.375 2c.621 0 1.125.504 1.125 1.125H16A2.625 2.625 0 0 0 13.375.5zM2.625.5A2.625 2.625 0 0 0 0 3.125h1.5C1.5 2.504 2.004 2 2.625 2z"/>`
        }, props));
    $87e4e36d6c115ce9$var$CommentIcon.displayName = 'CommentIcon';
    var $87e4e36d6c115ce9$var$_default = module.exports.default = $87e4e36d6c115ce9$var$CommentIcon;
});
parcelRegister("7eUVi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5455fef624dfcc70$var$_react = $5455fef624dfcc70$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5455fef624dfcc70$var$_UNSAFE_baseNew = $5455fef624dfcc70$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $5455fef624dfcc70$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5455fef624dfcc70$var$EyeOpenIcon = (props)=>$5455fef624dfcc70$var$_react.default.createElement($5455fef624dfcc70$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 2.75c-3.255 0-6.086 2.039-7.13 4.888a1.06 1.06 0 0 0 0 .724C1.914 11.212 4.745 13.25 8 13.25s6.086-2.039 7.129-4.888a1.06 1.06 0 0 0 0-.724c-1.043-2.85-3.874-4.888-7.13-4.888Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
        }, props));
    $5455fef624dfcc70$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
    var $5455fef624dfcc70$var$_default = module.exports.default = $5455fef624dfcc70$var$EyeOpenIcon;
});
parcelRegister("bvirq", function(module, exports) {
    $parcel$export(module.exports, "List", ()=>$a581088461a32051$export$54c2e3dc7acea9f5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $kgoHi;
    const $a581088461a32051$export$54c2e3dc7acea9f5 = ({ heading: heading, description: description, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.300"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            rowGap: "space.100",
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xxlarge"
        }, heading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.150"
        }, description, children));
});
parcelRegister("5PzzT", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$d59b37bfeef18160$export$defe85febe8b728c);
    var $7VHMR;
    const $d59b37bfeef18160$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        titleUnlockedBySameAdmin: {
            "id": "eoc-changeboarding.wizard.steps.five.title-unlocked-by-same-admin.no-translate",
            "defaultMessage": "We're now moving you to Jira Service Management"
        },
        titleUnlockedByAnotherAdmin: {
            "id": "eoc-changeboarding.wizard.steps.five.title-unlocked-by-another-admin.no-translate",
            "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
        },
        titleByUser: {
            "id": "eoc-changeboarding.wizard.steps.five.title-by-user.no-translate",
            "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
        },
        listDescription: {
            "id": "eoc-changeboarding.wizard.steps.five.list-description.no-translate",
            "defaultMessage": "Almost all of your Opsgenie data and settings are now in Jira Service Management."
        },
        listDescriptionTwo: {
            "id": "eoc-changeboarding.wizard.steps.five.list-description-two.no-translate",
            "defaultMessage": "Let's go finish setting up some critical configurations, so your teams can start using operations in Jira Service Management."
        },
        listItemHeading: {
            "id": "eoc-changeboarding.wizard.steps.five.list-item-heading.no-translate",
            "defaultMessage": "Let's go set up a few things so your team can get started"
        },
        listDescriptionForAnotherAdmin: {
            "id": "eoc-changeboarding.wizard.steps.five.list-description-for-another-admin.no-translate",
            "defaultMessage": "Almost all of your Opsgenie data and settings are now in Jira Service Management, so you no longer need Opsgenie to do your alerting and on-call work."
        },
        listItemOne: {
            "id": "eoc-changeboarding.wizard.steps.five.list-item-one.no-translate",
            "defaultMessage": "Configure chat integrations in Jira Service Management"
        },
        listItemTwo: {
            "id": "eoc-changeboarding.wizard.steps.five.list-item-two.no-translate",
            "defaultMessage": "Give the product admin role to {userAmount, plural, one {{userAmount} Opsgenie admin} other {{userAmount} Opsgenie admins}}"
        },
        listItemThree: {
            "id": "eoc-changeboarding.wizard.steps.five.list-item-three.no-translate",
            "defaultMessage": "Give a product role to {userAmount, plural, one {{userAmount} Opsgenie user} other {{userAmount} Opsgenie users}} who no longer have a custom role"
        },
        listItemOneUser: {
            "id": "eoc-changeboarding.wizard.steps.five.list-item-one-user.no-translate",
            "defaultMessage": "Configure your notifications settings in Jira"
        },
        listItemTwoUser: {
            "id": "eoc-changeboarding.wizard.steps.five.list-item-two-user.no-translate",
            "defaultMessage": "Discover how operations works on Jira Service Management"
        },
        learnMore: {
            "id": "eoc-changeboarding.wizard.steps.five.learn-more.no-translate",
            "defaultMessage": "Don't feel ready yet? <link>Read more about operations</link>"
        }
    });
});
parcelRegister("8nrJn", function(module, exports) {
    $parcel$export(module.exports, "StepFour", ()=>$00e484d2ef4a7a44$export$b88edf692723a2ee);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMcV;
    var $k7m40;
    var $fVnbM;
    var $1dJ6S;
    var $cwmS5;
    var $bjo8S;
    var $8w53e;
    var $8nk07;
    var $dC5iT;
    var $kgoHi;
    var $cgL5K;
    var $8CUq3;
    var $koVbs;
    var $ieJ0b;
    var $2YP9W;
    var $k763U;
    var $hAeFn;
    const $00e484d2ef4a7a44$export$b88edf692723a2ee = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { timeZone: timeZone } = (0, (0, parcelRequire("k763U")).useUserTimezone)();
        const { data: transitioningData } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("ieJ0b")).transitioningDetailsResource));
        if (!transitioningData) throw new Error('[StepFour] component should not be rendered before details resource fetched');
        const items = [
            {
                icon: {
                    component: (0, ($parcel$interopDefault((0, parcelRequire("8w53e"))))),
                    appearance: 'magenta'
                },
                text: formatMessage((0, (0, parcelRequire("hAeFn")).messages).listItemOne)
            },
            {
                icon: {
                    component: (0, ($parcel$interopDefault((0, parcelRequire("bjo8S"))))),
                    appearance: 'green'
                },
                text: formatMessage((0, (0, parcelRequire("hAeFn")).messages).listItemTwo)
            },
            {
                icon: {
                    component: (0, ($parcel$interopDefault((0, parcelRequire("8nk07"))))),
                    appearance: 'purple'
                },
                text: formatMessage((0, (0, parcelRequire("hAeFn")).messages).listItemThree, {
                    unlockDate: (0, (0, parcelRequire("k7m40")).default)((0, (0, parcelRequire("7CMcV")).default)(transitioningData?.autoOgTurnOffDate, timeZone), 'MMMM dd, yyyy'),
                    b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
                })
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.300"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            rowGap: "space.100",
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xlarge"
        }, formatMessage((0, (0, parcelRequire("hAeFn")).messages).title))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            role: "list",
            direction: "column",
            rowGap: "space.150"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("hAeFn")).messages).listDescription)), items.map((item, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                justifyContent: "start",
                columnGap: "space.075",
                alignItems: "start",
                role: "listitem",
                key: i
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: item.icon.component,
                appearance: item.icon.appearance,
                label: ""
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, item.text))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("hAeFn")).messages).learnMore, {
            link: (str)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "link",
                    spacing: "none",
                    href: "https://support.atlassian.com/jira-service-management-cloud/docs/what-are-operations/",
                    target: "_blank"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    as: "span",
                    xcss: $00e484d2ef4a7a44$var$buttonTextStyles
                }, str))
        }))));
    };
    const $00e484d2ef4a7a44$var$buttonTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textDecoration: 'underline',
        fontWeight: 400
    });
});
parcelRegister("bjo8S", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83c43234bc70a485$var$_UNSAFE_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83c43234bc70a485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83c43234bc70a485$var$CheckMarkIcon = (props)=>$83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
        }, props));
    $83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;
});
parcelRegister("8w53e", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $63353af41c1756be$var$_UNSAFE_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $63353af41c1756be$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $63353af41c1756be$var$CopyIcon = (props)=>$63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
    var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;
});
parcelRegister("k763U", function(module, exports) {
    $parcel$export(module.exports, "useUserTimezone", ()=>$61b09c1db2df12ec$export$a166f5a988ee846a);
    var $cYlk7;
    const $61b09c1db2df12ec$export$a166f5a988ee846a = ()=>{
        const { data: userData } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const timeZone = 'timeZone' in userData.user ? userData.user.timeZone || 'UTC' : 'UTC';
        return {
            timeZone: timeZone
        };
    };
});
parcelRegister("hAeFn", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$02f4523b36af2e4c$export$defe85febe8b728c);
    var $7VHMR;
    const $02f4523b36af2e4c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "eoc-changeboarding.wizard.steps.four.title-no-translate",
            "defaultMessage": "Ready to move from Opsgenie?"
        },
        listDescription: {
            "id": "eoc-changeboarding.wizard.steps.four.list-description-no-translate",
            "defaultMessage": "Here's a summary of what happens once you move:"
        },
        listItemOne: {
            "id": "eoc-changeboarding.wizard.steps.four.list-item-one-no-translate",
            "defaultMessage": "Your Opsgenie data and settings will be synced with Jira Service Management, without any changes,"
        },
        listItemTwo: {
            "id": "eoc-changeboarding.wizard.steps.four.list-item-two-no-translate",
            "defaultMessage": "You'll get a guide to follow and complete your move from Opsgenie to Jira Service Management,"
        },
        listItemThree: {
            "id": "eoc-changeboarding.wizard.steps.four.list-item-three-no-translate",
            "defaultMessage": "Your Opsgenie account will continue to be accessible, until it's turned off on <b>{unlockDate}</b>."
        },
        learnMore: {
            "id": "eoc-changeboarding.wizard.steps.four.learn-more-no-translate",
            "defaultMessage": "Don't feel ready yet? <link>Read more about moving from Opsgenie</link>"
        }
    });
});
parcelRegister("kDvMN", function(module, exports) {
    $parcel$export(module.exports, "StepOne", ()=>$7a86782c2818c255$export$d644924ea55d67c0);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $cwmS5;
    var $7Xp7u;
    var $jDorM;
    var $epOG5;
    var $kgoHi;
    var $cgL5K;
    var $koVbs;
    var $bCLyZ;
    const $7a86782c2818c255$export$d644924ea55d67c0 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const sections = [
            {
                icon: {
                    component: (0, ($parcel$interopDefault((0, parcelRequire("jDorM"))))),
                    appearance: 'orange'
                },
                title: formatMessage((0, (0, parcelRequire("bCLyZ")).messages).alertsTitle),
                description: formatMessage((0, (0, parcelRequire("bCLyZ")).messages).alertsDescription)
            },
            {
                icon: {
                    component: (0, ($parcel$interopDefault((0, parcelRequire("epOG5"))))),
                    appearance: 'lime'
                },
                title: formatMessage((0, (0, parcelRequire("bCLyZ")).messages).operationsTitle),
                description: formatMessage((0, (0, parcelRequire("bCLyZ")).messages).operationsDescription)
            },
            {
                icon: {
                    component: (0, ($parcel$interopDefault((0, parcelRequire("7Xp7u"))))),
                    appearance: 'teal'
                },
                title: formatMessage((0, (0, parcelRequire("bCLyZ")).messages).mobileTitle),
                description: formatMessage((0, (0, parcelRequire("bCLyZ")).messages).mobileDescription)
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.300"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            rowGap: "space.100",
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xlarge"
        }, formatMessage((0, (0, parcelRequire("bCLyZ")).messages).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("bCLyZ")).messages).description))), sections.map((section, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                key: i,
                direction: "column",
                rowGap: "space.100"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                columnGap: "space.075",
                alignItems: "center"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: section.icon.component,
                appearance: section.icon.appearance,
                label: ""
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                as: "h2",
                size: "xsmall"
            }, section.title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, section.description))));
    };
});
parcelRegister("7Xp7u", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5cb18762800f939e$var$_react = $5cb18762800f939e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5cb18762800f939e$var$_UNSAFE_baseNew = $5cb18762800f939e$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $5cb18762800f939e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5cb18762800f939e$var$DeviceMobileIcon = (props)=>$5cb18762800f939e$var$_react.default.createElement($5cb18762800f939e$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 12.25h4m-5.5 3h7c.69 0 1.25-.56 1.25-1.25V2c0-.69-.56-1.25-1.25-1.25h-7c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $5cb18762800f939e$var$DeviceMobileIcon.displayName = 'DeviceMobileIcon';
    var $5cb18762800f939e$var$_default = module.exports.default = $5cb18762800f939e$var$DeviceMobileIcon;
});
parcelRegister("bCLyZ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$a63a8f5fbc89de06$export$defe85febe8b728c);
    var $7VHMR;
    const $a63a8f5fbc89de06$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "eoc-changeboarding.wizard.steps.one.title-no-translate",
            "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
        },
        description: {
            "id": "eoc-changeboarding.wizard.steps.one.description-no-translate",
            "defaultMessage": "Make Jira Service Management your team's central place to do all the operations work that they currently do with Opsgenie."
        },
        alertsTitle: {
            "id": "eoc-changeboarding.wizard.steps.one.alerts-title-no-translate",
            "defaultMessage": "Respond to alerts"
        },
        alertsDescription: {
            "id": "eoc-changeboarding.wizard.steps.one.alerts-description-no-translate",
            "defaultMessage": "Work on your alerts natively from Jira Service Management's Your work page."
        },
        operationsTitle: {
            "id": "eoc-changeboarding.wizard.steps.one.operations-title-no-translate",
            "defaultMessage": "Manage operations"
        },
        operationsDescription: {
            "id": "eoc-changeboarding.wizard.steps.one.operations-description-no-translate",
            "defaultMessage": "Find your integrations, custom roles, maintenance, notifications, policies, audit logs, and more in Jira settings."
        },
        mobileTitle: {
            "id": "eoc-changeboarding.wizard.steps.one.mobile-title-no-translate",
            "defaultMessage": "Get mobile notifications"
        },
        mobileDescription: {
            "id": "eoc-changeboarding.wizard.steps.one.mobile-description-no-translate",
            "defaultMessage": "Stay notified of alerts, check on-call schedules, and manage notification rules on the go with Jira Cloud mobile."
        }
    });
});
parcelRegister("d9o3I", function(module, exports) {
    $parcel$export(module.exports, "StepThree", ()=>$8d1d9cf23c07c953$export$98c7d7d0f8104aa7);
    var $5uXOq = parcelRequire("5uXOq");
    var $k3qRI;
    var $1dJ6S;
    var $4GsX0;
    var $5qRwM;
    var $dC5iT;
    var $kgoHi;
    var $cgL5K;
    var $8CUq3;
    var $koVbs;
    var $fjrC9;
    var $4iQaI;
    var $aED3C;
    const $8d1d9cf23c07c953$export$98c7d7d0f8104aa7 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [integrations] = (0, (0, parcelRequire("4iQaI")).useChatToolsIntegrations)();
        if (!integrations.data) throw new Error('StepThree should be rendered when chat tools integrations are loaded');
        const head = {
            cells: [
                {
                    key: 'integration',
                    content: formatMessage((0, (0, parcelRequire("aED3C")).messages).integration),
                    width: 60
                },
                {
                    key: 'team',
                    content: formatMessage((0, (0, parcelRequire("aED3C")).messages).team),
                    width: 40
                }
            ]
        };
        const rows = integrations.data.values.slice(0, 3).map(({ chatSpaceId: chatSpaceId, name: name, chatSpaceType: chatSpaceType, teamName: teamName })=>({
                key: chatSpaceId,
                cells: [
                    {
                        key: `${chatSpaceId}-integration`,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                            alignItems: "center",
                            xcss: [
                                $8d1d9cf23c07c953$var$rowStyles,
                                $8d1d9cf23c07c953$var$linkStyles
                            ],
                            columnGap: "space.100"
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5qRwM")).default), {
                            width: "16",
                            height: "16",
                            src: chatSpaceType === 'slack' ? (0, (0, parcelRequire("fjrC9")).SLACK_IMAGE_URL) : (0, (0, parcelRequire("fjrC9")).MST_IMAGE_URL),
                            alt: chatSpaceType
                        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                            xcss: $8d1d9cf23c07c953$var$integrationNameBoxStyles
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                            as: "p",
                            maxLines: 1
                        }, name)))
                    },
                    {
                        key: `${chatSpaceId}-team`,
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                            alignItems: "center",
                            columnGap: "space.100"
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4GsX0"))))), {
                            size: "small",
                            label: ""
                        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                            as: "p",
                            maxLines: 1
                        }, teamName || formatMessage((0, (0, parcelRequire("aED3C")).messages).global)))
                    }
                ]
            }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.300"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            rowGap: "space.100",
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xlarge"
        }, formatMessage((0, (0, parcelRequire("aED3C")).messages).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("aED3C")).messages).description))), integrations.data.count > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall",
            as: "div"
        }, formatMessage((0, (0, parcelRequire("aED3C")).messages).chatIntegrationsFoundInOpsgenie, {
            amount: integrations.data.count
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8d1d9cf23c07c953$var$tableStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k3qRI")).default), {
            isFixedSize: true,
            head: head,
            rows: rows,
            rowsPerPage: 3,
            defaultPage: 1
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8d1d9cf23c07c953$var$blanketStyles
        }))));
    };
    const $8d1d9cf23c07c953$var$rowStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '36px'
    });
    const $8d1d9cf23c07c953$var$linkStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.link'
    });
    const $8d1d9cf23c07c953$var$tableStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        pointerEvents: 'none',
        userSelect: 'none',
        position: 'relative',
        marginBottom: '0'
    });
    const $8d1d9cf23c07c953$var$blanketStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%',
        position: 'absolute',
        background: `linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, ${"var(--ds-surface-overlay, #282E33)"} 100%)`,
        top: 'space.negative.300'
    });
    const $8d1d9cf23c07c953$var$integrationNameBoxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '60%'
    });
});
parcelRegister("k3qRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60e4f0159aa1c87c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $gS5Cm;
    var $dHbUn;
    class $60e4f0159aa1c87c$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                defaultPage: 1,
                isLoading: false,
                isFixedSize: false,
                isRankable: false,
                onSetPage: (0, (0, parcelRequire("eGmKJ")).default),
                onSort: (0, (0, parcelRequire("eGmKJ")).default),
                rowsPerPage: Infinity
            };
        }
        UNSAFE_componentWillReceiveProps(newProps) {
            const sortKey = newProps.sortKey || this.state.sortKey;
            const sortOrder = newProps.sortOrder || this.state.sortOrder;
            const page = newProps.page || this.state.page;
            this.setState({
                page: page,
                sortKey: sortKey,
                sortOrder: sortOrder,
                rows: newProps.rows
            });
        }
        render() {
            const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
            const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dHbUn")).default), {
                paginationi18n: paginationi18n,
                caption: caption,
                emptyView: emptyView,
                head: head,
                highlightedRowIndex: highlightedRowIndex,
                loadingSpinnerSize: loadingSpinnerSize,
                isLoading: isLoading,
                loadingLabel: loadingLabel,
                isFixedSize: isFixedSize,
                onSetPage: this.onSetPageHandler,
                onSort: this.onSortHandler,
                page: page,
                rows: rows,
                rowsPerPage: rowsPerPage,
                sortKey: sortKey,
                sortOrder: sortOrder,
                isRankable: isRankable,
                isRankingDisabled: isRankingDisabled,
                onRankEnd: this.onRankEndHandler,
                onRankStart: onRankStart,
                onPageRowsUpdate: onPageRowsUpdate,
                testId: testId,
                label: label
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                page: this.props.defaultPage,
                sortKey: this.props.defaultSortKey,
                sortOrder: this.props.defaultSortOrder,
                rows: this.props.rows
            };
            this.onSetPageHandler = (page, analyticsEvent)=>{
                const { onSetPage: onSetPage } = this.props;
                if (onSetPage) {
                    onSetPage(page, analyticsEvent);
                    this.setState({
                        page: page
                    });
                }
            };
            this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
                const { onSort: onSort } = this.props;
                if (onSort) {
                    onSort({
                        key: key,
                        item: item,
                        sortOrder: sortOrder
                    }, analyticsEvent);
                    this.setState({
                        sortKey: key,
                        sortOrder: sortOrder
                    });
                }
            };
            this.onRankEndIfExistsHandler = (params)=>{
                if (this.props.onRankEnd) this.props.onRankEnd(params);
            };
            this.onRankEndHandler = (params)=>{
                const { destination: destination } = params;
                const { rows: rows, page: page } = this.state;
                const { rowsPerPage: rowsPerPage } = this.props;
                if (!destination || !rows) {
                    this.onRankEndIfExistsHandler(params);
                    return;
                }
                const reordered = (0, (0, parcelRequire("gS5Cm")).reorderRows)(params, rows, page, rowsPerPage);
                this.setState({
                    rows: reordered
                });
                this.onRankEndIfExistsHandler(params);
            };
        }
    }
});
parcelRegister("gS5Cm", function(module, exports) {
    $parcel$export(module.exports, "getPageRows", ()=>$7f55105045703159$export$3987dc24b734dcab);
    $parcel$export(module.exports, "assertIsSortable", ()=>$7f55105045703159$export$5eb35a4771ec4090);
    $parcel$export(module.exports, "validateSortKey", ()=>$7f55105045703159$export$9133f5a8bfe8a200);
    $parcel$export(module.exports, "inlineStylesIfRanking", ()=>$7f55105045703159$export$a601f1775e10043f);
    $parcel$export(module.exports, "reorderRows", ()=>$7f55105045703159$export$c476bbe5da59992d);
    const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
        if (!pageNumber || !rowsPerPage || !allRows.length) return [];
        return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
    };
    const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
        if (!head || !head.cells) return;
        head.cells.forEach((cell)=>{
            if (cell.isSortable && !cell.key) try {
                throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
            } catch (e) {
                console.error(e);
            }
        });
    };
    const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
        if (!sortKey) return;
        const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
        if (!headHasKey) try {
            throw Error(`Cell with ${sortKey} key not found in head.`);
        } catch (e) {
            console.error(e);
        }
    };
    const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
        if (!isRanking) return {};
        if (height) return {
            width: width,
            height: height
        };
        return {
            width: width
        };
    };
    const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
        const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
        return index + itemOnPreviousPages;
    };
    const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
        const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
        if (!destination) return rows;
        const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
        const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
        const reordered = rows.slice();
        const [removed] = reordered.splice(fromIndex, 1);
        reordered.splice(toIndex, 0, removed);
        return reordered;
    };
});
parcelRegister("dHbUn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb6422faa785b221$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $eGmKJ;
    var $gS5Cm;
    var $hiWL0;
    var $kF3yx;
    var $fkvnY;
    var $hK8cd;
    var $dDBI6;
    var $dk72m;
    var $50Tma;
    var $jlnvO;
    function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
        switch(currentSortOrder){
            case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
                return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
            case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
                return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
            default:
                return currentSortOrder;
        }
    }
    const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, (0, parcelRequire("eGmKJ")).default), onSort: providedOnSort = (0, (0, parcelRequire("eGmKJ")).default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, (0, parcelRequire("eGmKJ")).default), onRankEnd: providedOnRankEnd = (0, (0, parcelRequire("eGmKJ")).default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
        prev: 'Previous',
        next: 'Next',
        label: 'Pagination',
        pageLabel: 'Page'
    } })=>{
        const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
        const tableBodyRef = (0, $5uXOq.useRef)(null);
        const onSort = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnSort,
            action: 'sorted',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const onRankEnd = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnRankEnd,
            action: 'ranked',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("gS5Cm")).validateSortKey)(sortKey, head);
            (0, (0, parcelRequire("gS5Cm")).assertIsSortable)(head);
        }, [
            sortKey,
            head
        ]);
        const onSortHandler = (item)=>()=>{
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        const onSetPageHandler = (page, event)=>{
            onSetPage(page, event);
        };
        const onRankStartHandler = (params)=>{
            setIsRanking(true);
            onRankStart(params);
        };
        const onRankEndHandler = (params)=>{
            setIsRanking(false);
            onRankEnd(params);
        };
        const getSpinnerSize = ()=>{
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, (0, parcelRequire("gS5Cm")).getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
        };
        const renderEmptyBody = ()=>{
            if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kF3yx")).EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kF3yx")).EmptyViewContainer), {
                testId: testId
            }, emptyView);
        };
        const rowsLength = rows && rows.length;
        let totalPages;
        let isTotalPagesControlledExternally = false;
        if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
            totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
            isTotalPagesControlledExternally = true;
        } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
        totalPages = totalPages < 1 ? 1 : totalPages;
        const getPageNumber = page > totalPages ? totalPages : page;
        const rowsExist = !!rowsLength;
        const spinnerSize = getSpinnerSize();
        const emptyBody = renderEmptyBody();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dk72m")).default), {
            isLoading: isLoading && rowsExist,
            spinnerSize: spinnerSize,
            targetRef: ()=>tableBodyRef.current,
            testId: testId,
            loadingLabel: loadingLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).Table), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading
        }, !!caption && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).Caption), null, caption), head && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jlnvO")).default), {
            head: head,
            onSort: onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: isRanking,
            isRankable: isRankable,
            testId: testId
        }), rowsExist && (0, ($parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$TableBody, {
            ref: tableBodyRef,
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            testId: testId,
            isRankable: isRankable,
            isRanking: isRanking,
            onRankStart: onRankStartHandler,
            onRankEnd: onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        }))), totalPages <= 1 ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).PaginationWrapper), {
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("50Tma")).default), {
            value: getPageNumber,
            onChange: onSetPageHandler,
            total: totalPages,
            i18n: paginationi18n,
            isDisabled: isLoading,
            testId: testId
        })), !rowsExist && emptyBody && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dDBI6")).default), {
            isLoading: isLoading,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            testId: testId,
            loadingLabel: loadingLabel
        }, emptyBody));
    };
    const $cb6422faa785b221$var$RankableTableBody = (0, $5uXOq.lazy)(()=>(parcelRequire("f9SMa")));
    const $cb6422faa785b221$var$TableBody = (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
        const canRank = isRankable && !bodyProps.sortKey;
        const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (canRank) setCanRenderRankable(true);
        }, [
            canRank
        ]);
        const nonRankableBody = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fkvnY")).default), {
            ref: ref,
            ...bodyProps
        });
        return canRank && canRenderRankable ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hK8cd")).ErrorBoundary), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$RankableTableBody, {
            ref: ref,
            ...bodyProps,
            isRanking: isRanking,
            onRankStart: onRankStart,
            onRankEnd: onRankEnd,
            isRankingDisabled: isRankingDisabled
        }))) : nonRankableBody;
    });
    var $cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;
});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;
parcelRegister("hiWL0", function(module, exports) {
    $parcel$export(module.exports, "tableRowCSSVars", ()=>$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb);
    $parcel$export(module.exports, "Table", ()=>$3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
    $parcel$export(module.exports, "Caption", ()=>$3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
    $parcel$export(module.exports, "PaginationWrapper", ()=>$3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $54lmm;
    function $3b29b0d00cd7b5c6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb = {
        CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
        CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
        CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
        CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
    };
    const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = {
        name: "wgb42e",
        styles: "table-layout:fixed"
    };
    const $3b29b0d00cd7b5c6$var$tableStyles = {
        name: "mul4pg",
        styles: "width:100%;border-collapse:separate;border-spacing:0px"
    };
    const $3b29b0d00cd7b5c6$var$bodyBorder = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("54lmm")).tableBorder).borderColor}`
    });
    const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("table", {
            inert: isLoading ? '' : undefined,
            style: {
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).hoverBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).highlightedBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).hoverHighlightedBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, (0, parcelRequire("54lmm")).row).focusOutline
            },
            css: [
                $3b29b0d00cd7b5c6$var$tableStyles,
                isFixedSize && $3b29b0d00cd7b5c6$var$fixedSizeTableStyles,
                hasDataRow && $3b29b0d00cd7b5c6$var$bodyBorder
            ],
            ref: ref,
            ...rest,
            "data-testid": testId && `${testId}--table`
        }, children);
    });
    const $3b29b0d00cd7b5c6$var$captionStyles = {
        name: "h9a27i",
        styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
    };
    const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("caption", {
            css: $3b29b0d00cd7b5c6$var$captionStyles
        }, children);
    const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = {
        name: "zl1inp",
        styles: "display:flex;justify-content:center"
    };
    const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3b29b0d00cd7b5c6$var$paginationWrapperStyles,
            "data-testid": testId && `${testId}--pagination--container`
        }, children);
});
parcelRegister("54lmm", function(module, exports) {
    $parcel$export(module.exports, "MSThemeColors", ()=>$b728acac6d8ee4bc$export$34af08ce45c78352);
    $parcel$export(module.exports, "arrow", ()=>$b728acac6d8ee4bc$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "row", ()=>$b728acac6d8ee4bc$export$120ff0929b202a6d);
    $parcel$export(module.exports, "head", ()=>$b728acac6d8ee4bc$export$5fd5031fecdacec3);
    $parcel$export(module.exports, "tableBorder", ()=>$b728acac6d8ee4bc$export$38d703b73e2cf64d);
    const $b728acac6d8ee4bc$export$34af08ce45c78352 = {
        Background: 'Canvas',
        Text: 'CanvasText',
        SelectedBackground: 'Highlight',
        SelectedText: 'HighlightText'
    };
    const $b728acac6d8ee4bc$export$f2120bbfa5450bd2 = {
        defaultColor: `var(--ds-icon-disabled, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`,
        selectedColor: `var(--ds-icon-subtle, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
    };
    const $b728acac6d8ee4bc$export$120ff0929b202a6d = {
        focusOutline: `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
        highlightedBackground: `var(--ds-background-selected, ${$829f609a65d26a98$export$226de0355ed012f8})`,
        hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$829f609a65d26a98$export$e655ef011c4aa1a2})`,
        hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`
    };
    const $b728acac6d8ee4bc$export$5fd5031fecdacec3 = {
        textColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
    };
    const $b728acac6d8ee4bc$export$38d703b73e2cf64d = {
        borderColor: `var(--ds-border, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
    };
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("kF3yx", function(module, exports) {
    $parcel$export(module.exports, "EmptyViewWithFixedHeight", ()=>$0852c529eaab7231$export$8f45b9407d4090d7);
    $parcel$export(module.exports, "EmptyViewContainer", ()=>$0852c529eaab7231$export$381ea436de119582);
    var $f8Sb3;
    function $0852c529eaab7231$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0852c529eaab7231$var$fixedHeightStyles = {
        name: "50gc26",
        styles: "height:9rem"
    };
    const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0852c529eaab7231$var$fixedHeightStyles,
            "data-testid": testId && `${testId}--empty-view-with-fixed-height`
        }, children);
    const $0852c529eaab7231$var$emptyViewContainerStyles = {
        name: "1yld51o",
        styles: "width:50%;margin:auto;padding:10px;text-align:center"
    };
    const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
        const { children: children, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0852c529eaab7231$var$emptyViewContainerStyles,
            "data-testid": testId && `${testId}--empty-view-container`
        }, children);
    };
});
parcelRegister("fkvnY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32bba7afdbc8736a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7bJDt;
    var $ggqAE;
    class $32bba7afdbc8736a$var$BodyComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", {
                "data-testid": testId && `${testId}--body`,
                ref: forwardedRef
            }, pageRows.map((row, rowIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ggqAE")).default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    key: row.key || rowIndex,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                })));
        }
    }
    const $32bba7afdbc8736a$var$Body = (0, (0, parcelRequire("7bJDt")).default)((0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($32bba7afdbc8736a$var$BodyComponent, {
            ...props,
            forwardedRef: ref
        });
    }));
    var $32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;
});
parcelRegister("7bJDt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc6eeecb3dc05edd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gS5Cm;
    const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
        for(let i = 0; i < cells.length; i++){
            if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
        }
        return undefined;
    };
    const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
        if (!sortKey || !head) return rows;
        if (!rows) return [];
        const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
        const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'accent'
        });
        const sortableRows = Array.from(rows);
        return sortableRows.sort((a, b)=>{
            const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
            const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
            if (valA === undefined || valB === undefined) return modifier;
            if (typeof valA !== typeof valB) {
                if (typeof valA === 'number') return -1;
                if (typeof valB === 'number') return 1;
                if (typeof valA === 'string') return -1;
                if (typeof valB === 'string') return 1;
            }
            if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
            if (!valA && valA !== 0 || valA < valB) return -modifier;
            if (!valB && valB !== 0 || valA > valB) return modifier;
            if (valA === valB) return 0;
            return 1;
        });
    };
    function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
        class WithSortedPageRows extends (0, ($parcel$interopDefault($5uXOq))).Component {
            static getDerivedStateFromProps(props, state) {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
                (0, (0, parcelRequire("gS5Cm")).validateSortKey)(sortKey, head);
                let sortedRows;
                let pageRows;
                if (isTotalPagesControlledExternally) {
                    sortedRows = rows;
                    pageRows = rows;
                } else {
                    sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                    pageRows = (0, (0, parcelRequire("gS5Cm")).getPageRows)(sortedRows, page, rowsPerPage);
                }
                return {
                    ...state,
                    pageRows: pageRows
                };
            }
            componentDidMount() {
                this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
            }
            componentDidUpdate(_prevProps, prevState) {
                if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
            }
            render() {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    pageRows: this.state.pageRows,
                    head: head,
                    ...restProps,
                    ref: forwardedRef
                });
            }
            constructor(...args){
                super(...args);
                this.state = {
                    pageRows: []
                };
            }
        }
        return (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
                ...props,
                forwardedRef: ref
            });
        });
    }
});
parcelRegister("ggqAE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$136b57fea50cecd2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1g0dL;
    var $d9WgS;
    const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
        const { cells: cells, ...restRowProps } = row;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9WgS")).TableBodyRow), {
            ...restRowProps,
            isHighlighted: isHighlighted,
            ...isHighlighted ? {
                'data-ts--dynamic-table--table-row--highlighted': true
            } : null,
            testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
        }, cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1g0dL")).TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        }));
    };
    var $136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;
});
parcelRegister("1g0dL", function(module, exports) {
    $parcel$export(module.exports, "TableBodyCell", ()=>$11c3ea74eda01ab8$export$948e91fcef170792);
    var $f8Sb3;
    var $9GQPi;
    const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("td", {
            style: (0, (0, parcelRequire("9GQPi")).getTruncationStyleVars)({
                width: width
            }),
            css: [
                (0, (0, parcelRequire("9GQPi")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("9GQPi")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("9GQPi")).overflowTruncateStyles),
                (0, (0, parcelRequire("9GQPi")).cellStyles)
            ],
            ref: innerRef,
            ...props
        });
});
parcelRegister("9GQPi", function(module, exports) {
    $parcel$export(module.exports, "truncationWidthStyles", ()=>$99c9652c1fab2b08$export$708a733455f59a29);
    $parcel$export(module.exports, "fixedSizeTruncateStyles", ()=>$99c9652c1fab2b08$export$616c93ee022c8812);
    $parcel$export(module.exports, "overflowTruncateStyles", ()=>$99c9652c1fab2b08$export$7f2cd17defa265d8);
    $parcel$export(module.exports, "getTruncationStyleVars", ()=>$99c9652c1fab2b08$export$5e6497a652ae30b5);
    $parcel$export(module.exports, "cellStyles", ()=>$99c9652c1fab2b08$export$f7913df521f684e2);
    var $f8Sb3;
    function $99c9652c1fab2b08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
    const $99c9652c1fab2b08$export$708a733455f59a29 = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `var(${$99c9652c1fab2b08$var$CSS_VAR_WIDTH})`
    });
    const $99c9652c1fab2b08$export$616c93ee022c8812 = {
        name: "1s7jr4j",
        styles: "text-overflow:ellipsis;white-space:nowrap"
    };
    const $99c9652c1fab2b08$export$7f2cd17defa265d8 = {
        name: "d3v9zr",
        styles: "overflow:hidden"
    };
    const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
            [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
        } : undefined;
    const $99c9652c1fab2b08$export$f7913df521f684e2 = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        border: 'none',
        textAlign: 'left',
        '&:first-of-type': {
            paddingInlineStart: "var(--ds-space-0, 0px)"
        },
        '&:last-child': {
            paddingInlineEnd: "var(--ds-space-0, 0px)"
        }
    });
});
parcelRegister("d9WgS", function(module, exports) {
    $parcel$export(module.exports, "TableBodyRow", ()=>$ba9cb59faf06ce7f$export$45f39d9c38b886d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $hiWL0;
    const $ba9cb59faf06ce7f$var$rowStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        '&:focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
            outlineOffset: `-2px`
        }
    });
    const $ba9cb59faf06ce7f$var$rowBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
        }
    });
    const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-background-selected, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
        }
    });
    const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("tr", {
            style: style,
            css: [
                $ba9cb59faf06ce7f$var$rowStyles,
                isHighlighted ? $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles : $ba9cb59faf06ce7f$var$rowBackgroundStyles
            ],
            ...rest,
            ref: ref,
            "data-testid": testId
        }, children);
    });
});
parcelRegister("hK8cd", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$883137116243a6a0$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    class $883137116243a6a0$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        render() {
            if (this.state.hasError) return this.props.fallback;
            return this.props.children;
        }
    }
});
parcelRegister("dDBI6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e4b90b361173610$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $lLAKY;
    class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
                loadingLabel: 'Loading table'
            };
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).Container), {
                testId: testId
            }, !isLoading ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).ContentsContainer), {
                contentsOpacity: contentsOpacity,
                testId: testId
            }, children), isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).SpinnerContainer), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            })));
        }
    }
});
parcelRegister("lLAKY", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$d0e2766ad96d94ad$export$42a852a2b6b56249);
    $parcel$export(module.exports, "ContentsContainer", ()=>$d0e2766ad96d94ad$export$67c29eae8ae2137a);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$d0e2766ad96d94ad$export$a5e06607a5ac6158);
    var $f8Sb3;
    function $d0e2766ad96d94ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
    const $d0e2766ad96d94ad$var$containerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d0e2766ad96d94ad$var$containerStyles,
            "data-testid": testId && `${testId}--container`
        }, children);
    const $d0e2766ad96d94ad$var$contentsContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: `var(${$d0e2766ad96d94ad$export$c335a80381ec61f5})`,
        pointerEvents: 'none'
    });
    const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
            },
            css: [
                $d0e2766ad96d94ad$var$contentsContainerStyles
            ],
            "data-testid": testId && `${testId}--contents--container`
        }, children);
    const $d0e2766ad96d94ad$var$spinnerContainerStyles = {
        name: "su4u96",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
    };
    const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d0e2766ad96d94ad$var$spinnerContainerStyles,
            "data-testid": testId && `${testId}--spinner--container`
        }, children);
});
parcelRegister("dk72m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba39c903b39a83b1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $4xXH4;
    class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
                loadingLabel: 'Loading table'
            };
        }
        attachListeners() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize);
        }
        detachListeners() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleResize);
        }
        updateSpinnerPosition() {
            const viewportHeight = window.innerHeight;
            const targetNode = this.getTargetNode();
            const spinnerNode = this.spinnerRef?.current;
            if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
            const targetRect = targetNode.getBoundingClientRect();
            const spinnerRect = spinnerNode.getBoundingClientRect();
            const spinnerHeight = spinnerRect.height;
            const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
            const { top: top, bottom: bottom, height: height } = targetRect;
            if (isInViewport) {
                const canFollow = height >= spinnerHeight * 3;
                if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                    if (top >= 0) {
                        const viewportSpaceTakenByElement = viewportHeight - top;
                        const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                        const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    } else if (top < 0 && bottom > viewportHeight) {
                        const y = viewportHeight / 2 - spinnerHeight / 2;
                        this.translateSpinner(spinnerNode, y, true);
                    } else {
                        const diff = bottom / 2 - spinnerHeight / 2;
                        const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    }
                    return;
                }
            } else {
                if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
            }
            const containerNode = this.containerRef?.current;
            if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
                const thisTop = containerNode.getBoundingClientRect().top;
                const y = (top - thisTop) / 2;
                this.translateSpinner(spinnerNode, y, false);
            }
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).Container), {
                testId: testId && `${testId}--loading--container--advanced`,
                ref: this.containerRef
            }, children, isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).SpinnerBackdrop), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).SpinnerContainer), {
                ref: this.spinnerRef
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            }))));
        }
        constructor(...args){
            super(...args);
            this.spinnerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.containerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.componentDidMount = ()=>{
                if (this.props.isLoading && this.hasTargetNode()) {
                    this.attachListeners();
                    this.updateTargetAppearance();
                    this.updateSpinnerPosition();
                }
            };
            this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
                if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
                else if (!this.props.isLoading) this.attachListeners();
            };
            this.componentDidUpdate = ()=>{
                if (this.hasTargetNode()) {
                    this.updateTargetAppearance();
                    if (this.props.isLoading) this.updateSpinnerPosition();
                }
            };
            this.componentWillUnmount = ()=>{
                this.detachListeners();
            };
            this.getTargetNode = (nextProps = this.props)=>{
                const { targetRef: targetRef } = nextProps;
                const target = targetRef?.();
                return target || this.containerRef.current;
            };
            this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
            this.isVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                if (bottom <= 0) return false;
                return top < viewportHeight;
            };
            this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                return top >= 0 && bottom <= viewportHeight;
            };
            this.handleResize = ()=>{
                this.updateSpinnerPosition();
            };
            this.handleScroll = ()=>{
                this.updateSpinnerPosition();
            };
            this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
                spinnerNode.style.position = isFixed ? 'fixed' : '';
                spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
            };
            this.updateTargetAppearance = ()=>{
                const targetNode = this.getTargetNode();
                const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
                if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                    targetNode.style.pointerEvents = isLoading ? 'none' : '';
                    targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
                }
            };
        }
    }
});
parcelRegister("4xXH4", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$48301faf1109874f$export$42a852a2b6b56249);
    $parcel$export(module.exports, "SpinnerBackdrop", ()=>$48301faf1109874f$export$aa207050321b0c53);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$48301faf1109874f$export$a5e06607a5ac6158);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $48301faf1109874f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $48301faf1109874f$var$containerStyles = {
        name: "17fhw1k",
        styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
    };
    const $48301faf1109874f$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, ...rest } = props;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$containerStyles,
            ...rest,
            "data-testid": testId,
            ref: ref
        }, children));
    });
    const $48301faf1109874f$var$spinnerBackdropStyles = {
        name: "1yy6mjk",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
    };
    const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$spinnerBackdropStyles,
            "data-testid": testId && `${testId}--spinner-backdrop`
        }, children);
    const $48301faf1109874f$var$spinnerContainerStyles = {
        name: "vi3nlf",
        styles: "position:relative;inset-block-start:0"
    };
    const $48301faf1109874f$export$a5e06607a5ac6158 = (0, $5uXOq.forwardRef)(({ children: children }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$spinnerContainerStyles,
            ref: ref
        }, children));
});
parcelRegister("50Tma", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21d5ee5c6331aeb9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $xBgAj;
    class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
            const pages = [
                ...Array(total)
            ].map((_, index)=>index + 1);
            const selectedIndex = value - 1;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xBgAj")).default), {
                selectedIndex: selectedIndex,
                isDisabled: isDisabled,
                label: i18n?.label,
                nextLabel: i18n?.next,
                previousLabel: i18n?.prev,
                pageLabel: i18n?.pageLabel,
                onChange: this.onChange,
                pages: pages,
                testId: testId && `${testId}--pagination`
            });
        }
        constructor(...args){
            super(...args);
            this.onChange = (_event, newValue, analyticsEvent)=>{
                this.props.onChange(newValue, analyticsEvent);
            };
        }
    }
});
parcelRegister("xBgAj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8aaadfaafd170b3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $eGmKJ;
    var $33etG;
    var $fmJTX;
    var $6s76W;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $5HBW9;
    var $15F6T;
    var $lmPue;
    var $fc5SA;
    var $gRWrA;
    const $8aaadfaafd170b3c$var$analyticsAttributes = {
        componentName: 'pagination',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $8aaadfaafd170b3c$var$paginationMenuStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.0',
        margin: 'space.0'
    });
    const $8aaadfaafd170b3c$var$paginationMenuItemStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.0'
    });
    const $8aaadfaafd170b3c$var$navigatorIconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.075'
    });
    function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
        const Chevron = chevronDirection === 'left' ? (0, ($parcel$interopDefault((0, parcelRequire("fmJTX"))))) : (0, ($parcel$interopDefault((0, parcelRequire("6s76W")))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $8aaadfaafd170b3c$var$navigatorIconWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        }));
    }
    function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, (0, parcelRequire("fc5SA")).emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, (0, parcelRequire("fc5SA")).emptyObject), max: max = 7, onChange: onChange = (0, (0, parcelRequire("eGmKJ")).default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, (0, parcelRequire("lmPue")).default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
        const [selectedIndexValue, setSelectedIndexValue] = (0, (0, parcelRequire("33etG")).default)(selectedIndex, ()=>defaultSelectedIndex || 0);
        const onChangeWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (value, analyticsEvent)=>{
                const { event: event, selectedPageIndex: selectedPageIndex } = value;
                if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
                if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
            },
            action: 'changed',
            actionSubject: 'pageNumber',
            analyticsData: analyticsContext,
            ...$8aaadfaafd170b3c$var$analyticsAttributes
        });
        const transform = (page, currPageIndex, testId)=>{
            const selectedPage = pages[selectedIndexValue];
            const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
            const isCurrentPage = page === selectedPage;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                as: "li",
                xcss: $8aaadfaafd170b3c$var$paginationMenuItemStyles,
                key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("15F6T")).default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
            }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            style: style,
            ref: ref,
            "aria-label": label,
            as: "nav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HBW9")).default), {
            key: "left-navigator",
            component: components.Previous,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue - 1
                }),
            isDisabled: isDisabled || selectedIndexValue === 0,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
                chevronDirection: "left"
            }),
            "aria-label": previousLabel,
            testId: testId && `${testId}--left-navigator`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "baseline",
            as: "ul",
            xcss: $8aaadfaafd170b3c$var$paginationMenuStyles
        }, (0, (0, parcelRequire("gRWrA")).default)(pages, selectedIndexValue, {
            max: max,
            ellipsis: renderEllipsis,
            transform: transform
        }, testId)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HBW9")).default), {
            key: "right-navigator",
            component: components.Next,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue + 1
                }),
            isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
                chevronDirection: "right"
            }),
            "aria-label": nextLabel,
            testId: testId && `${testId}--right-navigator`
        }))));
    }
    const $8aaadfaafd170b3c$var$Pagination = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
    var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;
});
parcelRegister("fmJTX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));
    var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
    function $b2fc843461eabf96$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>$b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
        }, props));
    $b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("a88oa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $7601289634e055f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>$7601289634e055f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $7601289634e055f6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;
});
parcelRegister("6s76W", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));
    var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
    function $4b2adfad98efb792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>$4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
        }, props));
    $4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
parcelRegister("5HBW9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63acbbc2953d9b5a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            "aria-label": props['aria-label'],
            isDisabled: props.isDisabled,
            iconBefore: props.iconBefore,
            testId: props.testId,
            onClick: props.onClick,
            component: props.component,
            appearance: "subtle"
        });
    }
});
parcelRegister("15F6T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097dd42f19f41562$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            appearance: "subtle"
        });
    }
});
parcelRegister("lmPue", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d144cd0d91a90ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $jldZL;
    const $3d144cd0d91a90ab$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        position: 'relative'
    });
    function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "li",
            testId: testId,
            key: key,
            xcss: $3d144cd0d91a90ab$var$containerStyles,
            paddingInline: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            testId: testId && `${testId}-text`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
    }
});
parcelRegister("fc5SA", function(module, exports) {
    $parcel$export(module.exports, "emptyObject", ()=>$cbef1c2cfb373aca$export$3f860eba1218f8d3);
    const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};
});
parcelRegister("gRWrA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48fbac64848b775a$export$2e2bcd8739ae039);
    var $8QpSo;
    const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
        const total = pages.length;
        const needEllipsis = total > max;
        const hasStartEllipsis = needEllipsis && max - 4 < current;
        const hasEndEllipsis = needEllipsis && current < total - max + 3;
        const getPageComponents = (0, (0, parcelRequire("8QpSo")).default)((startIndex = 0, lastIndex = total)=>{
            return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
        });
        if (!needEllipsis) return getPageComponents(0, total);
        if (hasStartEllipsis && !hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, 1),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: 2,
                    to: total - pageCount
                }),
                ...getPageComponents(total - pageCount)
            ];
        }
        if (!hasStartEllipsis && hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, pageCount),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: pageCount + 1,
                    to: total - 1
                }),
                ...getPageComponents(total - 1)
            ];
        }
        const pageCount = max - 4;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: current - Math.floor(pageCount / 2)
            }),
            ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
            ellipsis({
                key: 'ellipsis-2',
                testId: testId && `${testId}-ellipsis`,
                from: current + 3,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    };
    var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;
});
parcelRegister("jlnvO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097ee65829e33b82$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gS5Cm;
    var $9Ooyy;
    var $a41RA;
    var $dpXLF;
    class $097ee65829e33b82$var$TableHead extends (0, ($parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillMount() {
            (0, (0, parcelRequire("gS5Cm")).validateSortKey)(this.props.sortKey, this.props.head);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, (0, parcelRequire("gS5Cm")).validateSortKey)(nextProps.sortKey, nextProps.head);
        }
        render() {
            const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
            if (!head) return null;
            const HeadCellComponent = isRankable ? (0, (0, parcelRequire("a41RA")).default) : (0, (0, parcelRequire("dpXLF")).default);
            const { cells: cells, ...rest } = head;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ooyy")).Head), {
                ...rest,
                isRanking: isRanking,
                testId: testId && `${testId}--head`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
                const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, ...restCellProps } = cell;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                    colSpan: colSpan,
                    content: content,
                    isFixedSize: isFixedSize,
                    isSortable: !!isSortable,
                    isRanking: isRanking,
                    key: key || index,
                    onClick: isSortable ? onSort(cell) : undefined,
                    testId: cellTestId || testId,
                    shouldTruncate: shouldTruncate,
                    sortOrder: key === sortKey ? sortOrder : undefined,
                    width: width,
                    ...restCellProps
                });
            })));
        }
    }
    var $097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;
});
parcelRegister("9Ooyy", function(module, exports) {
    $parcel$export(module.exports, "Head", ()=>$e002e0403dc403bb$export$e93312b7773dfcac);
    $parcel$export(module.exports, "HeadCell", ()=>$e002e0403dc403bb$export$4e8024263ace498b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $54lmm;
    var $9GQPi;
    function $e002e0403dc403bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
    const $e002e0403dc403bb$var$rankingStyles = {
        name: "4zleql",
        styles: "display:block"
    };
    const $e002e0403dc403bb$var$headStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `none`
    });
    const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("thead", {
            css: [
                $e002e0403dc403bb$var$headStyles,
                isRanking && $e002e0403dc403bb$var$rankingStyles
            ],
            "data-testid": testId,
            ...props
        });
    };
    const $e002e0403dc403bb$var$headCellBaseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        position: 'relative',
        border: 'none',
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("54lmm")).tableBorder).borderColor}`,
        color: `var(--ds-text-subtle, ${`var(${$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR})`})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textAlign: 'left',
        verticalAlign: 'top',
        '&:focus-visible': {
            outline: `solid 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
        }
    });
    const $e002e0403dc403bb$var$onClickStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
            cursor: 'pointer'
        }
    });
    const $e002e0403dc403bb$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            padding: "var(--ds-space-0, 0)",
            position: 'relative',
            appearance: 'none',
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            '&::before, &::after': {
                display: 'block',
                width: 0,
                height: 0,
                position: 'absolute',
                border: '3px solid transparent',
                content: '""',
                insetInlineEnd: "var(--ds-space-negative-100, -8px)"
            },
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).defaultColor}`,
                insetBlockEnd: "var(--ds-space-100, 8px)"
            },
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).defaultColor}`,
                insetBlockEnd: 0
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before, &::after': {
                    border: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Background}`
                },
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Text}`
                },
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Text}`
                }
            }
        }
    });
    const $e002e0403dc403bb$var$ascendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $e002e0403dc403bb$var$descendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $e002e0403dc403bb$export$4e8024263ace498b = (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
        const mergedStyles = {
            ...style,
            ...width && (0, (0, parcelRequire("9GQPi")).getTruncationStyleVars)({
                width: width
            }),
            [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: (0, (0, parcelRequire("54lmm")).head).textColor
        };
        const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
        const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
        const getFormattedSortOrder = ()=>{
            if (isASC) return 'ascending';
            else if (isDESC) return 'descending';
        };
        const Component = children ? 'th' : 'td';
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
            "aria-sort": getFormattedSortOrder(),
            style: mergedStyles,
            css: [
                (0, (0, parcelRequire("9GQPi")).cellStyles),
                $e002e0403dc403bb$var$headCellBaseStyles,
                onClick && $e002e0403dc403bb$var$onClickStyles,
                (0, (0, parcelRequire("9GQPi")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("9GQPi")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("9GQPi")).overflowTruncateStyles),
                isSortable && $e002e0403dc403bb$var$baseStyles,
                isASC && $e002e0403dc403bb$var$ascendingStyles,
                isDESC && $e002e0403dc403bb$var$descendingStyles
            ],
            onClick: onClick,
            ref: ref,
            "data-testid": testId,
            ...rest
        }, children);
    });
});
parcelRegister("a41RA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$669a06e89a9827f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cVljL;
    var $gS5Cm;
    var $dpXLF;
    class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
            const inlineStyles = (0, (0, parcelRequire("gS5Cm")).inlineStylesIfRanking)(isRanking, refWidth);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dpXLF")).default), {
                inlineStyles: inlineStyles,
                ...restProps
            });
        }
    }
    const $669a06e89a9827f7$var$RankableTableHeadCell = (0, (0, parcelRequire("cVljL")).default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
    var $669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;
});
parcelRegister("cVljL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3e49a9b167764eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
        return class WithDimensions extends (0, ($parcel$interopDefault($5uXOq))).Component {
            UNSAFE_componentWillReceiveProps(nextProps) {
                const wasRanking = this.props.isRanking;
                const willRanking = nextProps.isRanking;
                if (willRanking && !wasRanking) this.updateDimensions();
            }
            render() {
                const { refWidth: refWidth, refHeight: refHeight } = this.state;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    refWidth: refWidth,
                    refHeight: refHeight,
                    innerRef: this.innerRef,
                    ...this.props
                });
            }
            constructor(...args){
                super(...args);
                this.state = {
                    refWidth: 0,
                    refHeight: 0
                };
                this.innerRef = (ref)=>{
                    if (ref && !this.props.isRanking) this.ref = ref;
                };
                this.updateDimensions = ()=>{
                    if (!this.ref) return;
                    const clientRect = this.ref.getBoundingClientRect();
                    const { width: width } = clientRect;
                    const { height: height } = clientRect;
                    if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                        refWidth: width,
                        refHeight: height
                    });
                };
            }
        };
    }
});
parcelRegister("dpXLF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9c80f4a483cfd6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9Ooyy;
    const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ooyy")).HeadCell), {
            style: inlineStyles,
            testId: testId && `${testId}--head--cell`,
            ref: typeof innerRef !== 'string' ? innerRef : null,
            ...rest,
            onClick: onClick,
            isSortable: isSortable
        }, isSortable ? (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            type: "button",
            "aria-roledescription": "Sort button"
        }, content) : content);
    };
    var $d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;
});
parcelRegister("f9SMa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("bz1jP")
    ]).then(()=>parcelRequire('4THp8'));
});
parcelRegister("aED3C", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$32e99b148de1b65c$export$defe85febe8b728c);
    var $7VHMR;
    const $32e99b148de1b65c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "eoc-changeboarding.wizard.steps.three.title-no-translate",
            "defaultMessage": "What happens to chat tools"
        },
        description: {
            "id": "eoc-changeboarding.wizard.steps.three.description-no-translate",
            "defaultMessage": "Connect your chat tools and copy your Opsgenie chat integrations to Jira Service Management, as they won't be moved automatically."
        },
        chatIntegrationsFoundInOpsgenie: {
            "id": "eoc-changeboarding.wizard.steps.three.chat-integrations-found-in-opsgenie-no-translate",
            "defaultMessage": "{amount, plural, one {{amount} Opsgenie chat integration} other {{amount} Opsgenie chat integrations}} found"
        },
        integration: {
            "id": "eoc-changeboarding.wizard.steps.three.integration-no-translate",
            "defaultMessage": "Integration"
        },
        team: {
            "id": "eoc-changeboarding.wizard.steps.three.team-no-translate",
            "defaultMessage": "Team"
        },
        global: {
            "id": "eoc-changeboarding.wizard.steps.three.global-no-translate",
            "defaultMessage": "Global"
        }
    });
});
parcelRegister("dPJzc", function(module, exports) {
    $parcel$export(module.exports, "StepTwo", ()=>$9c0d1653f9ddf163$export$f7c6032816713bb9);
    var $5uXOq = parcelRequire("5uXOq");
    var $jnhNB;
    var $1dJ6S;
    var $kgoHi;
    var $cgL5K;
    var $koVbs;
    var $k9ufy;
    var $9tWQs;
    const $9c0d1653f9ddf163$export$f7c6032816713bb9 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [usersWithoutCustomRole] = (0, (0, parcelRequire("k9ufy")).useGetUsersWithoutCustomRole)();
        if (usersWithoutCustomRole.data === null) throw new Error('StepTwo should not be rendered if users are still loading');
        const avatarGroupData = usersWithoutCustomRole.data.values.map((user)=>({
                key: user.id,
                name: user.name,
                src: user.avatarUrl
            }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.300"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            rowGap: "space.100",
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xlarge"
        }, formatMessage((0, (0, parcelRequire("9tWQs")).messages).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("9tWQs")).messages).description))), usersWithoutCustomRole.data.values.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall",
            as: "div"
        }, formatMessage((0, (0, parcelRequire("9tWQs")).messages).usersNeedAdminRole, {
            userAmount: usersWithoutCustomRole.data.values.length
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnhNB")).default), {
            appearance: "stack",
            data: avatarGroupData
        })));
    };
});
parcelRegister("9tWQs", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$e5af753299688322$export$defe85febe8b728c);
    var $7VHMR;
    const $e5af753299688322$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "eoc-changeboarding.wizard.steps.two.title-no-translate",
            "defaultMessage": "What happens to users and roles"
        },
        description: {
            "id": "eoc-changeboarding.wizard.steps.two.description-no-translate",
            "defaultMessage": "After users and roles are synced, you'll need to assign a product role to Opsgenie users who don't have the same role in Jira Service Management."
        },
        usersNeedAdminRole: {
            "id": "eoc-changeboarding.wizard.steps.two.users-need-admin-role-no-translate",
            "defaultMessage": "{userAmount, plural, one {{userAmount} Opsgenie user} other {{userAmount} Opsgenie users}} won't have the same role in Jira"
        }
    });
});
const $8bd01cb292c29cb9$export$75f90732d1326d15 = 5;
parcelRegister("83g2V", function(module, exports) {
    $parcel$export(module.exports, "Wizard", ()=>$aed802527fc8c816$export$c6a37f46d6629cf2);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $i8Qvm;
    var $9fuVs;
    var $hu9ei;
    var $ab6K3;
    var $78zm0;
    var $6pFzR;
    var $1IRNJ;
    const $aed802527fc8c816$export$c6a37f46d6629cf2 = ({ isOpen: isOpen, onClose: onClose, defaultStep: defaultStep = 1, onUnlock: onUnlock })=>{
        const [currentStep, setCurrentStep] = (0, $5uXOq.useState)(defaultStep);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            height: 700,
            width: 1100,
            onClose: onClose,
            shouldCloseOnOverlayClick: false
        }, currentStep === 1 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("78zm0")).StepOne), {
            onAction: setCurrentStep,
            onClose: onClose
        }), currentStep === 2 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1IRNJ")).StepTwo), {
            onAction: setCurrentStep,
            onClose: onClose
        }), currentStep === 3 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6pFzR")).StepThree), {
            onAction: setCurrentStep,
            onClose: onClose
        }), currentStep === 4 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ab6K3")).StepFour), {
            onAction: setCurrentStep,
            onClose: onClose,
            onUnlock: onUnlock
        }), currentStep === 5 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hu9ei")).StepFive), {
            onClose: onClose,
            isFirstUnlocked: defaultStep !== (0, $8bd01cb292c29cb9$export$75f90732d1326d15)
        }))));
    };
});
parcelRegister("hu9ei", function(module, exports) {
    $parcel$export(module.exports, "StepFive", ()=>$2a7668c353785674$export$782dfa47fc019134);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $2rqOp;
    var $koVbs;
    var $8zOmE;
    var $itmJb;
    var $cNd4s;
    var $1Iasm = parcelRequire("1Iasm");
    var $7gPEh = parcelRequire("7gPEh");
    var $fNY8p = parcelRequire("fNY8p");
    var $dL1CG;
    var $585jx;
    var $6BT89;
    var $ez5GD;
    var $6FtII;
    const $2a7668c353785674$export$782dfa47fc019134 = ({ onClose: onClose, isFirstUnlocked: isFirstUnlocked = true })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { openTransitionHomeModal: openTransitionHomeModal, isTransitionHomeLoading: isTransitionHomeLoading, activateTransitionHome: activateTransitionHome } = (0, (0, parcelRequire("6BT89")).useGlobalChangeboarding)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const { update: update } = (0, (0, parcelRequire("ez5GD")).useOgConsolidationUserState)();
        (0, $5uXOq.useEffect)(()=>{
            update({
                isWelcomeModalDisplayed: true
            }).catch(()=>{
                onClose();
            });
        }, [
            update
        ]);
        const primaryActionButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            onClick: ()=>{
                openTransitionHomeModal().then(()=>{
                    activateTransitionHome();
                    onClose();
                });
            },
            appearance: "primary",
            isLoading: isTransitionHomeLoading
        }, formatMessage((0, (0, parcelRequire("585jx")).messages).openShiftingGuideButtonNonFinal));
        const secondaryActionButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: (e, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'closeTransitionWizardInUnlockStep');
                onClose();
                activateTransitionHome();
            },
            appearance: "subtle"
        }, formatMessage((0, (0, parcelRequire("585jx")).messages).remindMeLaterButtonNonFinal));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dL1CG")).Layout), {
            vector: {
                light: isFirstUnlocked ? (0, ($parcel$interopDefault($1Iasm))) : (0, ($parcel$interopDefault($fNY8p))),
                dark: isFirstUnlocked ? (0, ($parcel$interopDefault($1Iasm))) : (0, ($parcel$interopDefault($7gPEh)))
            },
            currentStep: 5,
            actionButtons: {
                primary: primaryActionButton,
                secondary: secondaryActionButton
            },
            onClose: onClose
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6FtII")).Content), {
            isFirstUnlocked: isFirstUnlocked,
            isAdmin: isAdmin || isSiteAdmin
        }));
    };
});
parcelRegister("7gPEh", function(module, exports) {
    module.exports = new URL("step_five_vector_dark_optimal.d2b5a6c3.png", import.meta.url).toString();
});
parcelRegister("fNY8p", function(module, exports) {
    module.exports = new URL("step_five_vector_light_optimal.1d639656.png", import.meta.url).toString();
});
parcelRegister("dL1CG", function(module, exports) {
    $parcel$export(module.exports, "Layout", ()=>$af3a308a6aaf1dd3$export$c84671f46d6a1ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $lLLkM;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $hxoiH;
    var $koVbs;
    var $a0LIU = parcelRequire("a0LIU");
    var $oV99b = parcelRequire("oV99b");
    var $585jx;
    const $af3a308a6aaf1dd3$export$c84671f46d6a1ca = ({ children: children, vector: vector, actionButtons: actionButtons, currentStep: currentStep, onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const theme = (0, (0, parcelRequire("hxoiH")).default)();
        const isDarkMode = theme.colorMode === 'dark';
        const shouldShowStep = currentStep !== 5;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $af3a308a6aaf1dd3$var$contentContainerStyles,
            justifyContent: "space-between"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            xcss: [
                $af3a308a6aaf1dd3$var$halfWidthStyles
            ],
            justifyContent: "space-between"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.100",
            xcss: [
                $af3a308a6aaf1dd3$var$contentStyles
            ]
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: [
                $af3a308a6aaf1dd3$var$actionStyles
            ],
            justifyContent: shouldShowStep ? 'space-between' : 'end',
            alignItems: "center"
        }, shouldShowStep && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $af3a308a6aaf1dd3$var$locatorStyles
        }, formatMessage((0, (0, parcelRequire("585jx")).messages).stepLocatorNonFinal, {
            currentStep: currentStep
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            columnGap: "space.100"
        }, actionButtons.secondary, actionButtons.primary))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: [
                $af3a308a6aaf1dd3$var$halfWidthStyles,
                $af3a308a6aaf1dd3$var$rightColumnStyles,
                isDarkMode ? $af3a308a6aaf1dd3$var$rightColumnDarkStyles : $af3a308a6aaf1dd3$var$rightColumnLightStyles
            ]
        }, vector.component ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center",
            justifyContent: "center",
            xcss: $af3a308a6aaf1dd3$var$vectorComponentProps
        }, vector.component) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            role: "presentation",
            style: {
                backgroundImage: `url(${isDarkMode ? vector?.dark : vector?.light})`
            },
            xcss: $af3a308a6aaf1dd3$var$rightVectorStyles
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $af3a308a6aaf1dd3$var$closeIconStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
                label: ""
            }),
            "aria-label": formatMessage((0, (0, parcelRequire("585jx")).messages).closeButtonNonFinal),
            onClick: onClose
        })));
    };
    const $af3a308a6aaf1dd3$var$contentContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '100%',
        position: 'relative'
    });
    const $af3a308a6aaf1dd3$var$vectorComponentProps = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: '1'
    });
    const $af3a308a6aaf1dd3$var$halfWidthStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '50%',
        flexShrink: 0
    });
    const $af3a308a6aaf1dd3$var$contentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.600',
        padding: 'space.200'
    });
    const $af3a308a6aaf1dd3$var$actionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.200',
        borderStyle: 'solid',
        borderWidth: 'border.width',
        borderColor: 'color.border',
        borderLeft: 'none',
        borderRight: 'none',
        borderBottom: 'none'
    });
    const $af3a308a6aaf1dd3$var$locatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtlest'
    });
    const $af3a308a6aaf1dd3$var$rightColumnStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderTopRightRadius: 'border.radius.100',
        borderBottomRightRadius: 'border.radius.100',
        overflow: 'hidden'
    });
    const $af3a308a6aaf1dd3$var$rightVectorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center'
    });
    const $af3a308a6aaf1dd3$var$rightColumnLightStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundImage: `url(${(0, ($parcel$interopDefault($oV99b)))})`
    });
    const $af3a308a6aaf1dd3$var$rightColumnDarkStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundImage: `url(${(0, ($parcel$interopDefault($a0LIU)))})`
    });
    const $af3a308a6aaf1dd3$var$closeIconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        right: 'space.200',
        top: 'space.200'
    });
});
parcelRegister("585jx", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$21ef1f3f04cb2411$export$defe85febe8b728c);
    var $7VHMR;
    const $21ef1f3f04cb2411$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        stepLocatorNonFinal: {
            "id": "eoc-changeboarding.common.wizard.layout.step-locator-non-final",
            "defaultMessage": "Step {currentStep} of 4"
        },
        nextButtonNonFinal: {
            "id": "eoc-changeboarding.common.wizard.layout.next-button-non-final",
            "defaultMessage": "Next"
        },
        backButtonNonFinal: {
            "id": "eoc-changeboarding.common.wizard.layout.back-button-non-final",
            "defaultMessage": "Back"
        },
        closeButtonNonFinal: {
            "id": "eoc-changeboarding.common.wizard.layout.close-button-non-final",
            "defaultMessage": "Close"
        },
        openShiftingGuideButtonNonFinal: {
            "id": "eoc-changeboarding.common.wizard.layout.open-shifting-guide-button-non-final",
            "defaultMessage": "Open guide"
        },
        remindMeLaterButtonNonFinal: {
            "id": "eoc-changeboarding.common.wizard.layout.remind-me-later-button-non-final",
            "defaultMessage": "Remind me later"
        }
    });
});
parcelRegister("6FtII", function(module, exports) {
    $parcel$export(module.exports, "Content", ()=>$4503e5cddec106db$export$7c6e2c02157bb7d2);
    var $5uXOq = parcelRequire("5uXOq");
    var $e3vlv;
    var $aS5mB;
    var $3vEdM;
    const $4503e5cddec106db$export$7c6e2c02157bb7d2 = ({ isFirstUnlocked: isFirstUnlocked, isAdmin: isAdmin })=>{
        if (isFirstUnlocked) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aS5mB")).UnlockedAdminContent), null);
        if (isAdmin) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e3vlv")).AdminContent), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3vEdM")).UserContent), null);
    };
});
parcelRegister("e3vlv", function(module, exports) {
    $parcel$export(module.exports, "AdminContent", ()=>$605ab7d36fda55e0$export$55d2d5b64bfe8d2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $cwmS5;
    var $34OIV;
    var $8w53e;
    var $fptva;
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $koVbs;
    var $kXTK1;
    var $k9ufy;
    var $czz1v;
    const $605ab7d36fda55e0$export$55d2d5b64bfe8d2d = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ usersWithoutCustomRole: usersWithoutCustomRole, usersWithoutAdminRole: usersWithoutAdminRole }] = (0, (0, parcelRequire("k9ufy")).useUsersAndRolesStore)();
        if (usersWithoutCustomRole.data === null || usersWithoutAdminRole.data === null) throw new Error('[Optimal StepFive Admin Content] should not be rendered if users are still loading');
        const usersWithoutCustomRoleCount = usersWithoutCustomRole.data.count;
        const usersWithoutAdminRoleCount = usersWithoutAdminRole.data.count;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xlarge"
        }, formatMessage((0, (0, parcelRequire("czz1v")).messages).titleNonFinal)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("czz1v")).messages).descriptionNonFinal)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.050"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $605ab7d36fda55e0$var$listTitleWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "small",
            as: "h2"
        }, formatMessage((0, (0, parcelRequire("czz1v")).messages).listTitleNonFinal))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("8w53e"))))),
                appearance: "magenta",
                label: ""
            }),
            description: formatMessage((0, (0, parcelRequire("czz1v")).messages).configureChatIntegrationsNonFinal)
        }), usersWithoutAdminRoleCount > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("34OIV"))))),
                appearance: "purple",
                label: ""
            }),
            description: formatMessage((0, (0, parcelRequire("czz1v")).messages).giveProductAdminRoleNonFinal, {
                adminCount: usersWithoutAdminRoleCount
            })
        }), usersWithoutCustomRoleCount > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("fptva"))))),
                appearance: "orange",
                label: ""
            }),
            description: formatMessage((0, (0, parcelRequire("czz1v")).messages).giveProductRoleNonFinal, {
                userCount: usersWithoutCustomRoleCount
            })
        })));
    };
    const $605ab7d36fda55e0$var$listTitleWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.100',
        paddingBottom: 'space.100'
    });
});
parcelRegister("34OIV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $23d917767cf5e6f4$var$_react = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $23d917767cf5e6f4$var$_UNSAFE_baseNew = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $23d917767cf5e6f4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $23d917767cf5e6f4$var$CheckCircleIcon = (props)=>$23d917767cf5e6f4$var$_react.default.createElement($23d917767cf5e6f4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
        }, props));
    $23d917767cf5e6f4$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
    var $23d917767cf5e6f4$var$_default = module.exports.default = $23d917767cf5e6f4$var$CheckCircleIcon;
});
parcelRegister("kXTK1", function(module, exports) {
    $parcel$export(module.exports, "WizardInfoItem", ()=>$36e52a72d183ce67$export$b32afacf54b9b55f);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $kgoHi;
    var $cgL5K;
    var $8CUq3;
    const $36e52a72d183ce67$export$b32afacf54b9b55f = ({ iconTile: iconTile, title: title, description: description })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            columnGap: "space.100",
            alignItems: "start",
            xcss: $36e52a72d183ce67$var$containerStyles
        }, iconTile, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            rowGap: "space.025",
            direction: "column",
            xcss: $36e52a72d183ce67$var$contentWrapperStyles
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            as: "h2",
            size: "xsmall"
        }, title), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, description)));
    const $36e52a72d183ce67$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.050',
        paddingBottom: 'space.050'
    });
    const $36e52a72d183ce67$var$contentWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        alignSelf: 'center'
    });
});
parcelRegister("czz1v", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$6a84daa5ab021a46$export$defe85febe8b728c);
    var $7VHMR;
    const $6a84daa5ab021a46$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        titleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.title-non-final",
            "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
        },
        descriptionNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.description-non-final",
            "defaultMessage": "Almost all of your Opsgenie data and settings are now in Jira Service Management, so you no longer need Opsgenie to do your alerting and on-call work."
        },
        listTitleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.list-title-non-final",
            "defaultMessage": "Let's go set up a few things so your team can get started"
        },
        configureChatIntegrationsNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.configure-chat-integrations-non-final",
            "defaultMessage": "Configure chat integrations in Jira Service Management"
        },
        giveProductAdminRoleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.give-product-admin-role-non-final",
            "defaultMessage": "Give the product admin role to {adminCount, plural, one {# Opsgenie admin} other {# Opsgenie admins}}"
        },
        giveProductRoleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.give-product-role-non-final",
            "defaultMessage": "Give a product role to {userCount, plural, one {# Opsgenie user} other {# Opsgenie users}} who no longer have a custom role"
        }
    });
});
parcelRegister("aS5mB", function(module, exports) {
    $parcel$export(module.exports, "UnlockedAdminContent", ()=>$f6886b7af300ac7d$export$be18a8bc961d2bba);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $kgoHi;
    var $luBm6;
    var $cgL5K;
    var $koVbs;
    var $g8zzh;
    const $f6886b7af300ac7d$export$be18a8bc961d2bba = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            rowGap: "space.200",
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xlarge"
        }, formatMessage((0, (0, parcelRequire("g8zzh")).messages).titleNonFinal)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("g8zzh")).messages).description1NonFinal)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("g8zzh")).messages).description2NonFinal))));
    };
});
parcelRegister("g8zzh", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$4f21a978cb9bea92$export$defe85febe8b728c);
    var $7VHMR;
    const $4f21a978cb9bea92$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        titleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.five.content.first-unlocked-admin.title-non-final",
            "defaultMessage": "We're now moving you to Jira Service Management"
        },
        description1NonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.five.content.first-unlocked-admin.description-1-non-final",
            "defaultMessage": "Almost all of your Opsgenie data and settings are now in Jira Service Management."
        },
        description2NonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.five.content.first-unlocked-admin.description-2-non-final",
            "defaultMessage": "Let's go finish setting up some critical configurations, so your teams can start using operations in Jira Service Management."
        }
    });
});
parcelRegister("3vEdM", function(module, exports) {
    $parcel$export(module.exports, "UserContent", ()=>$bda13e9ad9e1420b$export$ef2ce2deea0ab0c1);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $cwmS5;
    var $h9rhI;
    var $jDorM;
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $koVbs;
    var $kXTK1;
    var $hgqTw;
    const $bda13e9ad9e1420b$export$ef2ce2deea0ab0c1 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xlarge"
        }, formatMessage((0, (0, parcelRequire("hgqTw")).messages).titleNonFinal)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("hgqTw")).messages).descriptionNonFinal)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.050"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $bda13e9ad9e1420b$var$listTitleWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "small",
            as: "h2"
        }, formatMessage((0, (0, parcelRequire("hgqTw")).messages).listTitleNonFinal))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("jDorM"))))),
                appearance: "magenta",
                label: ""
            }),
            description: formatMessage((0, (0, parcelRequire("hgqTw")).messages).configureNotificationSettingsNonFinal)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("h9rhI"))))),
                appearance: "purple",
                label: ""
            }),
            description: formatMessage((0, (0, parcelRequire("hgqTw")).messages).learnHowToWorkNonFinal)
        })));
    };
    const $bda13e9ad9e1420b$var$listTitleWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.100',
        paddingBottom: 'space.100'
    });
});
parcelRegister("h9rhI", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c7c8712306b53637$var$_react = $c7c8712306b53637$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7c8712306b53637$var$_UNSAFE_baseNew = $c7c8712306b53637$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c7c8712306b53637$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c7c8712306b53637$var$BookWithBookmarkIcon = (props)=>$c7c8712306b53637$var$_react.default.createElement($c7c8712306b53637$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 11.625c0 1.174.951 2.125 2.125 2.125H5.5m-2.75-2.125c0-1.174.951-2.125 2.125-2.125H12.5m-9.75 2.125v-8.75C2.75 1.701 3.701.75 4.875.75h8.375V9.5h-.75m1.5 4.25h-1.5m-2 0h2m0-4.25v4.25"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
        }, props));
    $c7c8712306b53637$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
    var $c7c8712306b53637$var$_default = module.exports.default = $c7c8712306b53637$var$BookWithBookmarkIcon;
});
parcelRegister("hgqTw", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$f396ccaba1d3f1dd$export$defe85febe8b728c);
    var $7VHMR;
    const $f396ccaba1d3f1dd$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        titleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.title-non-final",
            "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
        },
        descriptionNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.description-non-final",
            "defaultMessage": "Almost all of your Opsgenie data and settings are now in Jira Service Management, so you no longer need Opsgenie to do your alerting and on-call work."
        },
        listTitleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.list-title-non-final",
            "defaultMessage": "Let's go set up a few things so you can get started"
        },
        configureNotificationSettingsNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.configure-notification-settings-non-final",
            "defaultMessage": "Configure your notifications settings in Jira"
        },
        learnHowToWorkNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.learn-how-to-work-non-final",
            "defaultMessage": "Learn how operations works on Jira Service Management"
        }
    });
});
parcelRegister("ab6K3", function(module, exports) {
    $parcel$export(module.exports, "StepFour", ()=>$f7f00560076aee1c$export$b88edf692723a2ee);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMcV;
    var $k7m40;
    var $fVnbM;
    var $2rqOp;
    var $1dJ6S;
    var $cwmS5;
    var $h9rhI;
    var $8w53e;
    var $9x5pH;
    var $9fIhE;
    var $c781K;
    var $e4yMr;
    var $kgoHi;
    var $luBm6;
    var $cgL5K;
    var $koVbs;
    var $ieJ0b;
    var $2YP9W;
    var $cEXCj = parcelRequire("cEXCj");
    var $bLrRh = parcelRequire("bLrRh");
    var $kXTK1;
    var $dL1CG;
    var $585jx;
    var $6BT89;
    var $k763U;
    var $bkDpW;
    const $f7f00560076aee1c$export$b88edf692723a2ee = ({ onAction: onAction, onClose: onClose, onUnlock: onUnlock })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: transitioningData } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("ieJ0b")).transitioningDetailsResource));
        const { timeZone: timeZone } = (0, (0, parcelRequire("k763U")).useUserTimezone)();
        const { activateWelcomeModal: activateWelcomeModal } = (0, (0, parcelRequire("6BT89")).useGlobalChangeboarding)();
        if (!transitioningData) throw new Error('[Optimal StepFour] component should not be rendered before details resource fetched');
        const [isUnlocking, setIsUnlocking] = (0, $5uXOq.useState)(false);
        const handleNext = ()=>{
            activateWelcomeModal();
            setIsUnlocking(true);
            onUnlock?.().then(()=>{
                onAction((prevState)=>prevState + 1);
            }).finally(()=>{
                setIsUnlocking(false);
            });
        };
        const primaryActionButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            onClick: handleNext,
            appearance: "primary",
            isLoading: isUnlocking
        }, formatMessage((0, (0, parcelRequire("bkDpW")).messages).primaryButtonTextNonFinal));
        const secondaryActionButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: ()=>onAction((prevState)=>prevState - 1),
            appearance: "default"
        }, formatMessage((0, (0, parcelRequire("585jx")).messages).backButtonNonFinal));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dL1CG")).Layout), {
            vector: {
                light: (0, ($parcel$interopDefault($bLrRh))),
                dark: (0, ($parcel$interopDefault($cEXCj)))
            },
            currentStep: 4,
            actionButtons: {
                primary: primaryActionButton,
                secondary: secondaryActionButton
            },
            onClose: onClose
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            rowGap: "space.100",
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "large"
        }, formatMessage((0, (0, parcelRequire("bkDpW")).messages).titleNonFinal)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("bkDpW")).messages).descriptionNonFinal))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("8w53e"))))),
                appearance: "magenta",
                label: ""
            }),
            description: formatMessage((0, (0, parcelRequire("bkDpW")).messages).firstItemNonFinal)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("h9rhI"))))),
                appearance: "purple",
                label: ""
            }),
            description: formatMessage((0, (0, parcelRequire("bkDpW")).messages).secondItemNonFinal)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("9fIhE"))))),
                appearance: "teal",
                label: ""
            }),
            description: formatMessage((0, (0, parcelRequire("bkDpW")).messages).thirdItemNonFinal, {
                unlockDate: (0, (0, parcelRequire("k7m40")).default)((0, (0, parcelRequire("7CMcV")).default)(transitioningData?.autoOgTurnOffDate, timeZone), 'dd MMMM, yyyy')
            })
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("9x5pH"))))),
                appearance: "blue",
                label: ""
            }),
            description: formatMessage((0, (0, parcelRequire("bkDpW")).messages).fourthItemNonFinal, {
                link: (str)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                        href: "https://support.atlassian.com/security-and-access-policies/docs/understand-data-residency/",
                        target: "_blank"
                    }, str)
            })
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("c781K"))))),
                appearance: "orange",
                label: ""
            }),
            description: formatMessage((0, (0, parcelRequire("bkDpW")).messages).fifthItemNonFinal)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("bkDpW")).messages).dontReadyYetNonFinal, {
            link: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                href: "https://support.atlassian.com/jira-service-management-cloud/docs/start-shifting-from-opsgenie-to-jira-service-management/",
                target: "_blank"
            }, formatMessage((0, (0, parcelRequire("bkDpW")).messages).learnMoreNonFinal))
        }))));
    };
});
parcelRegister("bkDpW", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$5965c2011d9fb0df$export$defe85febe8b728c);
    var $7VHMR;
    const $5965c2011d9fb0df$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        titleNonFinal: {
            "id": "eoc-changeboarding.optimal.wizard.steps.four.title-no-translate",
            "defaultMessage": "Ready to move from Opsgenie?"
        },
        descriptionNonFinal: {
            "id": "eoc-changeboarding.optimal.wizard.steps.four.description-no-translate",
            "defaultMessage": "Here's a summary of what happens once you move:"
        },
        firstItemNonFinal: {
            "id": "eoc-changeboarding.optimal.wizard.steps.four.first-item-no-translate",
            "defaultMessage": "Your Opsgenie data and settings will be copied to Jira Service Management, without any changes"
        },
        secondItemNonFinal: {
            "id": "eoc-changeboarding.optimal.wizard.steps.four.second-item-no-translate",
            "defaultMessage": "You'll get a guide to finish setting up configurations that need your involvement"
        },
        thirdItemNonFinal: {
            "id": "eoc-changeboarding.optimal.wizard.steps.four.third-item-no-translate",
            "defaultMessage": "Your Opsgenie site will continue to be accessible, until it's turned off on {unlockDate}"
        },
        fourthItemNonFinal: {
            "id": "eoc-changeboarding.optimal.wizard.steps.four.fourth-item-no-translate",
            "defaultMessage": "Some of your data, including teams and team members, might change residency location from your selected server in Opsgenie. <link>Read more about data residency</link>"
        },
        fifthItemNonFinal: {
            "id": "eoc-changeboarding.optimal.wizard.steps.four.fifth-item-no-translate",
            "defaultMessage": "Inform your organization admin about this change as after the move, your teams and team members will become visible across all sites within your Atlassian account."
        },
        learnMoreNonFinal: {
            "id": "eoc-changeboarding.optimal.wizard.steps.four.learn-more-no-translate",
            "defaultMessage": "Read more about moving from Opsgenie"
        },
        dontReadyYetNonFinal: {
            "id": "eoc-changeboarding.optimal.wizard.steps.four.dont-ready-yet-no-translate",
            "defaultMessage": "Don't feel ready yet? {link}"
        },
        primaryButtonTextNonFinal: {
            "id": "eoc-changeboarding.optimal.wizard.steps.four.primary-button-text-no-translate",
            "defaultMessage": "Let's start moving"
        }
    });
});
parcelRegister("78zm0", function(module, exports) {
    $parcel$export(module.exports, "StepOne", ()=>$85e934cdc0a13fc9$export$d644924ea55d67c0);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $1dJ6S;
    var $cwmS5;
    var $7Xp7u;
    var $fNZB4;
    var $jDorM;
    var $fptva;
    var $epOG5;
    var $kgoHi;
    var $luBm6;
    var $cgL5K;
    var $koVbs;
    var $8r2Ej = parcelRequire("8r2Ej");
    var $7RwOe = parcelRequire("7RwOe");
    var $kXTK1;
    var $dL1CG;
    var $585jx;
    var $5DZDY;
    const $85e934cdc0a13fc9$export$d644924ea55d67c0 = ({ onAction: onAction, onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const primaryActionButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: ()=>onAction((prevState)=>prevState + 1),
            appearance: "primary"
        }, formatMessage((0, (0, parcelRequire("585jx")).messages).nextButtonNonFinal));
        const secondaryActionButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: onClose,
            appearance: "default"
        }, formatMessage((0, (0, parcelRequire("585jx")).messages).closeButtonNonFinal));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dL1CG")).Layout), {
            vector: {
                light: (0, ($parcel$interopDefault($7RwOe))),
                dark: (0, ($parcel$interopDefault($8r2Ej)))
            },
            currentStep: 1,
            actionButtons: {
                primary: primaryActionButton,
                secondary: secondaryActionButton
            },
            onClose: onClose
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            rowGap: "space.100",
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "large"
        }, formatMessage((0, (0, parcelRequire("5DZDY")).messages).titleNonFinal)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("5DZDY")).messages).descriptionNonFinal))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("jDorM"))))),
                appearance: "orange",
                label: ""
            }),
            title: formatMessage((0, (0, parcelRequire("5DZDY")).messages).alertsTitleNonFinal),
            description: formatMessage((0, (0, parcelRequire("5DZDY")).messages).alertsDescriptionNonFinal)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("epOG5"))))),
                appearance: "lime",
                label: ""
            }),
            title: formatMessage((0, (0, parcelRequire("5DZDY")).messages).operationsTitleNonFinal),
            description: formatMessage((0, (0, parcelRequire("5DZDY")).messages).operationsDescriptionNonFinal)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("7Xp7u"))))),
                appearance: "teal",
                label: ""
            }),
            title: formatMessage((0, (0, parcelRequire("5DZDY")).messages).mobileTitleNonFinal),
            description: formatMessage((0, (0, parcelRequire("5DZDY")).messages).mobileDescriptionNonFinal)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("fptva"))))),
                appearance: "blue",
                label: ""
            }),
            title: formatMessage((0, (0, parcelRequire("5DZDY")).messages).teamsTitleNonFinal),
            description: formatMessage((0, (0, parcelRequire("5DZDY")).messages).teamsDescriptionNonFinal)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("fNZB4"))))),
                appearance: "purple",
                label: ""
            }),
            title: formatMessage((0, (0, parcelRequire("5DZDY")).messages).incidentsTitleNonFinal),
            description: formatMessage((0, (0, parcelRequire("5DZDY")).messages).incidentsDescriptionNonFinal)
        }))));
    };
});
parcelRegister("fNZB4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b81b36817ee75239$var$_react = $b81b36817ee75239$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b81b36817ee75239$var$_UNSAFE_baseNew = $b81b36817ee75239$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $b81b36817ee75239$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b81b36817ee75239$var$IncidentIcon = (props)=>$b81b36817ee75239$var$_react.default.createElement($b81b36817ee75239$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 14.25h2m12 0h-2m0 0H3m10 0-1.4-3.5M3 14.25l1.4-3.5m0 0 .1-.25 1.3-3.25m-1.4 3.5h7.2m0 0-.1-.25-1.3-3.25m-4.4 0L5.9 7 8 1.75 10.1 7l.1.25m-4.4 0h4.4"/>`
        }, props));
    $b81b36817ee75239$var$IncidentIcon.displayName = 'IncidentIcon';
    var $b81b36817ee75239$var$_default = module.exports.default = $b81b36817ee75239$var$IncidentIcon;
});
parcelRegister("5DZDY", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$7563954c96425b2b$export$defe85febe8b728c);
    var $7VHMR;
    const $7563954c96425b2b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        titleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.one.title-non-final",
            "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
        },
        descriptionNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.one.description-non-final",
            "defaultMessage": "Make Jira Service Management your team's central place to do all the operations work that they do with Opsgenie."
        },
        alertsTitleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.one.alerts-title-non-final",
            "defaultMessage": "Respond to alerts"
        },
        alertsDescriptionNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.one.alerts-description-non-final",
            "defaultMessage": "Access all your alerts natively from Jira Service Management's Your work page."
        },
        operationsTitleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.one.operations-title-non-final",
            "defaultMessage": "Manage operations"
        },
        operationsDescriptionNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.one.operations-description-non-final",
            "defaultMessage": "Find your integrations, custom roles, maintenance, notifications, policies, audit logs, and more in Jira settings."
        },
        mobileTitleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.one.mobile-title-non-final",
            "defaultMessage": "Get mobile notifications"
        },
        mobileDescriptionNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.one.mobile-description-non-final",
            "defaultMessage": "Stay notified of alerts, check on-call schedules, and manage notification rules on the go with Jira Cloud mobile."
        },
        teamsTitleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.one.teams-title-non-final",
            "defaultMessage": "Build efficient on-call teams"
        },
        teamsDescriptionNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.one.teams-description-non-final",
            "defaultMessage": "Your Opsgenie teams will become Atlassian teams, so you can manage all your teams, including on-call, from Jira."
        },
        incidentsTitleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.one.incidents-title-non-final",
            "defaultMessage": "Streamlined incident management"
        },
        incidentsDescriptionNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.one.incidents-description-non-final",
            "defaultMessage": "Detect and resolve incidents collaboratively in Jira Service Management."
        }
    });
});
parcelRegister("6pFzR", function(module, exports) {
    $parcel$export(module.exports, "StepThree", ()=>$0922918979750f7a$export$98c7d7d0f8104aa7);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $1dJ6S;
    var $cwmS5;
    var $hRf4g;
    var $50qBU;
    var $17Ngn;
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $jhmo0;
    var $gDAJT;
    var $koVbs;
    var $6FZUM;
    var $kXTK1;
    var $dL1CG;
    var $585jx;
    var $lLiTq;
    var $5fIfP;
    var $4PWqB;
    const $0922918979750f7a$export$98c7d7d0f8104aa7 = ({ onAction: onAction, onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const primaryActionButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: ()=>onAction((prevState)=>prevState + 1),
            appearance: "primary"
        }, formatMessage((0, (0, parcelRequire("585jx")).messages).nextButtonNonFinal));
        const secondaryActionButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: ()=>onAction((prevState)=>prevState - 1),
            appearance: "default"
        }, formatMessage((0, (0, parcelRequire("585jx")).messages).backButtonNonFinal));
        const [{ counts: integrationCounts }] = (0, (0, parcelRequire("5fIfP")).useIntegrationCounts)();
        const [{ hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats, heartbeats: heartbeats }] = (0, (0, parcelRequire("lLiTq")).useDeprecatedHeartbeats)();
        const [{ hasDeprecatedNotificationPolicies: hasDeprecatedNotificationPolicies, notificationPolicies: notificationPolicies }] = (0, (0, parcelRequire("lLiTq")).useDeprecatedNotificationPolicies)();
        const [{ hasDeprecatedGroups: hasDeprecatedGroups, groups: groups }] = (0, (0, parcelRequire("lLiTq")).useDeprecatedGroups)();
        const [{ hasDeprecatedIntegration: hasDeprecatedIntegration, deprecatedIntegrations: deprecatedIntegrations }] = (0, (0, parcelRequire("5fIfP")).useDeprecatedIntegrations)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dL1CG")).Layout), {
            vector: {
                light: '',
                dark: '',
                component: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gDAJT")).default), {
                    alt: "",
                    width: 355
                })
            },
            currentStep: 3,
            actionButtons: {
                primary: primaryActionButton,
                secondary: secondaryActionButton
            },
            onClose: onClose
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            rowGap: "space.100",
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "large"
        }, formatMessage((0, (0, parcelRequire("4PWqB")).messages).titleNonFinal)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("4PWqB")).messages).descriptionNonFinal))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, hasDeprecatedIntegration && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("hRf4g"))))),
                appearance: "teal",
                label: ""
            }),
            title: formatMessage((0, (0, parcelRequire("4PWqB")).messages).integrationsInfoTitleNonFinal, {
                count: deprecatedIntegrations.data?.count
            }),
            description: formatMessage((0, (0, parcelRequire("4PWqB")).messages).integrationsInfoDescriptionNonFinal, {
                count: deprecatedIntegrations.data?.count,
                totalCount: integrationCounts.data?.totalCount
            })
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("50qBU"))))),
                appearance: "purple",
                label: ""
            }),
            title: formatMessage((0, (0, parcelRequire("4PWqB")).messages).teamsApiInfoTitleNonFinal),
            description: formatMessage((0, (0, parcelRequire("4PWqB")).messages).teamsApiInfoDescriptionNonFinal)
        })), (hasDeprecatedGroups || hasDeprecatedGlobalHeartbeats || hasDeprecatedNotificationPolicies) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            as: "h3",
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("4PWqB")).messages).moreConfigurationsNonFinal)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.025",
            xcss: $0922918979750f7a$var$configurationItemsWrapperStyles
        }, hasDeprecatedGroups && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6FZUM")).ConfigurationItem), null, formatMessage((0, (0, parcelRequire("4PWqB")).messages).groupNonFinal, {
            count: groups.data?.count
        })), hasDeprecatedGlobalHeartbeats && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6FZUM")).ConfigurationItem), null, formatMessage((0, (0, parcelRequire("4PWqB")).messages).heartbeatsNonFinal, {
            count: heartbeats.data?.globalHeartbeatCount
        })), hasDeprecatedNotificationPolicies && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6FZUM")).ConfigurationItem), null, formatMessage((0, (0, parcelRequire("4PWqB")).messages).notificationPoliciesNonFinal, {
            count: notificationPolicies.data?.count
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            paddingBlockStart: "space.150"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            href: "https://support.atlassian.com/jira-service-management-cloud/docs/start-shifting-from-opsgenie-to-jira-service-management/#What-happens-after-starting-your-shift-from-Opsgenie",
            target: "_blank"
        }, formatMessage((0, (0, parcelRequire("4PWqB")).messages).learnMoreNonFinal), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("17Ngn"))))), {
            label: "",
            size: "small"
        })))));
    };
    const $0922918979750f7a$var$configurationItemsWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.100',
        paddingBottom: 'space.100'
    });
});
parcelRegister("50qBU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3a519821f4edd432$var$_react = $3a519821f4edd432$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3a519821f4edd432$var$_UNSAFE_baseNew = $3a519821f4edd432$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3a519821f4edd432$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3a519821f4edd432$var$UploadIcon = (props)=>$3a519821f4edd432$var$_react.default.createElement($3a519821f4edd432$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 11V2.25m-4 3.5 4-4 4 4"/>`
        }, props));
    $3a519821f4edd432$var$UploadIcon.displayName = 'UploadIcon';
    var $3a519821f4edd432$var$_default = module.exports.default = $3a519821f4edd432$var$UploadIcon;
});
parcelRegister("gDAJT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66f05628fd509e9f$export$2e2bcd8739ae039);
    var $dCLgq;
    var $fMzMk = parcelRequire("fMzMk");
    const $66f05628fd509e9f$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($fMzMk)),
        srcDark: ($parcel$interopDefault($fMzMk))
    });
    var $66f05628fd509e9f$export$2e2bcd8739ae039 = $66f05628fd509e9f$var$Illustration;
    const $66f05628fd509e9f$export$a179c88182cb9d56 = [
        0,
        0,
        235,
        235
    ];
});
parcelRegister("fMzMk", function(module, exports) {
    module.exports = new URL("crystal-ball.30a0dd2d.svg", import.meta.url).toString();
});
parcelRegister("6FZUM", function(module, exports) {
    $parcel$export(module.exports, "ConfigurationItem", ()=>$aa32db96444c9fcc$export$201f11292a316609);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $3RZIb;
    const $aa32db96444c9fcc$export$201f11292a316609 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            columnGap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $aa32db96444c9fcc$var$markerWrapperStyles,
            alignItems: "center",
            justifyContent: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $aa32db96444c9fcc$var$markerStyles
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $aa32db96444c9fcc$var$textStyles,
            as: "span"
        }, children));
    const $aa32db96444c9fcc$var$markerWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: 'size.100',
        height: 'size.100'
    });
    const $aa32db96444c9fcc$var$markerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.accent.gray.bolder',
        borderRadius: '100%',
        width: '7px',
        height: '7px'
    });
    const $aa32db96444c9fcc$var$textStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtlest',
        font: `var(--ds-font-body, ${(0, (0, parcelRequire("3RZIb")).fontFallback).body.medium})`
    });
});
parcelRegister("4PWqB", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$b4e690297ebc4e4b$export$defe85febe8b728c);
    var $7VHMR;
    const $b4e690297ebc4e4b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        titleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.three.title-non-final",
            "defaultMessage": "What you'll leave behind in Opsgenie"
        },
        descriptionNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.three.description-non-final",
            "defaultMessage": "A few legacy Opsgenie features that aren't supported by Jira Service Management will be left behind in Opsgenie. They'll keep working in Opsgenie until Opsgenie is turned off."
        },
        integrationsInfoTitleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.three.integrations-info-title-non-final",
            "defaultMessage": "{count, plural, one {{count} integration} other {{count} integrations}}"
        },
        integrationsInfoDescriptionNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.three.integrations-info-description-non-final",
            "defaultMessage": "{count} of your {totalCount, plural, one {{totalCount} Opsgenie integration} other {{totalCount} Opsgenie integrations}} won't be available in Jira Service Management. They'll still work in Opsgenie."
        },
        teamsApiInfoTitleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.three.teams-api-info-title-non-final",
            "defaultMessage": "Teams API in Opsgenie"
        },
        teamsApiInfoDescriptionNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.three.teams-api-info-description-non-final",
            "defaultMessage": "Opsgenie's API for team management won't work anymore. It will have to be done through the alternative Jira Cloud Platform API."
        },
        moreConfigurationsNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.three.more-configurations-non-final",
            "defaultMessage": "And a few more configurations:"
        },
        groupNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.three.group-non-final",
            "defaultMessage": "{count, plural, one {{count} group} other {{count} groups}}"
        },
        heartbeatsNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.three.heartbeats-non-final",
            "defaultMessage": "{count, plural, one {{count} global heartbeat} other {{count} global heartbeats}}"
        },
        notificationPoliciesNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.three.notification-policies-non-final",
            "defaultMessage": "{count, plural, one {{count} global notification policy} other {{count} global notification policies}}"
        },
        learnMoreNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.three.learn-more-non-final",
            "defaultMessage": "Read more about what you'll leave behind in Opsgenie"
        }
    });
});
parcelRegister("1IRNJ", function(module, exports) {
    $parcel$export(module.exports, "StepTwo", ()=>$29bbda40643646a4$export$f7c6032816713bb9);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $1dJ6S;
    var $cwmS5;
    var $bFmnZ;
    var $fptva;
    var $e4yMr;
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $ousew;
    var $koVbs;
    var $cueoZ = parcelRequire("cueoZ");
    var $ixXAl = parcelRequire("ixXAl");
    var $6FZUM;
    var $kXTK1;
    var $dL1CG;
    var $585jx;
    var $5fIfP;
    var $k9ufy;
    var $fJDtE;
    const $29bbda40643646a4$export$f7c6032816713bb9 = ({ onAction: onAction, onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ usersWithoutCustomRole: usersWithoutCustomRole, usersWithoutAdminRole: usersWithoutAdminRole }] = (0, (0, parcelRequire("k9ufy")).useUsersAndRolesStore)();
        if (usersWithoutCustomRole.data === null || usersWithoutAdminRole.data === null) throw new Error('[Optimal StepTwo] should not be rendered if users are still loading');
        const usersWithoutCustomRoleCount = usersWithoutCustomRole.data.count;
        const usersWithoutAdminRoleCount = usersWithoutAdminRole.data.count;
        const [{ counts: integrationCounts }] = (0, (0, parcelRequire("5fIfP")).useIntegrationCounts)();
        const chatCount = integrationCounts.data?.chatCount || 0;
        const primaryActionButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: ()=>onAction((prevState)=>prevState + 1),
            appearance: "primary"
        }, formatMessage((0, (0, parcelRequire("585jx")).messages).nextButtonNonFinal));
        const secondaryActionButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: ()=>onAction((prevState)=>prevState - 1),
            appearance: "default"
        }, formatMessage((0, (0, parcelRequire("585jx")).messages).backButtonNonFinal));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dL1CG")).Layout), {
            vector: {
                light: (0, ($parcel$interopDefault($ixXAl))),
                dark: (0, ($parcel$interopDefault($cueoZ)))
            },
            currentStep: 2,
            actionButtons: {
                primary: primaryActionButton,
                secondary: secondaryActionButton
            },
            onClose: onClose
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            rowGap: "space.100",
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "large"
        }, formatMessage((0, (0, parcelRequire("fJDtE")).messages).titleNonFinal)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("fJDtE")).messages).descriptionNonFinal))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, (usersWithoutCustomRoleCount > 0 || usersWithoutAdminRoleCount > 0) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("fptva"))))),
                appearance: "teal",
                label: ""
            }),
            title: formatMessage((0, (0, parcelRequire("fJDtE")).messages).usersRoleTitleNonFinal),
            description: formatMessage((0, (0, parcelRequire("fJDtE")).messages).usersRoleDescriptionNonFinal, {
                adminCount: usersWithoutAdminRoleCount,
                userCount: usersWithoutCustomRoleCount
            })
        }), chatCount > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXTK1")).WizardInfoItem), {
            iconTile: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwmS5")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("bFmnZ"))))),
                appearance: "lime",
                label: ""
            }),
            title: formatMessage((0, (0, parcelRequire("fJDtE")).messages).chatIntegrationsTitleNonFinal),
            description: formatMessage((0, (0, parcelRequire("fJDtE")).messages).chatIntegrationsDescriptionNonFinal, {
                chatCount: chatCount
            })
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "xsmall",
            as: "h2"
        }, formatMessage((0, (0, parcelRequire("fJDtE")).messages).configurationsTitleNonFinal)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            rowGap: "space.025",
            xcss: $29bbda40643646a4$var$configurationItemsWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6FZUM")).ConfigurationItem), null, formatMessage((0, (0, parcelRequire("fJDtE")).messages).actionsAndIncidentRulesNonFinal)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6FZUM")).ConfigurationItem), null, formatMessage((0, (0, parcelRequire("fJDtE")).messages).heartbeatsNonFinal)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
            href: "https://support.atlassian.com/jira-service-management-cloud/docs/start-shifting-from-opsgenie-to-jira-service-management",
            target: "_blank"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("fJDtE")).messages).readMoreAboutNonFinal)))));
    };
    const $29bbda40643646a4$var$configurationItemsWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.100',
        paddingBottom: 'space.100'
    });
});
parcelRegister("cueoZ", function(module, exports) {
    module.exports = new URL("step_two_vector_dark_optimal.34c23cb4.png", import.meta.url).toString();
});
parcelRegister("ixXAl", function(module, exports) {
    module.exports = new URL("step_two_vector_light_optimal.959d3c54.png", import.meta.url).toString();
});
parcelRegister("fJDtE", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$d31a72ac957be233$export$defe85febe8b728c);
    var $7VHMR;
    const $d31a72ac957be233$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        titleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.two.title-non-final",
            "defaultMessage": "What you'll need to set up"
        },
        descriptionNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.two.description-non-final",
            "defaultMessage": "Almost all of your Opsgenie settings will be synced with Jira Service Management, only some configurations will need your involvement."
        },
        usersRoleTitleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.two.users-role-title-non-final",
            "defaultMessage": "Verify users' roles"
        },
        usersRoleDescriptionNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.two.users-role-description-non-final",
            "defaultMessage": "{adminCount, plural,\n            =0 {{userCount, plural, =0 {} one {{userCount} Opsgenie user} other {{userCount} Opsgenie users}}}\n             one {{userCount, plural, =0 {{adminCount} Opsgenie admin} one {{adminCount} Opsgenie admin and {userCount} user} other {{adminCount} Opsgenie admin and {userCount} users}}}\n            other {{userCount, plural, =0 {{adminCount} Opsgenie admins} one {{adminCount} Opsgenie admins and {userCount} user} other {{adminCount} Opsgenie admins and {userCount} users}}}\n        } who don't have the same role in Jira Service Management."
        },
        chatIntegrationsTitleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.two.chat-integrations-title-non-final",
            "defaultMessage": "Copy chat integrations"
        },
        chatIntegrationsDescriptionNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.two.chat-integrations-description-non-final",
            "defaultMessage": "Connect your chat tools and copy your {chatCount, plural, one {# Opsgenie chat integration} other {# Opsgenie chat integrations}} to Jira Service Management."
        },
        configurationsTitleNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.two.configurations-title-non-final",
            "defaultMessage": "And a few more configurations:"
        },
        actionsAndIncidentRulesNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.two.actions-and-incident-rules-non-final",
            "defaultMessage": "Actions and incident rules"
        },
        heartbeatsNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.two.heartbeats-non-final",
            "defaultMessage": "Heartbeats"
        },
        readMoreAboutNonFinal: {
            "id": "eoc-changeboarding.wizard.optimal.steps.two.read-more-about-non-final",
            "defaultMessage": "Read more about setting up operations"
        }
    });
});
